import React, { useState, useEffect, useRef, useCallback, useMemo } from 'react';
import { Play, Menu, Info, Plus, Home, Settings, Search, X, MonitorPlay, LogIn, Trash2, Film, Star, ChevronLeft, ChevronRight, ChevronDown, ChevronUp, Database, Loader, Filter, RefreshCcw, User, Moon, Sun, Globe, LogOut, Layers, Video, FolderPlus, ArrowLeft, Users, History, Clock, MoreVertical, CheckCircle, AlertCircle, SlidersHorizontal, Heart, Share2, Edit, Eye, Check, Flame, MessageSquare, Send, ThumbsUp, ArrowDownCircle, SkipForward, RotateCcw, RotateCw, Pause, Maximize, Minimize, Move, Tv, Type, Monitor, Volume2, VolumeX, PictureInPicture, Scaling, FlipHorizontal, Scan, Minimize2, Server, PlusCircle, MinusCircle, Flag, AlertTriangle, FileWarning, ExternalLink, Youtube, Download, Cloud, CloudOff, Sparkles, Bot, MessageCircle , Crown, CreditCard } from 'lucide-react';
import { initializeApp } from 'firebase/app';
import { 
  initializeFirestore, persistentLocalCache, persistentMultipleTabManager, collection, addDoc, onSnapshot, 
  query, deleteDoc, doc, serverTimestamp, updateDoc, increment, arrayUnion, arrayRemove, getDoc, setDoc, orderBy, where, limit, startAfter, getDocs, getAggregateFromServer, average
} from 'firebase/firestore';
import { 
  getAuth, 
  signInAnonymously, 
  signInWithCustomToken, 
  onAuthStateChanged,
  GoogleAuthProvider,
  signInWithPopup,
  signOut
} from 'firebase/auth';
import OneSignal from 'react-onesignal';
import { ScreenOrientation } from '@capacitor/screen-orientation';
import { Filesystem, Directory } from '@capacitor/filesystem';
import { App as CapacitorApp } from '@capacitor/app';
import { StatusBar, Style } from '@capacitor/status-bar';

// --- GEMINI API SETUP ---
// IMPORTANT: Paste your Free Gemini API Key inside the quotes below (এটি ফলব্যাক হিসেবে থাকবে)
const GEMINI_API_KEY = "AIzaSyB-80VJhcGWB4bhBjEI-cfqpAARm3kFOws"; 

// --- FIREBASE SETUP ---
const firebaseConfig = {
  apiKey: "AIzaSyAzXDc_mmZGDfoflM_GJ70eYpjPNgwJ-30",
  authDomain: "miniflix-app-35914.firebaseapp.com",
  projectId: "miniflix-app-35914",
  storageBucket: "miniflix-app-35914.firebasestorage.app",
  messagingSenderId: "681072226268",
  appId: "1:681072226268:web:3ab06518a454506e82a919"
};

const app = initializeApp(firebaseConfig);
const auth = getAuth(app);
const db = initializeFirestore(app, {
    localCache: persistentLocalCache({tabManager: persistentMultipleTabManager()})
});
const appId = 'miniflix-main';



// --- TRANSLATIONS (All 11 Languages) ---
const translations = {
  en: {
    admin: "Admin", searchPlaceholder: "Search...", settings: "Settings", history: "History", watchlist: "My List",
    clearHistory: "Clear All", removeFromHistory: "Remove", historyCleared: "History Cleared", noHistory: "No watch history yet.",
    noWatchlist: "Your list is empty.", theme: "THEME", language: "LANGUAGE", account: "ACCOUNT", guestUser: "Guest User",
    loginGoogle: "Login with Google", logout: "Logout", featured: "FEATURED", playNow: "Play Now", details: "Details",
    trending: "Trending Now", continueWatching: "Continue Watching", reviews: "Reviews & Ratings", writeReview: "Write a review (optional)...",
    submit: "Submit", noReviews: "No reviews yet. Be the first!", library: "All Library", searchResults: "Search Results",
    noContent: "No content found.", loadDemo: "Load Demo Data", playingOn: "Playing on", addToWatchlist: "My List",
    removeFromWatchlist: "In List", share: "Share", relatedMovies: "You May Also Like", noDescription: "No description available.",
    uploadNew: "Upload New Content", editContent: "Edit Content", title: "Title", description: "Description",
    category: "Category", audioLanguage: "Language", releaseYear: "Year", genre: "Genre", posterUrl: "Poster URL",
    videoLink: "Video Link", addServer: "Add Server", removeServer: "Remove", serverName: "Server Name (e.g. 720p, Drive)",
    showSlider: "Show in Slider?", showTrending: "Add to Trending?", upload: "Upload",
    update: "Update", createSeries: "Create Series Profile", existingContent: "Manage Content", resetData: "Reset All Data",
    back: "Back", adminLogin: "Admin Login", enter: "ENTER", cancel: "Cancel", dark: "Dark", light: "Light",
    catAll: "All", catMovie: "Movie", catWebSeries: "Web Series", catAnime: "Anime", catTvShow: "TV Show",
    catAnimation: "Animation", episodes: "Episodes", season: "Season", episode: "Episode", addEpisode: "Add Episode",
    manageEpisodes: "Manage Episodes", manageReviews: "Manage Reviews", totalVideos: "Total Videos", topCast: "Top Casts",
    actorName: "Actor Name", actorImage: "Actor Image URL", addCast: "Add Cast", castList: "Cast List", castAdded: "added",
    filter: "Filter", country: "Country", industry: "Industry", any: "Any", views: "Views", imdbRating: "IMDb Rating",
    userRating: "User Rating", reviewError: "Please add a rating or a comment!", loadingMore: "Loading more...",
    loadMoreBtn: "Load More", showing: "Showing", of: "of", autoPlay: "Auto Play", nextEp: "Next Ep",
    rewind: "-10s", forward: "+10s", skipIntro: "Skip Intro (+85s)", zoom: "Zoom", flip: "Flip", speed: "Speed",
    normal: "Normal", aspectRatio: "Aspect Ratio", subtitle: "Subtitle", default: "Default", on: "On", off: "Off",
    quality: "Quality", fullscreen: "Fullscreen", pip: "Mini Player", zoomed: "Zoomed", flipped: "Flipped",
    servers: "Servers", reportIssue: "Report Issue", reportSent: "Report Sent!", describeIssue: "Describe the problem (e.g. link broken):",
    viewReports: "View Reports", noReports: "No reports found.", delete: "Delete", reports: "Reports",
    watchTrailer: "Watch Trailer", trailerUrl: "Trailer URL (Optional)", installApp: "Install App", animeInd: "Anime",
    notLoggedIn: "Not logged in", loggedInAs: "Logged in as", syncOn: "History syncing to cloud", syncOff: "Login to save history permanently",
    firstEp: "First Episode (S1 E1)", epTitle: "Episode Title", getApp: "Get the App", appDesc: "Install for better experience",
    download: "Download", downloadUrl: "Download URL (Optional)",
    askAi: "Ask AI", aiAssistant: "ZiniPlay AI", aiPlaceholder: "Ask for a movie recommendation...", aiDisclaimer: "Powered by Gemini",
    aiWelcome: "Hello! I am your movie assistant. Ask me for recommendations or details about any movie in our library.",
    dailyLimit: "Today's Question Limit",
    aiErrorLimit: "Global limit reached, please try again tomorrow.",
    aiErrorGeneric: "Something went wrong. Please try again."
  },
  bn: {
    admin: "অ্যাডমিন", searchPlaceholder: "খুঁজুন...", settings: "সেটিংস", history: "হিস্ট্রি", watchlist: "মাই লিস্ট",
    clearHistory: "সব মুছুন", removeFromHistory: "সরান", historyCleared: "হিস্ট্রি মুছে ফেলা হয়েছে", noHistory: "কোনো হিস্ট্রি নেই।",
    noWatchlist: "লিস্ট খালি।", theme: "থিম", language: "ভাষা", account: "অ্যাকাউন্ট", guestUser: "অতিথি ব্যবহারকারী",
    loginGoogle: "গুগল দিয়ে লগিন", logout: "লগআউট", featured: "ফিচারড", playNow: "প্লে করুন", details: "বিস্তারিত",
    trending: "ট্রেন্ডিং নাও", continueWatching: "কন্টিনিউ ওয়াচিং", reviews: "রিভিউ এবং রেটিং", writeReview: "আপনার মতামত (অপশনাল)...",
    submit: "সাবমিট", noReviews: "কোনো রিভিউ নেই। আপনিই প্রথম দিন!", library: "সব লাইব্রেরি", searchResults: "সার্চ রেজাল্ট",
    noContent: "কোন কন্টেন্ট পাওয়া যায়নি।", loadDemo: "ডেমো লোড করুন", playingOn: "প্লে হচ্ছে", addToWatchlist: "মাই লিস্ট",
    removeFromWatchlist: "লিস্টে আছে", share: "শেয়ার", relatedMovies: "আরও দেখুন", noDescription: "কোন বিবরণ নেই।",
    uploadNew: "নতুন কন্টেন্ট আপলোড", editContent: "কন্টেন্ট এডিট করুন", title: "শিরোনাম", description: "বিবরণ",
    category: "ক্যাটাগরি", audioLanguage: "ভাষা", releaseYear: "বছর", genre: "ধরণ", posterUrl: "পোস্টার লিঙ্ক",
    videoLink: "ভিডিও লিঙ্ক", addServer: "সার্ভার যোগ করুন", removeServer: "সরান", serverName: "সার্ভারের নাম (যেমন: 720p, Drive)",
    showSlider: "স্লাইডারে দেখাবেন?", showTrending: "ট্রেন্ডিং-এ দেখাবেন?", upload: "আপলোড করুন",
    update: "আপডেট করুন", createSeries: "সিরিজ প্রোফাইল তৈরি করুন", existingContent: "কন্টেন্ট ম্যানেজ করুন",
    resetData: "সব রিসেট করুন", back: "ফিরে যান", adminLogin: "অ্যাডমিন লগিন", enter: "প্রবেশ", cancel: "বাতিল",
    dark: "ডার্ক", light: "লাইট", catAll: "সব", catMovie: "মুভি", catWebSeries: "ওয়েব সিরিজ", catAnime: "অ্যানিমে",
    catTvShow: "টিভি শো", catAnimation: "অ্যানিমেশন", episodes: "এপিসোড", season: "সিজন", episode: "পর্ব",
    addEpisode: "এপিসোড যোগ করুন", manageEpisodes: "এপিসোড ম্যানেজ", manageReviews: "রিভিউ ম্যানেজ", totalVideos: "মোট ভিডিও",
    topCast: "টপ কাস্টস", actorName: "অভিনেতার নাম", actorImage: "ছবির লিঙ্ক", addCast: "কাস্ট যোগ করুন", castList: "কাস্ট তালিকা",
    castAdded: "যোগ হয়েছে", filter: "ফিল্টার", country: "দেশ", industry: "ইন্ডাস্ট্রি", any: "যেকোনো", views: "ভিউ",
    imdbRating: "IMDb রেটিং", userRating: "ইউজার রেটিং", reviewError: "দয়া করে রেটিং বা কমেন্ট দিন!", loadingMore: "আরও লোড হচ্ছে...",
    loadMoreBtn: "আরও লোড করুন", showing: "দেখাচ্ছে", of: "এর মধ্যে", autoPlay: "অটো প্লে", nextEp: "পরবর্তী",
    rewind: "-১০সে", forward: "+১০সে", skipIntro: "স্কিপ ইন্ট্রো", zoom: "জুম", flip: "ফ্লিপ", speed: "স্পিড",
    normal: "নরমাল", aspectRatio: "রেশিও", subtitle: "সাবটাইটেল", default: "ডিফল্ট", on: "অন", off: "অফ",
    quality: "কোয়ালিটি", fullscreen: "ফুলস্ক্রিন", pip: "মিনি প্লেয়ার", zoomed: "জুমড", flipped: "উল্টানো",
    servers: "সার্ভার", reportIssue: "রিপোর্ট করুন", reportSent: "রিপোর্ট পাঠানো হয়েছে!", describeIssue: "সমস্যাটি লিখুন (যেমন: লিঙ্ক কাজ করছে না):",
    viewReports: "রিপোর্ট দেখুন", noReports: "কোনো রিপোর্ট নেই।", delete: "মুছুন", reports: "রিপোর্টসমূহ",
    watchTrailer: "ট্রেইলার দেখুন", trailerUrl: "ট্রেইলার লিঙ্ক (অপশনাল)", installApp: "অ্যাপ ইন্সটল", animeInd: "অ্যানিমে",
    notLoggedIn: "লগিন করা নেই", loggedInAs: "লগিন করা আছে", syncOn: "হিস্ট্রি ক্লাউডে সেভ হচ্ছে", syncOff: "হিস্ট্রি সেভ করতে লগিন করুন",
    firstEp: "প্রথম এপিসোড (S1 E1)", epTitle: "এপিসোড টাইটেল", getApp: "অ্যাপটি নিন", appDesc: "ভালো অভিজ্ঞতার জন্য ইন্সটল করুন",
    download: "ডাউনলোড", downloadUrl: "ডাউনলোড লিঙ্ক (অপশনাল)",
    askAi: "AI কে জিজ্ঞাসা করুন", aiAssistant: "জিনিপ্লে AI", aiPlaceholder: "মুভি সম্পর্কে প্রশ্ন করুন...", aiDisclaimer: "পাওয়ার্ড বাই জেমিনি",
    aiWelcome: "স্বাগতম! আমি জিনিপ্লে অ্যাসিস্ট্যান্ট। মুভি সম্পর্কে যেকোনো তথ্য বা পরামর্শের জন্য আমাকে জিজ্ঞাসা করুন।",
    dailyLimit: "আজকের প্রশ্নের লিমিট",
    aiErrorLimit: "গ্লোবাল লিমিট শেষ হয়ে গেছে, দয়া করে আগামীকাল আবার চেষ্টা করুন।",
    aiErrorGeneric: "কিছু ভুল হয়েছে। দয়া করে আবার চেষ্টা করুন।"
  },
  es: {
    admin: "Administrador", searchPlaceholder: "Buscar...", settings: "Ajustes", history: "Historial", watchlist: "Mi Lista",
    clearHistory: "Borrar todo", removeFromHistory: "Eliminar", historyCleared: "Historial borrado", noHistory: "Sin historial.",
    noWatchlist: "Tu lista está vacía.", theme: "TEMA", language: "IDIOMA", account: "CUENTA", guestUser: "Usuario Invitado",
    loginGoogle: "Entrar con Google", logout: "Cerrar sesión", featured: "DESTACADO", playNow: "Reproducir", details: "Detalles",
    trending: "Tendencias", continueWatching: "Seguir viendo", reviews: "Reseñas", writeReview: "Escribe una reseña...",
    submit: "Enviar", noReviews: "Sin reseñas.", library: "Biblioteca", searchResults: "Resultados",
    noContent: "Sin contenido.", loadDemo: "Cargar Demo", playingOn: "Reproduciendo en", addToWatchlist: "Mi Lista",
    removeFromWatchlist: "En Lista", share: "Compartir", relatedMovies: "También te puede gustar", noDescription: "Sin descripción.",
    uploadNew: "Subir Contenido", editContent: "Editar", title: "Título", description: "Descripción",
    category: "Categoría", audioLanguage: "Idioma", releaseYear: "Año", genre: "Género", posterUrl: "URL del Póster",
    videoLink: "Enlace de Video", addServer: "Añadir Servidor", removeServer: "Quitar", serverName: "Nombre del Servidor",
    showSlider: "¿Mostrar en Slider?", showTrending: "¿Añadir a Tendencias?", upload: "Subir",
    update: "Actualizar", createSeries: "Crear Serie", existingContent: "Gestionar Contenido", resetData: "Reiniciar Datos",
    back: "Atrás", adminLogin: "Acceso Admin", enter: "ENTRAR", cancel: "Cancelar", dark: "Oscuro", light: "Claro",
    catAll: "Todo", catMovie: "Película", catWebSeries: "Serie Web", catAnime: "Anime", catTvShow: "Programa TV",
    catAnimation: "Animación", episodes: "Episodios", season: "Temporada", episode: "Episodio", addEpisode: "Añadir Episodio",
    manageEpisodes: "Gestionar Episodios", manageReviews: "Gestionar Reseñas", totalVideos: "Videos Totales", topCast: "Reparto Principal",
    actorName: "Nombre Actor", actorImage: "URL Imagen", addCast: "Añadir Reparto", castList: "Lista Reparto", castAdded: "añadido",
    filter: "Filtrar", country: "País", industry: "Industria", any: "Cualquiera", views: "Vistas", imdbRating: "Calif. IMDb",
    userRating: "Calif. Usuario", reviewError: "¡Añade una calificación o comentario!", loadingMore: "Cargando más...",
    loadMoreBtn: "Cargar Más", showing: "Mostrando", of: "de", autoPlay: "Auto Reprod.", nextEp: "Sig. Ep",
    rewind: "-10s", forward: "+10s", skipIntro: "Saltar Intro", zoom: "Zoom", flip: "Voltear", speed: "Velocidad",
    normal: "Normal", aspectRatio: "Relación", subtitle: "Subtítulo", default: "Por defecto", on: "Enc.", off: "Apag.",
    quality: "Calidad", fullscreen: "Pantalla completa", pip: "Mini Reprod.", zoomed: "Zoom", flipped: "Volteado",
    servers: "Servidores", reportIssue: "Reportar Problema", reportSent: "¡Reporte Enviado!", describeIssue: "Describe el problema:",
    viewReports: "Ver Reportes", noReports: "Sin reportes.", delete: "Borrar", reports: "Reportes",
    watchTrailer: "Ver Tráiler", trailerUrl: "URL del Tráiler", installApp: "Instalar App", animeInd: "Anime",
    notLoggedIn: "No conectado", loggedInAs: "Conectado como", syncOn: "Sincronizando historial", syncOff: "Inicia sesión para guardar",
    firstEp: "Primer Episodio", epTitle: "Título Episodio", getApp: "Obtener App", appDesc: "Instalar para mejor experiencia",
    download: "Descargar", downloadUrl: "URL de Descarga",
    askAi: "Preguntar a IA", aiAssistant: "Asistente ZiniPlay", aiPlaceholder: "Pide una recomendación...", aiDisclaimer: "Desarrollado por Gemini",
    aiWelcome: "¡Hola! Soy tu asistente de películas. Pídeme recomendaciones o detalles sobre cualquier película.",
    dailyLimit: "Límite de preguntas de hoy",
    aiErrorLimit: "Se ha alcanzado el límite global, inténtalo de nuevo mañana.",
    aiErrorGeneric: "Algo salió mal. Por favor, inténtalo de nuevo."
  },
  hi: {
    admin: "एडमिन", searchPlaceholder: "खोजें...", settings: "सेटिंग्स", history: "इतिहास", watchlist: "मेरी सूची",
    clearHistory: "सब साफ़ करें", removeFromHistory: "हटाएं", historyCleared: "इतिहास साफ़ किया गया", noHistory: "कोई इतिहास नहीं।",
    noWatchlist: "आपकी सूची खाली है।", theme: "थीम", language: "भाषा", account: "खाता", guestUser: "अतिथि उपयोगकर्ता",
    loginGoogle: "गूगल से लॉगिन करें", logout: "लॉग आउट", featured: "विशेष रुप से प्रदर्शित", playNow: "अभी चलाएं", details: "विवरण",
    trending: "अभी ट्रेंडिंग", continueWatching: "देखना जारी रखें", reviews: "समीक्षाएं", writeReview: "समीक्षा लिखें...",
    submit: "जमा करें", noReviews: "कोई समीक्षा नहीं।", library: "लाइब्रेरी", searchResults: "खोज परिणाम",
    noContent: "कोई सामग्री नहीं मिली।", loadDemo: "डेमो लोड करें", playingOn: "चल रहा है", addToWatchlist: "मेरी सूची",
    removeFromWatchlist: "सूची में है", share: "साझा करें", relatedMovies: "आपको यह भी पसंद आ सकता है", noDescription: "कोई विवरण नहीं।",
    uploadNew: "नई सामग्री अपलोड करें", editContent: "सामग्री संपादित करें", title: "शीर्षक", description: "विवरण",
    category: "श्रेणी", audioLanguage: "भाषा", releaseYear: "वर्ष", genre: "शैली", posterUrl: "पोस्टर URL",
    videoLink: "वीडियो लिंक", addServer: "सर्वर जोड़ें", removeServer: "हटाएं", serverName: "सर्वर का नाम",
    showSlider: "स्लाइडर में दिखाएं?", showTrending: "ट्रेंडिंग में जोड़ें?", upload: "अपलोड",
    update: "अपडेट", createSeries: "सीरीज बनाएं", existingContent: "सामग्री प्रबंधित करें", resetData: "डेटा रीसेट करें",
    back: "वापस", adminLogin: "एडमिन लॉगिन", enter: "प्रवेश", cancel: "रद्द करें", dark: "डार्क", light: "लाइट",
    catAll: "सभी", catMovie: "फ़िल्म", catWebSeries: "वेब सीरीज", catAnime: "एनिमे", catTvShow: "टीवी शो",
    catAnimation: "एनिमेशन", episodes: "एपिसोड", season: "सीजन", episode: "भाग", addEpisode: "एपिसोड जोड़ें",
    manageEpisodes: "एपिसोड प्रबंधित करें", manageReviews: "समीक्षाएं प्रबंधित करें", totalVideos: "कुल वीडियो", topCast: "प्रमुख कलाकार",
    actorName: "अभिनेता का नाम", actorImage: "छवि URL", addCast: "कलाकार जोड़ें", castList: "कलाकार सूची", castAdded: "जोड़ा गया",
    filter: "फ़िल्टर", country: "देश", industry: "उद्योग", any: "कोई भी", views: "दृश्य", imdbRating: "IMDb रेटिंग",
    userRating: "उपयोगकर्ता रेटिंग", reviewError: "कृपया रेटिंग या टिप्पणी जोड़ें!", loadingMore: "और लोड हो रहा है...",
    loadMoreBtn: "और लोड करें", showing: "दिखा रहा है", of: "का", autoPlay: "ऑटो प्ले", nextEp: "अगला भाग",
    rewind: "-10s", forward: "+10s", skipIntro: "इंट्रो छोड़ें", zoom: "ज़ूम", flip: "पलटें", speed: "गति",
    normal: "सामान्य", aspectRatio: "अनुपात", subtitle: "उपशीर्षक", default: "डिफ़ॉल्ट", on: "चालू", off: "बंद",
    quality: "गुणवत्ता", fullscreen: "पूर्ण स्क्रीन", pip: "मिनी प्लेयर", zoomed: "ज़ूम किया", flipped: "पलटा हुआ",
    servers: "सर्वर", reportIssue: "समस्या रिपोर्ट करें", reportSent: "रिपोर्ट भेजी गई!", describeIssue: "समस्या का वर्णन करें:",
    viewReports: "रिपोर्ट देखें", noReports: "कोई रिपोर्ट नहीं।", delete: "हटाएं", reports: "रिपोर्ट",
    watchTrailer: "ट्रेलर देखें", trailerUrl: "ट्रेलर URL", installApp: "ऐप इंस्टॉल करें", animeInd: "एनिमे",
    notLoggedIn: "लॉग इन नहीं", loggedInAs: "लॉग इन हैं", syncOn: "इतिहास सिंक हो रहा है", syncOff: "सहेजने के लिए लॉगिन करें",
    firstEp: "पहला एपिसोड", epTitle: "एपिसोड शीर्षक", getApp: "ऐप प्राप्त करें", appDesc: "बेहतर अनुभव के लिए",
    download: "डाउनलोड", downloadUrl: "डाउनलोड लिंक",
    askAi: "AI से पूछें", aiAssistant: "ZiniPlay AI", aiPlaceholder: "फिल्म सुझाव मांगें...", aiDisclaimer: "Gemini द्वारा संचालित",
    aiWelcome: "नमस्ते! मैं आपका मूवी असिस्टेंट हूँ। मुझसे किसी भी फिल्म के बारे में सुझाव या जानकारी मांगें।",
    dailyLimit: "आज की प्रश्न सीमा",
    aiErrorLimit: "वैश्विक सीमा समाप्त हो गई है, कृपया कल पुनः प्रयास करें।",
    aiErrorGeneric: "कुछ गलत हो गया। कृपया पुन: प्रयास करें।"
  },
  ar: {
    admin: "مسؤول", searchPlaceholder: "بحث...", settings: "الإعدادات", history: "السجل", watchlist: "قائمتي",
    clearHistory: "مسح الكل", removeFromHistory: "إزالة", historyCleared: "تم مسح السجل", noHistory: "لا يوجد سجل مشاهدة.",
    noWatchlist: "قائمتك فارغة.", theme: "السمة", language: "اللغة", account: "الحساب", guestUser: "زائر",
    loginGoogle: "دخول عبر جوجل", logout: "خروج", featured: "متميز", playNow: "شاهد الآن", details: "تفاصيل",
    trending: "شائع الآن", continueWatching: "متابعة المشاهدة", reviews: "التقييمات", writeReview: "اكتب مراجعة...",
    submit: "إرسال", noReviews: "لا توجد مراجعات.", library: "المكتبة", searchResults: "نتائج البحث",
    noContent: "لم يتم العثور على محتوى.", loadDemo: "تحميل تجريبي", playingOn: "يعرض على", addToWatchlist: "قائمتي",
    removeFromWatchlist: "في القائمة", share: "مشاركة", relatedMovies: "قد يعجبك أيضاً", noDescription: "لا يوجد وصف.",
    uploadNew: "رفع محتوى جديد", editContent: "تعديل المحتوى", title: "العنوان", description: "الوصف",
    category: "الفئة", audioLanguage: "اللغة", releaseYear: "السنة", genre: "النوع", posterUrl: "رابط الملصق",
    videoLink: "رابط الفيديو", addServer: "إضافة خادم", removeServer: "إزالة", serverName: "اسم الخادم",
    showSlider: "عرض في الشريط؟", showTrending: "إضافة للشائع؟", upload: "رفع",
    update: "تحديث", createSeries: "إنشاء سلسلة", existingContent: "إدارة المحتوى", resetData: "إعادة تعيين",
    back: "رجوع", adminLogin: "دخول المسؤول", enter: "دخول", cancel: "إلغاء", dark: "داكن", light: "فاتح",
    catAll: "الكل", catMovie: "فيلم", catWebSeries: "مسلسل ويب", catAnime: "أنيمي", catTvShow: "برنامج تلفزيوني",
    catAnimation: "رسوم متحركة", episodes: "الحلقات", season: "الموسم", episode: "الحلقة", addEpisode: "إضافة حلقة",
    manageEpisodes: "إدارة الحلقات", manageReviews: "إدارة المراجعات", totalVideos: "إجمالي الفيديوهات", topCast: "أفضل الممثلين",
    actorName: "اسم الممثل", actorImage: "صورة الممثل", addCast: "إضافة ممثل", castList: "قائمة الممثلين", castAdded: "تمت الإضافة",
    filter: "تصفية", country: "الدولة", industry: "الصناعة", any: "أي", views: "مشاهدات", imdbRating: "تقييم IMDb",
    userRating: "تقييم المستخدم", reviewError: "يرجى إضافة تقييم أو تعليق!", loadingMore: "جار التحميل...",
    loadMoreBtn: "تحميل المزيد", showing: "عرض", of: "من", autoPlay: "تشغيل تلقائي", nextEp: "الحلقة التالية",
    rewind: "-10ث", forward: "+10ث", skipIntro: "تخطي المقدمة", zoom: "تكبير", flip: "قلب", speed: "سرعة",
    normal: "عادي", aspectRatio: "الأبعاد", subtitle: "ترجمة", default: "افتراضي", on: "تشغيل", off: "إيقاف",
    quality: "جودة", fullscreen: "ملء الشاشة", pip: "مشغل مصغر", zoomed: "مكبر", flipped: "مقلوب",
    servers: "الخوادم", reportIssue: "إبلاغ عن مشكلة", reportSent: "تم الإرسال!", describeIssue: "صف المشكلة:",
    viewReports: "عرض البلاغات", noReports: "لا توجد بلاغات.", delete: "حذف", reports: "البلاغات",
    watchTrailer: "شاهد الإعلان", trailerUrl: "رابط الإعلان", installApp: "تثبيت التطبيق", animeInd: "أنيمي",
    notLoggedIn: "غير مسجل للدخول", loggedInAs: "مسجل كـ", syncOn: "المزامن مفعلة", syncOff: "سجل الدخول للحفظ",
    firstEp: "الحلقة الأولى", epTitle: "عنوان الحلقة", getApp: "احصل على التطبيق", appDesc: "لتجربة أفضل",
    download: "تحميل", downloadUrl: "رابط التحميل",
    askAi: "اسأل الذكاء الاصطناعي", aiAssistant: "مساعد ZiniPlay", aiPlaceholder: "اطلب توصية فيلم...", aiDisclaimer: "مدعوم من Gemini",
    aiWelcome: "مرحبًا! أنا مساعد الأفلام الخاص بك. اسألني عن توصيات أو تفاصيل حول أي فيلم.",
    dailyLimit: "حد الأسئلة اليوم",
    aiErrorLimit: "تم الوصول إلى الحد العالمي، يرجى المحاولة مرة أخرى غدًا.",
    aiErrorGeneric: "حدث خطأ ما. حاول مرة اخرى."
  },
  pt: {
    admin: "Admin", searchPlaceholder: "Buscar...", settings: "Configurações", history: "Histórico", watchlist: "Minha Lista",
    clearHistory: "Limpar Tudo", removeFromHistory: "Remover", historyCleared: "Histórico Limpo", noHistory: "Sem histórico.",
    noWatchlist: "Sua lista está vazia.", theme: "TEMA", language: "IDIOMA", account: "CONTA", guestUser: "Visitante",
    loginGoogle: "Entrar com Google", logout: "Sair", featured: "DESTAQUE", playNow: "Assistir", details: "Detalhes",
    trending: "Em Alta", continueWatching: "Continuar Assistindo", reviews: "Avaliações", writeReview: "Escrever avaliação...",
    submit: "Enviar", noReviews: "Sem avaliações.", library: "Biblioteca", searchResults: "Resultados",
    noContent: "Nenhum conteúdo.", loadDemo: "Carregar Demo", playingOn: "Reproduzindo em", addToWatchlist: "Minha Lista",
    removeFromWatchlist: "Na Lista", share: "Compartilhar", relatedMovies: "Você pode gostar", noDescription: "Sem descrição.",
    uploadNew: "Novo Conteúdo", editContent: "Editar Conteúdo", title: "Título", description: "Descrição",
    category: "Categoria", audioLanguage: "Idioma", releaseYear: "Ano", genre: "Gênero", posterUrl: "URL do Pôster",
    videoLink: "Link do Vídeo", addServer: "Adicionar Servidor", removeServer: "Remover", serverName: "Nome do Servidor",
    showSlider: "Mostrar no Slider?", showTrending: "Adicionar ao Trending?", upload: "Enviar",
    update: "Atualizar", createSeries: "Criar Série", existingContent: "Gerenciar", resetData: "Resetar Dados",
    back: "Voltar", adminLogin: "Login Admin", enter: "ENTRAR", cancel: "Cancelar", dark: "Escuro", light: "Claro",
    catAll: "Tudo", catMovie: "Filme", catWebSeries: "Série Web", catAnime: "Anime", catTvShow: "Programa de TV",
    catAnimation: "Animação", episodes: "Episódios", season: "Temporada", episode: "Episódio", addEpisode: "Adicionar Episódio",
    manageEpisodes: "Gerenciar Episódios", manageReviews: "Gerenciar Avaliações", totalVideos: "Total de Vídeos", topCast: "Elenco Principal",
    actorName: "Nome do Ator", actorImage: "URL da Imagem", addCast: "Adicionar Elenco", castList: "Lista de Elenco", castAdded: "adicionado",
    filter: "Filtrar", country: "País", industry: "Indústria", any: "Qualquer", views: "Visualizações", imdbRating: "Avaliação IMDb",
    userRating: "Avaliação do Usuário", reviewError: "Adicione uma avaliação ou comentário!", loadingMore: "Carregando...",
    loadMoreBtn: "Carregar Mais", showing: "Mostrando", of: "de", autoPlay: "Auto Play", nextEp: "Próx. Ep",
    rewind: "-10s", forward: "+10s", skipIntro: "Pular Intro", zoom: "Zoom", flip: "Inverter", speed: "Velocidade",
    normal: "Normal", aspectRatio: "Proporção", subtitle: "Legenda", default: "Padrão", on: "On", off: "Off",
    quality: "Qualidade", fullscreen: "Tela Cheia", pip: "Mini Player", zoomed: "Zoom", flipped: "Invertido",
    servers: "Servidores", reportIssue: "Reportar Problema", reportSent: "Enviado!", describeIssue: "Descreva o problema:",
    viewReports: "Ver Reportes", noReports: "Sem reportes.", delete: "Deletar", reports: "Reportes",
    watchTrailer: "Ver Trailer", trailerUrl: "URL do Trailer", installApp: "Instalar App", animeInd: "Anime",
    notLoggedIn: "Não logado", loggedInAs: "Logado como", syncOn: "Sincronizando", syncOff: "Faça login para salvar",
    firstEp: "Primeiro Episódio", epTitle: "Título do Episódio", getApp: "Baixar App", appDesc: "Instale para melhor experiência",
    download: "Baixar", downloadUrl: "Link de Download",
    askAi: "Perguntar à IA", aiAssistant: "ZiniPlay IA", aiPlaceholder: "Peça uma recomendação...", aiDisclaimer: "Desenvolvido por Gemini",
    aiWelcome: "Olá! Sou seu assistente de filmes. Peça recomendações ou detalhes sobre qualquer filme.",
    dailyLimit: "Limite de perguntas de hoje",
    aiErrorLimit: "Limite global atingido, tente novamente amanhã.",
    aiErrorGeneric: "Algo deu errado. Por favor, tente novamente."
  },
  ru: {
    admin: "Админ", searchPlaceholder: "Поиск...", settings: "Настройки", history: "История", watchlist: "Список",
    clearHistory: "Очистить", removeFromHistory: "Удалить", historyCleared: "История очищена", noHistory: "Нет истории.",
    noWatchlist: "Список пуст.", theme: "ТЕМА", language: "ЯЗЫК", account: "АККАУНТ", guestUser: "Гость",
    loginGoogle: "Войти через Google", logout: "Выйти", featured: "ИЗБРАННОЕ", playNow: "Смотреть", details: "Детали",
    trending: "В тренде", continueWatching: "Продолжить", reviews: "Отзывы", writeReview: "Написать отзыв...",
    submit: "Отправить", noReviews: "Нет отзывов.", library: "Библиотека", searchResults: "Результаты",
    noContent: "Контент не найден.", loadDemo: "Загрузить демо", playingOn: "Воспроизведение", addToWatchlist: "В список",
    removeFromWatchlist: "В списке", share: "Поделиться", relatedMovies: "Похожие", noDescription: "Нет описания.",
    uploadNew: "Загрузить", editContent: "Редактировать", title: "Название", description: "Описание",
    category: "Категория", audioLanguage: "Язык", releaseYear: "Год", genre: "Жанр", posterUrl: "URL Постера",
    videoLink: "Ссылка на видео", addServer: "Добавить сервер", removeServer: "Удалить", serverName: "Имя сервера",
    showSlider: "В слайдер?", showTrending: "В тренды?", upload: "Загрузить",
    update: "Обновить", createSeries: "Создать сериал", existingContent: "Управление", resetData: "Сброс данных",
    back: "Назад", adminLogin: "Вход Админа", enter: "ВВОД", cancel: "Отмена", dark: "Темная", light: "Светлая",
    catAll: "Все", catMovie: "Фильм", catWebSeries: "Веб-сериал", catAnime: "Аниме", catTvShow: "ТВ Шоу",
    catAnimation: "Анимация", episodes: "Эпизоды", season: "Сезон", episode: "Эпизод", addEpisode: "Добавить эпизод",
    manageEpisodes: "Управление эпизодами", manageReviews: "Управление отзывами", totalVideos: "Всего видео", topCast: "Актеры",
    actorName: "Имя актера", actorImage: "Фото актера", addCast: "Добавить актера", castList: "Список актеров", castAdded: "добавлено",
    filter: "Фильтр", country: "Страна", industry: "Индустрия", any: "Любой", views: "Просмотры", imdbRating: "Рейтинг IMDb",
    userRating: "Рейтинг", reviewError: "Добавьте оценку или комментарий!", loadingMore: "Загрузка...",
    loadMoreBtn: "Загрузить еще", showing: "Показано", of: "из", autoPlay: "Авто", nextEp: "След. Эп.",
    rewind: "-10с", forward: "+10с", skipIntro: "Пропустить", zoom: "Зум", flip: "Поворот", speed: "Скорость",
    normal: "Норм", aspectRatio: "Формат", subtitle: "Субтитры", default: "По умолч.", on: "Вкл", off: "Выкл",
    quality: "Качество", fullscreen: "На весь экран", pip: "Мини-плеер", zoomed: "Зум", flipped: "Повернуто",
    servers: "Серверы", reportIssue: "Сообщить", reportSent: "Отправлено!", describeIssue: "Опишите проблему:",
    viewReports: "Отчеты", noReports: "Нет отчетов.", delete: "Удалить", reports: "Отчеты",
    watchTrailer: "Трейлер", trailerUrl: "URL трейлера", installApp: "Установить", animeInd: "Аниме",
    notLoggedIn: "Не вошли", loggedInAs: "Вы вошли как", syncOn: "Синхронизация вкл", syncOff: "Войдите для сохр.",
    firstEp: "Первый эпизод", epTitle: "Название эпизода", getApp: "Скачать", appDesc: "Установите приложение",
    download: "Скачать", downloadUrl: "Ссылка на скачивание",
    askAi: "Спросить ИИ", aiAssistant: "ZiniPlay AI", aiPlaceholder: "Попросите рекомендацию...", aiDisclaimer: "На базе Gemini",
    aiWelcome: "Привет! Я ваш помощник по фильмам. Спрашивайте рекомендации или детали о любом фильме.",
    dailyLimit: "Лимит вопросов на сегодня",
    aiErrorLimit: "Достигнут глобальный лимит, попробуйте завтра.",
    aiErrorGeneric: "Что-то пошло не так. Пожалуйста, попробуйте еще раз."
  },
  ja: {
    admin: "管理者", searchPlaceholder: "検索...", settings: "設定", history: "履歴", watchlist: "マイリスト",
    clearHistory: "全削除", removeFromHistory: "削除", historyCleared: "履歴を削除しました", noHistory: "履歴がありません。",
    noWatchlist: "リストは空です。", theme: "テーマ", language: "言語", account: "アカウント", guestUser: "ゲスト",
    loginGoogle: "Googleでログイン", logout: "ログアウト", featured: "おすすめ", playNow: "再生", details: "詳細",
    trending: "トレンド", continueWatching: "続きを見る", reviews: "レビュー", writeReview: "レビューを書く...",
    submit: "送信", noReviews: "レビューはありません。", library: "ライブラリ", searchResults: "検索結果",
    noContent: "コンテンツが見つかりません。", loadDemo: "デモをロード", playingOn: "再生中", addToWatchlist: "マイリスト",
    removeFromWatchlist: "リスト済み", share: "共有", relatedMovies: "おすすめ", noDescription: "説明はありません。",
    uploadNew: "新規アップロード", editContent: "編集", title: "タイトル", description: "説明",
    category: "カテゴリ", audioLanguage: "言語", releaseYear: "年", genre: "ジャンル", posterUrl: "ポスターURL",
    videoLink: "動画リンク", addServer: "サーバー追加", removeServer: "削除", serverName: "サーバー名",
    showSlider: "スライダーに表示？", showTrending: "トレンドに追加？", upload: "アップロード",
    update: "更新", createSeries: "シリーズ作成", existingContent: "管理", resetData: "リセット",
    back: "戻る", adminLogin: "管理者ログイン", enter: "決定", cancel: "キャンセル", dark: "ダーク", light: "ライト",
    catAll: "すべて", catMovie: "映画", catWebSeries: "Webシリーズ", catAnime: "アニメ", catTvShow: "TV番組",
    catAnimation: "アニメーション", episodes: "エピソード", season: "シーズン", episode: "話", addEpisode: "エピソード追加",
    manageEpisodes: "エピソード管理", manageReviews: "レビュー管理", totalVideos: "総動画数", topCast: "キャスト",
    actorName: "俳優名", actorImage: "画像URL", addCast: "キャスト追加", castList: "キャスト一覧", castAdded: "追加済み",
    filter: "フィルタ", country: "国", industry: "業界", any: "すべて", views: "再生数", imdbRating: "IMDb評価",
    userRating: "ユーザー評価", reviewError: "評価またはコメントを入力してください！", loadingMore: "読み込み中...",
    loadMoreBtn: "もっと見る", showing: "表示中", of: "/", autoPlay: "自動再生", nextEp: "次へ",
    rewind: "-10秒", forward: "+10秒", skipIntro: "スキップ", zoom: "ズーム", flip: "反転", speed: "速度",
    normal: "標準", aspectRatio: "比率", subtitle: "字幕", default: "デフォルト", on: "オン", off: "オフ",
    quality: "画質", fullscreen: "全画面", pip: "ミニプレーヤー", zoomed: "拡大", flipped: "反転",
    servers: "サーバー", reportIssue: "問題を報告", reportSent: "送信しました！", describeIssue: "問題を記述:",
    viewReports: "報告を見る", noReports: "報告はありません。", delete: "削除", reports: "報告",
    watchTrailer: "予告編", trailerUrl: "予告編URL", installApp: "アプリをインストール", animeInd: "アニメ",
    notLoggedIn: "未ログイン", loggedInAs: "ログイン中", syncOn: "同期中", syncOff: "ログインして保存",
    firstEp: "第1話", epTitle: "エピソード名", getApp: "アプリを入手", appDesc: "より良い体験のために",
    download: "ダウンロード", downloadUrl: "ダウンロードリンク",
    askAi: "AIに聞く", aiAssistant: "ZiniPlay AI", aiPlaceholder: "おすすめの映画を聞く...", aiDisclaimer: "Gemini搭載",
    aiWelcome: "こんにちは！映画アシスタントです。おすすめや詳細について何でも聞いてください。",
    dailyLimit: "今日の質問制限",
    aiErrorLimit: "グローバル制限に達しました。明日もう一度お試しください。",
    aiErrorGeneric: "何かがうまくいきませんでした。もう一度お試しください。"
  },
  zh: {
    admin: "管理员", searchPlaceholder: "搜索...", settings: "设置", history: "历史记录", watchlist: "我的列表",
    clearHistory: "清除所有", removeFromHistory: "移除", historyCleared: "历史记录已清除", noHistory: "暂无历史记录。",
    noWatchlist: "列表为空。", theme: "主题", language: "语言", account: "账户", guestUser: "访客",
    loginGoogle: "Google登录", logout: "登出", featured: "精选", playNow: "立即播放", details: "详情",
    trending: "当下流行", continueWatching: "继续观看", reviews: "评论与评分", writeReview: "撰写评论...",
    submit: "提交", noReviews: "暂无评论。", library: "库", searchResults: "搜索结果",
    noContent: "未找到内容。", loadDemo: "加载演示", playingOn: "正在播放", addToWatchlist: "我的列表",
    removeFromWatchlist: "已在列表中", share: "分享", relatedMovies: "猜你喜欢", noDescription: "暂无描述。",
    uploadNew: "上传新内容", editContent: "编辑内容", title: "标题", description: "描述",
    category: "类别", audioLanguage: "语言", releaseYear: "年份", genre: "类型", posterUrl: "海报链接",
    videoLink: "视频链接", addServer: "添加服务器", removeServer: "移除", serverName: "服务器名称",
    showSlider: "显示在滑块？", showTrending: "添加到流行？", upload: "上传",
    update: "更新", createSeries: "创建系列", existingContent: "管理内容", resetData: "重置数据",
    back: "返回", adminLogin: "管理员登录", enter: "进入", cancel: "取消", dark: "深色", light: "浅色",
    catAll: "全部", catMovie: "电影", catWebSeries: "网络剧", catAnime: "动漫", catTvShow: "电视剧",
    catAnimation: "动画", episodes: "剧集", season: "季", episode: "集", addEpisode: "添加剧集",
    manageEpisodes: "管理剧集", manageReviews: "管理评论", totalVideos: "视频总数", topCast: "主要演员",
    actorName: "演员姓名", actorImage: "图片链接", addCast: "添加演员", castList: "演员表", castAdded: "已添加",
    filter: "筛选", country: "国家", industry: "行业", any: "任意", views: "观看次数", imdbRating: "IMDb评分",
    userRating: "用户评分", reviewError: "请添加评分或评论！", loadingMore: "加载中...",
    loadMoreBtn: "加载更多", showing: "显示", of: "/", autoPlay: "自动播放", nextEp: "下一集",
    rewind: "-10秒", forward: "+10秒", skipIntro: "跳过片头", zoom: "缩放", flip: "翻转", speed: "速度",
    normal: "正常", aspectRatio: "比例", subtitle: "字幕", default: "默认", on: "开", off: "关",
    quality: "画质", fullscreen: "全屏", pip: "画中画", zoomed: "缩放", flipped: "翻转",
    servers: "服务器", reportIssue: "报告问题", reportSent: "已发送！", describeIssue: "描述问题:",
    viewReports: "查看报告", noReports: "暂无报告。", delete: "删除", reports: "报告",
    watchTrailer: "观看预告", trailerUrl: "预告链接", installApp: "安装应用", animeInd: "动漫",
    notLoggedIn: "未登录", loggedInAs: "登录为", syncOn: "正在同步", syncOff: "登录以保存",
    firstEp: "第一集", epTitle: "剧集标题", getApp: "获取应用", appDesc: "安装以获得更好体验",
    download: "下载", downloadUrl: "下载链接",
    askAi: "询问AI", aiAssistant: "ZiniPlay AI", aiPlaceholder: "寻求电影推荐...", aiDisclaimer: "由Gemini提供支持",
    aiWelcome: "你好！我是你的电影助手。向我询问有关任何电影的推荐或详情。",
    dailyLimit: "今日提问限制",
    aiErrorLimit: "已达到全球限制，请明天再试。",
    aiErrorGeneric: "出了点问题。请再试一次。"
  },
  de: {
    admin: "Admin", searchPlaceholder: "Suchen...", settings: "Einstellungen", history: "Verlauf", watchlist: "Meine Liste",
    clearHistory: "Alles löschen", removeFromHistory: "Entfernen", historyCleared: "Verlauf gelöscht", noHistory: "Kein Verlauf.",
    noWatchlist: "Deine Liste ist leer.", theme: "THEMA", language: "SPRACHE", account: "KONTO", guestUser: "Gast",
    loginGoogle: "Mit Google anmelden", logout: "Abmelden", featured: "HIGHLIGHTS", playNow: "Abspielen", details: "Details",
    trending: "Im Trend", continueWatching: "Weiterschauen", reviews: "Bewertungen", writeReview: "Bewertung schreiben...",
    submit: "Senden", noReviews: "Keine Bewertungen.", library: "Bibliothek", searchResults: "Suchergebnisse",
    noContent: "Kein Inhalt gefunden.", loadDemo: "Demo laden", playingOn: "Wiedergabe auf", addToWatchlist: "Meine Liste",
    removeFromWatchlist: "In Liste", share: "Teilen", relatedMovies: "Das könnte dir gefallen", noDescription: "Keine Beschreibung.",
    uploadNew: "Neu hochladen", editContent: "Bearbeiten", title: "Titel", description: "Beschreibung",
    category: "Kategorie", audioLanguage: "Sprache", releaseYear: "Jahr", genre: "Genre", posterUrl: "Poster URL",
    videoLink: "Video Link", addServer: "Server hinzufügen", removeServer: "Entfernen", serverName: "Servername",
    showSlider: "Im Slider anzeigen?", showTrending: "Zu Trends hinzufügen?", upload: "Hochladen",
    update: "Aktualisieren", createSeries: "Serie erstellen", existingContent: "Verwalten", resetData: "Daten zurücksetzen",
    back: "Zurück", adminLogin: "Admin Login", enter: "ENTER", cancel: "Abbrechen", dark: "Dunkel", light: "Hell",
    catAll: "Alle", catMovie: "Film", catWebSeries: "Webserie", catAnime: "Anime", catTvShow: "TV-Show",
    catAnimation: "Animation", episodes: "Episoden", season: "Staffel", episode: "Episode", addEpisode: "Episode hinzufügen",
    manageEpisodes: "Episoden verwalten", manageReviews: "Bewertungen verwalten", totalVideos: "Videos gesamt", topCast: "Besetzung",
    actorName: "Name", actorImage: "Bild URL", addCast: "Hinzufügen", castList: "Liste", castAdded: "hinzugefügt",
    filter: "Filter", country: "Land", industry: "Industrie", any: "Alle", views: "Aufrufe", imdbRating: "IMDb Bewertung",
    userRating: "Nutzerbewertung", reviewError: "Bitte Bewertung oder Kommentar hinzufügen!", loadingMore: "Laden...",
    loadMoreBtn: "Mehr laden", showing: "Zeige", of: "von", autoPlay: "Auto Play", nextEp: "Nächste Ep",
    rewind: "-10s", forward: "+10s", skipIntro: "Intro überspringen", zoom: "Zoom", flip: "Spiegeln", speed: "Geschw.",
    normal: "Normal", aspectRatio: "Format", subtitle: "Untertitel", default: "Standard", on: "Ein", off: "Aus",
    quality: "Qualität", fullscreen: "Vollbild", pip: "Miniplayer", zoomed: "Gezoomt", flipped: "Gespiegelt",
    servers: "Server", reportIssue: "Problem melden", reportSent: "Gesendet!", describeIssue: "Problem beschreiben:",
    viewReports: "Berichte ansehen", noReports: "Keine Berichte.", delete: "Löschen", reports: "Berichte",
    watchTrailer: "Trailer ansehen", trailerUrl: "Trailer URL", installApp: "App installieren", animeInd: "Anime",
    notLoggedIn: "Nicht angemeldet", loggedInAs: "Angemeldet als", syncOn: "Verlauf wird synchronisiert", syncOff: "Anmelden zum Speichern",
    firstEp: "Erste Episode", epTitle: "Episodentitel", getApp: "App holen", appDesc: "Für besseres Erlebnis installieren",
    download: "Herunterladen", downloadUrl: "Download Link",
    askAi: "KI fragen", aiAssistant: "ZiniPlay AI", aiPlaceholder: "Nach Filmempfehlung fragen...", aiDisclaimer: "Unterstützt von Gemini",
    aiWelcome: "Hallo! Ich bin dein Film-Assistent. Frag mich nach Empfehlungen oder Details.",
    dailyLimit: "Heutiges Fragenlimit",
    aiErrorLimit: "Globales Limit erreicht, bitte versuchen Sie es morgen erneut.",
    aiErrorGeneric: "Etwas ist schief gelaufen. Bitte versuche es erneut."
  },
  id: {
    admin: "Admin", searchPlaceholder: "Cari...", settings: "Pengaturan", history: "Riwayat", watchlist: "Daftar Saya",
    clearHistory: "Hapus Semua", removeFromHistory: "Hapus", historyCleared: "Riwayat Dihapus", noHistory: "Belum ada riwayat.",
    noWatchlist: "Daftar kosong.", theme: "TEMA", language: "BAHASA", account: "AKUN", guestUser: "Tamu",
    loginGoogle: "Masuk dengan Google", logout: "Keluar", featured: "UNGGULAN", playNow: "Putar", details: "Detail",
    trending: "Sedang Tren", continueWatching: "Lanjut Menonton", reviews: "Ulasan", writeReview: "Tulis ulasan...",
    submit: "Kirim", noReviews: "Belum ada ulasan.", library: "Pustaka", searchResults: "Hasil Pencarian",
    noContent: "Konten tidak ditemukan.", loadDemo: "Muat Demo", playingOn: "Memutar di", addToWatchlist: "Daftar Saya",
    removeFromWatchlist: "Di Daftar", share: "Bagikan", relatedMovies: "Mungkin Anda Suka", noDescription: "Tidak ada deskripsi.",
    uploadNew: "Unggah Baru", editContent: "Edit Konten", title: "Judul", description: "Deskripsi",
    category: "Kategori", audioLanguage: "Bahasa", releaseYear: "Tahun", genre: "Genre", posterUrl: "URL Poster",
    videoLink: "Tautan Video", addServer: "Tambah Server", removeServer: "Hapus", serverName: "Nama Server",
    showSlider: "Tampil di Slider?", showTrending: "Tambah ke Tren?", upload: "Unggah",
    update: "Perbarui", createSeries: "Buat Seri", existingContent: "Kelola", resetData: "Reset Data",
    back: "Kembali", adminLogin: "Login Admin", enter: "MASUK", cancel: "Batal", dark: "Gelap", light: "Terang",
    catAll: "Semua", catMovie: "Film", catWebSeries: "Seri Web", catAnime: "Anime", catTvShow: "Acara TV",
    catAnimation: "Animasi", episodes: "Episode", season: "Musim", episode: "Ep", addEpisode: "Tambah Episode",
    manageEpisodes: "Kelola Episode", manageReviews: "Kelola Ulasan", totalVideos: "Total Video", topCast: "Pemeran",
    actorName: "Nama Aktor", actorImage: "URL Foto", addCast: "Tambah", castList: "Daftar", castAdded: "ditambahkan",
    filter: "Filter", country: "Negara", industry: "Industri", any: "Apa saja", views: "Tayangan", imdbRating: "Rating IMDb",
    userRating: "Rating Pengguna", reviewError: "Tambahkan rating atau komentar!", loadingMore: "Memuat...",
    loadMoreBtn: "Muat Lebih", showing: "Menampilkan", of: "dari", autoPlay: "Putar Otomatis", nextEp: "Ep Lanjut",
    rewind: "-10d", forward: "+10d", skipIntro: "Lewati Intro", zoom: "Zoom", flip: "Balik", speed: "Kecepatan",
    normal: "Normal", aspectRatio: "Rasio", subtitle: "Subtitle", default: "Bawaan", on: "Nyala", off: "Mati",
    quality: "Kualitas", fullscreen: "Layar Penuh", pip: "Mini Player", zoomed: "Zoom", flipped: "Terbalik",
    servers: "Server", reportIssue: "Lapor Masalah", reportSent: "Terkirim!", describeIssue: "Jelaskan masalahnya:",
    viewReports: "Lihat Laporan", noReports: "Tidak ada laporan.", delete: "Hapus", reports: "Laporan",
    watchTrailer: "Tonton Trailer", trailerUrl: "URL Trailer", installApp: "Instal App", animeInd: "Anime",
    notLoggedIn: "Belum masuk", loggedInAs: "Masuk sebagai", syncOn: "Sinkronisasi aktif", syncOff: "Masuk untuk menyimpan",
    firstEp: "Episode Pertama", epTitle: "Judul Episode", getApp: "Dapatkan App", appDesc: "Instal untuk pengalaman lebih baik",
    download: "Unduh", downloadUrl: "Tautan Unduhan",
    askAi: "Tanya AI", aiAssistant: "Asisten AI", aiPlaceholder: "Minta rekomendasi film...", aiDisclaimer: "Didukung oleh Gemini",
    aiWelcome: "Halo! Saya asisten film Anda. Tanyakan rekomendasi atau detail tentang film apa pun.",
    dailyLimit: "Batas Pertanyaan Hari Ini",
    aiErrorLimit: "Batas global tercapai, silakan coba lagi besok.",
    aiErrorGeneric: "Ada yang salah. Silakan coba lagi."
  }
};

const getT = (lang) => translations[lang] || translations['en'];

// --- SMART EMBED URL HELPER ---
const getEmbedUrl = (url, autoplay = false, mute = false, enableJsApi = false) => {
  if (!url) return '';
  const params = [];
  if (autoplay) params.push('autoplay=1');
  if (mute) params.push('mute=1');
  
  params.push('modestbranding=1'); 
  params.push('rel=0'); 
  params.push('showinfo=0'); 
  params.push('iv_load_policy=3'); 
  
  if (enableJsApi) {
      params.push('enablejsapi=1');
      if (typeof window !== 'undefined' && window.location.origin && window.location.origin !== 'null' && window.location.origin !== 'about:blank') {
          params.push(`origin=${window.location.origin}`);
      }
  }
  
  const paramString = params.length > 0 ? `?${params.join('&')}` : '';

  if (url.includes('youtube.com') || url.includes('youtu.be')) {
    const v = url.split('v=')[1]?.split('&')[0] || url.split('/').pop();
    return `https://www.youtube.com/embed/${v}${paramString}${params.length > 0 ? '&' : '?'}controls=1`; 
  }
  if (url.includes('ok.ru')) return `https://ok.ru/videoembed/${url.split('/').pop()}?autoplay=${autoplay ? 1 : 0}`;
  if (url.includes('drive.google.com')) return url.replace('/view', '/preview');
  if (url.includes('vimeo.com')) { const v = url.split('/').pop(); return `https://player.vimeo.com/video/${v}`; }
  if (url.includes('dailymotion.com')) { const v = url.split('/video/')[1]?.split('?')[0]; if(v) return `https://www.dailymotion.com/embed/video/${v}`; return url; }
  if (url.includes('facebook.com') && (url.includes('/videos/') || url.includes('watch'))) return `https://www.facebook.com/plugins/video.php?href=${encodeURIComponent(url)}&show_text=0&width=560`;
  if (url.includes('bitchute.com')) { const v = url.split('/video/')[1]?.replace('/', ''); if(v) return `https://www.bitchute.com/embed/${v}/`; return url; }

  return url;
};
// --- SPLASH SCREEN COMPONENT ---
function SplashScreen() {
  return (
    <div className="fixed inset-0 z-[999999] bg-[#000000] flex flex-col items-center justify-center overflow-hidden">
      {/* অ্যানিমেশনের জন্য কাস্টম CSS */}
      <style>
        {`
          @keyframes zoomInLogo {
            0% { transform: scale(0.3); opacity: 0; }
            100% { transform: scale(1); opacity: 1; }
          }
          @keyframes slideInText {
            0% { transform: translateX(-30px); opacity: 0; }
            100% { transform: translateX(0); opacity: 1; }
          }
          @keyframes fadeInText {
            0% { opacity: 0; }
            100% { opacity: 1; }
          }
          .animate-z-logo { animation: zoomInLogo 0.8s cubic-bezier(0.25, 0.46, 0.45, 0.94) forwards; }
          .animate-z-title { opacity: 0; animation: slideInText 0.8s cubic-bezier(0.25, 0.46, 0.45, 0.94) 0.5s forwards; }
          .animate-z-subtitle { opacity: 0; animation: fadeInText 1s ease-in 1.2s forwards; }
          .animate-z-footer { opacity: 0; animation: fadeInText 1s ease-in 2s forwards; }
        `}
      </style>

      <div className="flex-1 flex flex-col items-center justify-center">
        {/* Z Logo & ZINI PLAY Title */}
        <div className="flex items-center gap-4">
          <img 
            src="https://i.imgur.com/6fubsgM.jpeg" 
            alt="Z Logo" 
            className="w-16 h-16 md:w-20 md:h-20 rounded-2xl object-cover animate-z-logo shadow-[0_0_30px_rgba(220,38,38,0.3)]"
          />
          <h1 className="text-4xl md:text-5xl font-black text-white uppercase tracking-wider animate-z-title" style={{ fontFamily: '"Helvetica Neue", Arial, sans-serif' }}>
            ZINI <span className="text-red-600">PLAY</span>
          </h1>
        </div>
        
        {/* Watch Free Subtitle */}
        <div className="mt-4 animate-z-subtitle">
          <span className="text-white text-xs md:text-sm font-bold tracking-[0.3em] uppercase opacity-80">
            Watch Free
          </span>
        </div>
      </div>

      {/* from zinixa footer */}
      <div className="mb-8 animate-z-footer flex flex-col items-center">
        <span className="text-gray-500 text-[10px] font-medium tracking-widest uppercase mb-0.5">from</span>
        <span className="text-red-600 font-bold text-base tracking-widest uppercase">Munsha</span>
        <img 
            src="https://i.imgur.com/gF1Ujaz_d.png?maxwidth=520&shape=thumb&fidelity=high" 
            alt="Brand Logo" 
            className="w-10 h-10 object-contain drop-shadow-md"
            />
      </div>
    </div>
  );
}
// --- POPUP MODAL COMPONENT (NEW) ---
function PopupModal() {
  const [config, setConfig] = useState(null);
  const [isVisible, setIsVisible] = useState(false);
  const [timeLeft, setTimeLeft] = useState(0);

  useEffect(() => {
    const fetchConfig = async () => {
      try {
        const docRef = doc(db, 'artifacts', appId, 'public', 'data', 'popup_config', 'main');
        const snap = await getDoc(docRef);
        if (snap.exists()) {
          const data = snap.data();
          if (data.active) {
            setConfig(data);
            setIsVisible(true);
            if (data.timer && Number(data.timer) > 0) {
              setTimeLeft(Number(data.timer));
            }
          }
        }
      } catch (e) {
        console.error("Popup fetch error:", e);
      }
    };
    fetchConfig();
  }, []);

  useEffect(() => {
    if (!isVisible || !config?.timer || timeLeft <= 0) {
        if(timeLeft === 0 && isVisible && config?.timer) setIsVisible(false);
        return;
    }
    const interval = setInterval(() => {
      setTimeLeft((prev) => prev - 1);
    }, 1000);
    return () => clearInterval(interval);
  }, [isVisible, config, timeLeft]);

  if (!isVisible || !config) return null;

  return (
    <div className="fixed inset-0 z-[300] flex items-center justify-center p-4 bg-black/80 backdrop-blur-sm animate-in fade-in">
      <div className="relative bg-gray-900 border border-gray-700 p-1 rounded-xl shadow-2xl max-w-sm w-full">
        <button 
          onClick={() => setIsVisible(false)} 
          className="absolute -top-3 -right-3 bg-red-600 text-white p-1.5 rounded-full shadow-lg hover:scale-110 transition z-50"
        >
          <X size={20} />
        </button>
        
        <div className="overflow-hidden rounded-lg bg-black">
          {config.image && (
            <div 
              onClick={() => config.link && window.open(config.link, '_blank')} 
              className={`relative group ${config.link ? 'cursor-pointer' : ''}`}
            >
              <img src={config.image} alt="Special Offer" className="w-full h-auto object-cover max-h-[60vh]" />
              {config.link && (
                  <div className="absolute inset-0 bg-black/20 group-hover:bg-black/40 transition flex items-center justify-center opacity-0 group-hover:opacity-100">
                       <ExternalLink className="text-white drop-shadow-md" size={40}/>
                  </div>
              )}
            </div>
          )}
          
          {(config.message || (config.timer > 0)) && (
              <div className="p-4 text-center bg-gray-900">
                  {config.message && (
                      <p className="text-sm font-medium text-gray-200 whitespace-pre-wrap mb-2">
                          {config.message}
                      </p>
                  )}
                  
                  {config.link && !config.image && (
                      <button 
                        onClick={() => window.open(config.link, '_blank')}
                        className="bg-red-600 text-white px-4 py-2 rounded-full text-xs font-bold hover:bg-red-700 transition mb-2"
                      >
                        Check it out
                      </button>
                  )}

                  {config.timer > 0 && (
                      <div className="text-[10px] text-gray-500 font-mono mt-2 border-t border-gray-800 pt-2">
                          Auto closing in <span className="text-red-500 font-bold">{timeLeft}s</span>
                      </div>
                  )}
              </div>
          )}
        </div>
      </div>
    </div>
  );
}

// AI COMPONENT TO FIX FOCUS ISSUE ---
const AIComponent = ({ isOpen, onClose, messages, input, setInput, onSubmit, isLoading, t, usageCount, keyCount, dailyLimit }) => {
  
  // ১. হুকগুলো (Hooks) সবার আগে লিখতে হবে (শর্তের উপরে)
  const chatContainerRef = useRef(null);

  useEffect(() => {
    if (chatContainerRef.current) {
      chatContainerRef.current.scrollTop = chatContainerRef.current.scrollHeight;
    }
  }, [messages]);

  // ২. এরপর শর্ত (Condition) চেক করতে হবে
  if (!isOpen) return null;

    return (
        // FIXED: Changed h-[400px] to h-[min(400px,60vh)] so it fits on small screens
        <div className="fixed bottom-20 right-4 z-[6000] w-[85%] sm:w-80 h-[min(400px,60vh)] flex flex-col pointer-events-auto">
            <div className={`w-full h-full bg-gray-900 border border-gray-700 shadow-2xl flex flex-col rounded-2xl overflow-hidden animate-in slide-in-from-bottom-5 duration-300`}>
                {/* Header */}
                <div className="p-3 border-b border-gray-700 bg-gray-900 flex justify-between items-center z-10">
                    <div className="flex items-center gap-2">
                        {/* CHANGED: Replaced Gemini Logo (Sparkles) with App Logo (Film) */}
                        <div className="p-0.5 rounded-lg">
   <img src="https://i.imgur.com/gF1Ujaz_d.png?maxwidth=520&shape=thumb&fidelity=high" alt="Brand Logo" className="w-10 h-10 object-contain" />
</div>
                        <div>
                            <h3 className="font-bold text-white text-xs">Munsha AI</h3>

                            {/* ADDED LIMIT DISPLAY HERE - UPDATED TO DYNAMIC LIMIT */}
                            <p className="text-[9px] text-gray-400 font-mono mt-0.5">
                                {t.dailyLimit}: <span className={usageCount >= dailyLimit ? "text-red-500" : "text-green-400"}>{usageCount}</span>/{dailyLimit}
                            </p>
                        </div>
                    </div>
                    <div className="flex items-center gap-2">
                        <button onClick={onClose} className="bg-gray-800 hover:bg-gray-700 text-white px-2 py-1 rounded text-[10px] font-bold border border-gray-600">
                            Back
                        </button>
                    </div>
                </div>

                {/* Messages */}
                <div ref={chatContainerRef} className="flex-1 overflow-y-auto p-3 space-y-3 bg-gray-900/95">
                    {messages.map((msg, i) => (
                        <div key={i} className={`flex ${msg.role === 'user' ? 'justify-end' : 'justify-start'}`}>
                            <div className={`max-w-[85%] p-2 rounded-xl text-xs ${msg.role === 'user' ? 'bg-red-600 text-white rounded-br-none' : 'bg-gray-800 text-gray-200 rounded-bl-none border border-gray-700'}`}>
                                {msg.text}
                            </div>
                        </div>
                    ))}
                    {isLoading && (
                        <div className="flex justify-start">
                            <div className="bg-gray-800 p-2 rounded-xl rounded-bl-none border border-gray-700 flex gap-1">
                                <div className="w-1.5 h-1.5 bg-gray-500 rounded-full animate-bounce"></div>
                                <div className="w-1.5 h-1.5 bg-gray-500 rounded-full animate-bounce delay-100"></div>
                                <div className="w-1.5 h-1.5 bg-gray-500 rounded-full animate-bounce delay-200"></div>
                            </div>
                        </div>
                    )}
                </div>

                {/* Input */}
                <form onSubmit={onSubmit} className="p-2 border-t border-gray-800 bg-gray-900">
                    <div className="relative flex items-center">
                        <input 
                            type="text" 
                            value={input}
                            onChange={(e) => setInput(e.target.value)}
                            placeholder={t.aiPlaceholder || "Ask..."}
                            autoFocus
                            className="w-full bg-gray-800 text-white rounded-full pl-3 pr-10 py-2 text-xs focus:ring-1 focus:ring-red-600 outline-none border border-gray-700"
                        />
                        <button 
                            type="submit" 
                            disabled={!input.trim() || isLoading}
                            className="absolute right-1 p-1.5 bg-red-600 rounded-full text-white disabled:opacity-50 disabled:cursor-not-allowed hover:bg-red-700 transition"
                        >
                            <Send size={12} />
                        </button>
                    </div>
                </form>
            </div>
        </div>
    );
};

export default function App() {
  // --- 🔒 WEB SECURITY (Block DevTools & Right Click) ---
  useEffect(() => {
    const handleContext = (e) => e.preventDefault();
    const handleKeydown = (e) => {
      if (
        e.keyCode === 123 || // F12
        (e.ctrlKey && e.shiftKey && (e.keyCode === 73 || e.keyCode === 74 || e.keyCode === 67)) || // Ctrl+Shift+I/J/C
        (e.ctrlKey && e.keyCode === 85) // Ctrl+U (View Source)
      ) {
        e.preventDefault();
      }
    };
    document.addEventListener('contextmenu', handleContext);
    document.addEventListener('keydown', handleKeydown);
    return () => {
      document.removeEventListener('contextmenu', handleContext);
      document.removeEventListener('keydown', handleKeydown);
    };
  }, []);

  // --- SPLASH SCREEN STATE ---
  const [showSplash, setShowSplash] = useState(() => {
    if (typeof window !== 'undefined') {
      // যদি এই সেশনে আগে থেকেই স্প্ল্যাশ স্ক্রিন দেখানো হয়ে থাকে, তবে আর দেখাবে না (false হবে)
      return !sessionStorage.getItem('miniflix-splash-shown');
    }
    return true;
  });

  useEffect(() => {
    // যদি স্প্ল্যাশ স্ক্রিন দেখানোর প্রয়োজন না থাকে, তাহলে এখান থেকেই ফিরে যাবে
    if (!showSplash) return;

    // ৩.৫ সেকেন্ড পর স্প্ল্যাশ স্ক্রিন বন্ধ হয়ে মেইন অ্যাপ চালু হবে
    const timer = setTimeout(() => {
      setShowSplash(false);
      // ব্রাউজারকে জানিয়ে দেওয়া হলো যে একবার স্প্ল্যাশ দেখানো হয়ে গেছে
      sessionStorage.setItem('miniflix-splash-shown', 'true');
    }, 3500); 
    return () => clearTimeout(timer);
  }, [showSplash]);
  // --- 🌟 ONESIGNAL CONFIGURATION (START) 🌟 ---
  const [pendingMovieId, setPendingMovieId] = useState(null);

  useEffect(() => {
    // OneSignal Initialize
    const initOneSignal = async () => {
      try {
        await OneSignal.init({ 
          appId: "adc33ff9-f80c-454d-acc2-9decc53b697e", // আপনার দেওয়া ID
          allowLocalhostAsSecureOrigin: true,
          notifyButton: { enable: true },
        });
        // সাবস্ক্রিপশন পপ-আপ দেখাবে
        OneSignal.Slidedown.promptPush();
      } catch (error) {
        console.error("OneSignal Init Failed:", error);
      }
    };
    initOneSignal();

    // নোটিফিকেশন ক্লিক লিসেনার (Deep Linking)
    const handleNotificationClick = (event) => {
      const data = event.notification.additionalData;
      if (data && data.movieId) {
        console.log("Notification Clicked! Movie ID:", data.movieId);
        setPendingMovieId(data.movieId);
      }
    };

    OneSignal.Notifications.addEventListener('click', handleNotificationClick);
    return () => {
       OneSignal.Notifications.removeEventListener('click', handleNotificationClick);
    };
  }, []);

  
  // --- 🌟 ONESIGNAL CONFIGURATION (END) 🌟 ---
  // --- 1. DEVICE DETECTOR (মোবাইল নাকি পিসি বোঝার জন্য) ---
  const [isMobile, setIsMobile] = useState(typeof window !== 'undefined' ? window.innerWidth < 768 : false);
  // --- DEVICE DETECTION (Capacitor & PWA) ---
  const isCapacitor = typeof window !== 'undefined' && window.Capacitor?.isNativePlatform();
  const isPwa = typeof window !== 'undefined' && (window.matchMedia('(display-mode: standalone)').matches || window.navigator.standalone);

  // --- 🌟 OFFLINE DOWNLOAD LOGIC (CAPACITOR ONLY) 🌟 ---
  const [downloadingItems, setDownloadingItems] = useState([]);
  const [downloadedItems, setDownloadedItems] = useState([]);
  const [selectedSeriesForDownload, setSelectedSeriesForDownload] = useState(null);

  useEffect(() => {
    if (!isCapacitor) return;
    const loadDownloads = async () => {
      try {
        const res = await Filesystem.readFile({
          path: 'ziniplay_downloads/meta.json',
          directory: Directory.Data,
          encoding: 'utf8'
        });
        setDownloadedItems(JSON.parse(res.data) || []);
      } catch (e) {
        console.log("No existing downloads meta.");
      }
    };
    loadDownloads();
  }, [isCapacitor]);

  const saveDownloadsMeta = async (newItems) => {
    setDownloadedItems(newItems);
    try {
      await Filesystem.writeFile({
        path: 'ziniplay_downloads/meta.json',
        data: JSON.stringify(newItems),
        directory: Directory.Data,
        encoding: 'utf8',
        recursive: true
      });
    } catch (e) {
      console.error("Failed to save downloads meta", e);
    }
  };

  const startOfflineDownload = async (movieOrSeries, epData = null) => {
      if (!isCapacitor) {
          showNotification("Movie downloading is secured. Please install our App to download offline.");
          return;
      }
      
      const isSeries = !!epData;
      const downloadId = Date.now().toString();
      const title = isSeries ? `${movieOrSeries.title} - ${epData.title}` : movieOrSeries.title;
      // Series episode may have downloadUrl or videoUrl, fallback to videoUrl
      let url = isSeries ? (epData.downloadUrl || epData.videoUrl) : (movieOrSeries.downloadUrl || movieOrSeries.videoUrl);

      if (!url) return showNotification("Error: No download link available.");

      // --- 🚦 TELEGRAM MTPROTO LINK PARSING LOGIC 🚦 ---
      if (url.includes('t.me/c/')) {
          const pathParts = url.split('t.me/c/')[1];
          let rServers = [];
          try {
              const cachedData = localStorage.getItem('ziniplay_render_servers');
              if (cachedData) rServers = JSON.parse(cachedData).servers || [];
          } catch(e) {}

          if (rServers.length > 0) {
              const randomServer = rServers[Math.floor(Math.random() * rServers.length)];
              url = `${randomServer}/stream/-100${pathParts}`;
          } else {
              url = `https://mp-api-v2.onrender.com/stream/-100${pathParts}`;
          }
      }
      // --------------------------------------------------

      // Check if already downloading or downloaded
      if (downloadingItems.find(i => i.url === url)) return showNotification("Already downloading this item!");
      let alreadyDownloaded = false;
      if(isSeries) {
          const sMeta = downloadedItems.find(m => m.id === movieOrSeries.id);
          if(sMeta && sMeta.episodes.find(e => e.id === epData.id)) alreadyDownloaded = true;
      } else {
          if(downloadedItems.find(m => m.id === movieOrSeries.id && !m.isSeries)) alreadyDownloaded = true;
      }
      if(alreadyDownloaded) return showNotification("Already downloaded!");

      showNotification(`Download started: ${title}`);
      setDownloadingItems(prev => [...prev, { id: downloadId, title, progress: 0, url }]);

      try {
          const extension = url.includes('.mkv') ? 'mkv' : 'mp4';
          const filePath = `ziniplay_downloads/videos/${downloadId}.${extension}`;

          const progressListener = await Filesystem.addListener('progress', (progressEvent) => {
              if (progressEvent.url === url) {
                  const prog = Math.round((progressEvent.bytes / progressEvent.contentLength) * 100);
                  setDownloadingItems(prev => prev.map(item => item.id === downloadId ? { ...item, progress: prog } : item));
              }
          });

          const result = await Filesystem.downloadFile({
              url: url,
              path: filePath,
              directory: Directory.Data,
              recursive: true,
              progress: true
          });

          progressListener.remove();
          setDownloadingItems(prev => prev.filter(item => item.id !== downloadId));

          // Save to metadata
          const newItems = [...downloadedItems];
          if (isSeries) {
              const existingSeries = newItems.find(m => m.id === movieOrSeries.id);
              const epRecord = { id: epData.id, title: epData.title, localUrl: result.path };
              if (existingSeries) {
                  existingSeries.episodes.push(epRecord);
              } else {
                  newItems.push({
                      id: movieOrSeries.id,
                      title: movieOrSeries.title,
                      poster: movieOrSeries.poster,
                      isSeries: true,
                      episodes: [epRecord]
                  });
              }
          } else {
              newItems.push({
                  id: movieOrSeries.id,
                  title: movieOrSeries.title,
                  poster: movieOrSeries.poster,
                  isSeries: false,
                  localUrl: result.path
              });
          }
          saveDownloadsMeta(newItems);
          showNotification(`Download Complete: ${title}`);
      } catch (err) {
          setDownloadingItems(prev => prev.filter(item => item.id !== downloadId));
          showNotification(`Download Failed: Please check your internet connection.`);
      }
  };

  const playOfflineVideo = async (item, epRecord = null) => {
      let localUrl = epRecord ? epRecord.localUrl : item.localUrl;
      try {
          const stat = await Filesystem.stat({ path: localUrl, directory: Directory.Data });
          const webUrl = typeof window !== 'undefined' && window.Capacitor ? window.Capacitor.convertFileSrc(stat.uri) : stat.uri;
          
          const mockMovie = {
              id: item.id,
              title: epRecord ? `${item.title} - ${epRecord.title}` : item.title,
              videoUrl: webUrl,
              poster: item.poster,
              isDirectFile: true,
              isOfflineMode: true,
              offlineParentId: item.isSeries ? item.id : null,
              seriesData: item.isSeries ? item : null, // To list other episodes in suggestions
              category: item.isSeries ? 'Series' : 'Movie'
          };
          setCurrentMovie(mockMovie);
          setView('player');
      } catch (e) {
          showNotification("Video file not found or corrupted.");
      }
  };
  // --- OFFLINE DOWNLOAD LOGIC END ---
  // --- NEW: SMART DOWNLOAD & PROMO STATES ---
  const [appLinks, setAppLinks] = useState([]);
  const [promotions, setPromotions] = useState([]);
  const [currentPromo, setCurrentPromo] = useState(null);
  const [showSmartDownload, setShowSmartDownload] = useState(false);
  const [showBottomBanner, setShowBottomBanner] = useState(true); // স্টিকি ব্যানার কন্ট্রোল
  const [downloadType, setDownloadType] = useState('all'); // 'mobile' | 'pc'

  // --- SMART DOWNLOAD HANDLER (CRITICAL LOGIC) ---
  // --- SMART DOWNLOAD HANDLER (FIXED LOGIC) ---
  // --- SMART DOWNLOAD HANDLER (AUTO-REDIRECT LOGIC ADDED) ---
  const handleAppDownload = (type) => {
    // ১. পিসি লিংক এবং মোবাইল লিংকগুলো আলাদা করি
    const pcLink = appLinks.find(l => l.type === 'pc');
    const mobileLinks = appLinks.filter(l => l.type === 'mobile');

    // --- PC LOGIC (আগের মতোই থাকছে) ---
    // যদি পিসি বাটন ক্লিক করে এবং লিংক না থাকে -> PWA ইন্সটল হবে
    if (type === 'pc' && !pcLink) {
      if (isCapacitor) {
         showNotification("PC Version is coming soon!");
         return; 
      }
      if (installPrompt) {
        handleInstallClick();
      } else {
        showNotification("App is already installed or check address bar icon.");
      }
      return; 
    }

    // --- MOBILE LOGIC (নতুন পরিবর্তন) ---
    if (type === 'mobile') {
        // লজিক: যদি মোবাইলের জন্য মাত্র ১টি লিংক থাকে -> সরাসরি ওপেন হবে (লিস্ট দেখাবে না)
        if (mobileLinks.length === 1) {
            window.open(mobileLinks[0].url, '_blank');
            return; // এখানেই কাজ শেষ, মডাল ওপেন হবে না
        }
        // আর যদি লিংক না থাকে অথবা একের বেশি থাকে -> তাহলে নিচে যাবে এবং মডাল ওপেন হবে
    }

    // অন্যথায় (একাধিক লিংক থাকলে বা পিসি লিংক থাকলে) মডাল ওপেন হবে
    setDownloadType(type);
    setShowSmartDownload(true);
  };

  // --- 🚀 JADUKORI MASTER CONFIG LISTENER (1 REQUEST INSTEAD OF 10) ---
  useEffect(() => {
    const masterRef = doc(db, 'artifacts', appId, 'public', 'data', 'master_config', 'main');
    const unsub = onSnapshot(masterRef, (snap) => {
        if (snap.exists()) {
            const data = snap.data();
            
            if (data.app_links?.list) setAppLinks(data.app_links.list);
            if (data.ad_config) setAdConfig(prev => ({ ...prev, ...data.ad_config }));
            if (data.app_version?.latestVersion && data.app_version.latestVersion.trim() !== '' && data.app_version.latestVersion !== CURRENT_APP_VERSION) setUpdateInfo(data.app_version);
            if (data.store_config) setShowPremiumMenu(data.store_config.showMenu !== false);
            if (data.ui_config) {
                setNewReleaseLimit(data.ui_config.newReleaseLimit || 10);
                if (data.ui_config.showDownloadBanner !== undefined) {
                    setIsBannerAllowed(data.ui_config.showDownloadBanner);
                    setShowBottomBanner(data.ui_config.showDownloadBanner);
                }
                if (data.ui_config.pcPopup) {
                    setPcPopupConfig({ active: data.ui_config.pcPopup.active !== undefined ? data.ui_config.pcPopup.active : true, timer: data.ui_config.pcPopup.timer || 5 });
                }
                setTrendingLimit(data.ui_config.trendingLimit || 30);
                if (data.ui_config.reportEmail) {
                    setReportEmail(data.ui_config.reportEmail);
                }
            }
            if (data.ai_config?.dailyLimit) setAiDailyLimit(Number(data.ai_config.dailyLimit));
        }
    });
    return () => unsub();
  }, []);
  

  // 2. FETCH SEQUENTIAL PROMOTIONS
  useEffect(() => {
    const q = query(collection(db, 'artifacts', appId, 'public', 'data', 'promotions'));
    const unsub = onSnapshot(q, (snap) => {
      const allPromos = snap.docs.map(d => ({ id: d.id, ...d.data() }));
      
      // Filter Logic: Active + Target Match
      const deviceType = isMobile ? 'mobile' : 'pc';
      const filtered = allPromos.filter(p => 
        p.isActive === true && (p.target === 'all' || p.target === deviceType)
      );
      setPromotions(filtered);
    }, (err) => console.log("Promo error:", err));
    return () => unsub();
  }, [isMobile]);

  // 3. PROMO QUEUE LOGIC (One by One)
  useEffect(() => {
    if (!currentPromo && promotions.length > 0) {
      setCurrentPromo(promotions[0]);
    }
  }, [promotions, currentPromo]);

  const handleClosePromo = () => {
    // বর্তমান পপ-আপ সরিয়ে পরেরটি লোড হবে
    setCurrentPromo(null);
    setPromotions(prev => prev.slice(1));
  };

  useEffect(() => {
    const isMobileDevice = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
    
    const handleResize = () => {
      // Prevent UI layout changes if the user is in fullscreen mode
      if (document.fullscreenElement || document.webkitFullscreenElement) return;
      
      // If it's a physical mobile device, lock it to mobile layout even in landscape
      if (isMobileDevice) {
         setIsMobile(true);
      } else {
         setIsMobile(window.innerWidth < 768);
      }
    };
    
    handleResize(); // Run once to ensure correct initial state
    
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  // --- 2. ADVERTISEMENT & DOWNLOAD SETTINGS (মাস্টার কন্ট্রোলার) ---
  // এখান থেকেই আপনি ফিউচারে অ্যাডমিন প্যানেল দিয়ে অ্যাড কন্ট্রোল করবেন
  // --- 2. ADVERTISEMENT & DOWNLOAD SETTINGS (REAL-TIME DB) ---
  const [adConfig, setAdConfig] = useState({
    preRoll: { mobile: { active: false }, pc: { active: false }, skipTime: 5, autoClose: 30 },
    homeFooter: { mobile: { active: false }, pc: { active: false } },
    underVideo: { mobile: { active: false }, pc: { active: false } },
    pauseAd: { mobile: { active: false }, pc: { active: false } },
    midRoll: { mobile: { active: false }, pc: { active: false }, interval: 10, skipTime: 5, autoClose: 30 }
  });

  
  // --- 0. IN-APP UPDATE SYSTEM (STEP 1) ---
  const CURRENT_APP_VERSION = "1.0.0"; // অ্যাপের বর্তমান ভার্সন (APK বানানোর সময় এটি বাড়াবেন)
  const [updateInfo, setUpdateInfo] = useState(null);

  
  // --- 3. DOWNLOAD MODAL STATE (পপ-আপ দেখানোর লজিক) ---
  const [showDownloadModal, setShowDownloadModal] = useState(false);
  // PC Popup Config State (Admin Control)
  const [pcPopupConfig, setPcPopupConfig] = useState({ active: true, timer: 5 });

  // ৩. স্মার্ট পপ-আপ লজিক (Smart Popup Logic) - UPDATED
  useEffect(() => {
    // শুধুমাত্র পিসিতে (PC) এবং যদি অ্যাডমিন প্যানেল থেকে 'active' করা থাকে তবেই দেখাবে
    if (!isMobile && pcPopupConfig.active) {
      // অ্যাডমিনের দেওয়া সেকেন্ডকে মিলিসেকেন্ডে রূপান্তর করা হলো (যেমন: 10s * 1000 = 10000ms)
      const delayTime = (pcPopupConfig.timer || 5) * 1000; 
      
      const timer = setTimeout(() => {
        setShowDownloadModal(true);
      }, delayTime);
      
      return () => clearTimeout(timer);
    }
  }, [isMobile, pcPopupConfig]); // যখন কনফিগারেশন লোড হবে, তখন এটি আপডেট হবে

  // --- EXISTING STATES (আপনার আগের স্টেটগুলো এর নিচে থাকবে) ---
  // const [activeTab, setActiveTab] = useState('home'); 
  // ... বাকি কোড ...
  const [user, setUser] = useState(null);
  const [view, setView] = useState(() => {
    if (typeof window !== 'undefined') return sessionStorage.getItem('miniflix-view') || 'home';
    return 'home';
  });
  
  useEffect(() => { 
    sessionStorage.setItem('miniflix-view', view); 
  }, [view]);

  // --- NATIVE CAPACITOR SETUP (Status Bar & Back Button) ---
  useEffect(() => {
      if (!isCapacitor) return;
      
      const initNativeSetup = async () => {
          try {
              await StatusBar.setOverlaysWebView({ overlay: true });
              await StatusBar.setStyle({ style: Style.Dark });
          } catch (e) {
              console.log("StatusBar setup failed:", e);
          }
      };
      initNativeSetup();

      const backListener = CapacitorApp.addListener('backButton', () => {
          setView(prevView => {
              if (prevView === 'player' || prevView === 'downloads' || prevView === 'settings' || prevView === 'history' || prevView === 'search') {
                  if (prevView === 'player') {
                      ScreenOrientation.lock({ orientation: 'portrait' }).catch(() => {});
                  }
                  return 'home';
              } else {
                  CapacitorApp.exitApp();
                  return prevView;
              }
          });
      });

      return () => {
          backListener.then(l => l.remove());
      };
  }, [isCapacitor, setView]);
  const [movies, setMovies] = useState([]);
  const [lastVisible, setLastVisible] = useState(null); // প্যাজিনেশনের জন্য শেষ মুভি ট্র্যাক করা
  const [isFetchingMore, setIsFetchingMore] = useState(false); // লোড হচ্ছে কিনা চেক করা
  const [hasMore, setHasMore] = useState(true); // আর ডাটা আছে কিনা চেক করা
  
  // --- 🪙 COIN & PREMIUM STATE (NEW) ---
  const [coins, setCoins] = useState(0);
  const [isPremium, setIsPremium] = useState(() => {
    if (typeof window !== 'undefined') return localStorage.getItem('ziniplay_premium') === 'true';
    return false;
  });
  const [premiumExpiryDate, setPremiumExpiryDate] = useState(null); // VIP মেয়াদ রাখার জন্য
  const [activePlanName, setActivePlanName] = useState('VIP'); // ডিফল্ট নাম VIP
  // মুভি লিস্ট লোড হলে অটোমেটিক প্লে করা
  useEffect(() => {
    if (pendingMovieId && movies.length > 0) {
      const targetMovie = movies.find(m => m.id === pendingMovieId);
      if (targetMovie) {
        handlePlayMovie(targetMovie); // ভিডিও প্লে হবে
        setPendingMovieId(null); // আইডি ক্লিয়ার করা হলো
      }
    }
  }, [pendingMovieId, movies]);
  const [featuredMovies, setFeaturedMovies] = useState([]);
  const [currentMovie, setCurrentMovie] = useState(() => {
    if (typeof window !== 'undefined') {
      const saved = sessionStorage.getItem('miniflix-current-movie');
      return saved && saved !== "undefined" ? JSON.parse(saved) : null;
    }
    return null;
  });

  useEffect(() => { 
    if (currentMovie) {
      sessionStorage.setItem('miniflix-current-movie', JSON.stringify(currentMovie));
    } else {
      sessionStorage.removeItem('miniflix-current-movie');
    }
  }, [currentMovie]);
  
  // NOTE: Admin related states removed for User App
  const [isSetupLoading, setIsSetupLoading] = useState(false);
  
  const [userWatchlist, setUserWatchlist] = useState([]);
  const [searchQuery, setSearchQuery] = useState('');
  const [selectedCategory, setSelectedCategory] = useState('All');
  const [showFilters, setShowFilters] = useState(false);
  
  const [filterCountry, setFilterCountry] = useState('Any');
  const [filterIndustry, setFilterIndustry] = useState('Any');
  const [filterYear, setFilterYear] = useState('Any');
  const [filterLang, setFilterLang] = useState('Any');
  const [filterGenre, setFilterGenre] = useState('Any');
  
  const [activeFilterIndex, setActiveFilterIndex] = useState(null);
  const [isSearchOpen, setIsSearchOpen] = useState(false);
  const [suggestions, setSuggestions] = useState([]);
  const [notification, setNotification] = useState(null);
  
  const [loginError, setLoginError] = useState(null);

  // --- AI CHAT STATE ---
  const [isAiOpen, setIsAiOpen] = useState(false);
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [showPremiumModal, setShowPremiumModal] = useState(false);
  const [geminiKeys, setGeminiKeys] = useState([]); // নতুন স্টেট API Keys এর জন্য
  const [aiMessages, setAiMessages] = useState([{ role: 'model', text: 'Hello! I am your movie assistant. Ask me for recommendations or details about any movie in our library.' }]);
  const [aiInput, setAiInput] = useState('');
  const [isAiLoading, setIsAiLoading] = useState(false);
  
  // ADDED: State to track daily usage for UI display
  const [aiUsageCount, setAiUsageCount] = useState(0);
  const [aiDailyLimit, setAiDailyLimit] = useState(20); // Default Limit 20
  const [trendingLimit, setTrendingLimit] = useState(30);
  const [newReleaseLimit, setNewReleaseLimit] = useState(10);
  const [isBannerAllowed, setIsBannerAllowed] = useState(true);
  // --- PREMIUM MENU TOGGLE STATE (NEW) ---
  const [showPremiumMenu, setShowPremiumMenu] = useState(true);
  const [reportEmail, setReportEmail] = useState('');
  

  

  
  

  

  // ADDED: Effect to update count when AI window opens
 // --- FETCH GEMINI KEYS FROM FIRESTORE ---
  useEffect(() => {
    const q = query(collection(db, 'artifacts', appId, 'public', 'data', 'api_keys'));
    const unsubscribe = onSnapshot(q, (snapshot) => {
       const keys = snapshot.docs.map(doc => doc.data().key).filter(k => k);
       if(keys.length > 0) {
           console.log("Loaded dynamic Gemini keys:", keys.length);
           setGeminiKeys(keys);
       }
    }, (error) => console.log("API Keys fetch error:", error));

    return () => unsubscribe();
  }, []);

  // --- AI LOGIC (GEMINI) ---
  const handleAiSubmit = async (e) => {
    e.preventDefault();
    if (!aiInput.trim()) return;

    const userMsg = aiInput.trim();
    setAiMessages(prev => [...prev, { role: 'user', text: userMsg }]);
    setAiInput('');
    setIsAiLoading(true);

    // 1. CHECK USER DAILY LIMIT (LocalStorage - Cost Free)
    const today = new Date().toDateString(); 
    const storageKey = 'miniflix_ai_usage';
    let usage = JSON.parse(localStorage.getItem(storageKey) || '{"count": 0, "date": ""}');

    if (usage.date !== today) {
        usage = { count: 0, date: today };
    }

    // UPDATED LIMIT TO DYNAMIC VARIABLE
    if (usage.count >= aiDailyLimit) {
        setAiMessages(prev => [...prev, { role: 'model', text: t.dailyLimit + " reached." }]); 
        setIsAiLoading(false);
        return;
    }

    try {
        const movieContext = movies.slice(0, 50).map(m => `${m.title} (${m.genre}, ${m.lang})`).join(', ');
        const prompt = `You are a helpful assistant for a movie app called ZiniPlay. 
        Available movies in database: ${movieContext}.
        User Question: ${userMsg}.
        
        STRICT LANGUAGE RULES:
        1. GENERAL RULE (ALL LANGUAGES):
           - ALWAYS reply in the SAME Language and Script used by the User in their question.
           - Example: If User asks in Hindi -> Reply in Hindi. If Spanish -> Spanish.
        
        2. BENGALI SPECIFIC RULES:
           - If User writes in Banglish (Bengali in English letters) -> You MUST reply in Banglish.
           - If User writes in Bangla Script (বাংলা) -> You MUST reply in Bangla Script.
           - Never use the Hindi word 'Swagat'. Use 'Shagotom' (Banglish) or 'স্বাগতম' (Bangla).

        Answer briefly and helpfully regarding movies.`;

        // --- SMART FAILOVER LOGIC (SEQUENTIAL) ---
        // 1. Hardcoded Key (Priority 1)
        // 2. Dynamic Keys from Admin (Priority 2, 3, 4...)
        // এখন আর এলোমেলো (Shuffle) করা হবে না, সিরিয়াল অনুযায়ী চেক করবে।
        const allAvailableKeys = [GEMINI_API_KEY, ...geminiKeys];
        
        let aiResponse = null;
        let success = false;

        // লুপ চালিয়ে একটার পর একটা কী চেক করা হবে (Sequential Check)
        for (const apiKey of allAvailableKeys) {
            try {
                // ডিবাগিং এর জন্য লগ (কোন কি-টি ব্যবহার হচ্ছে তা বোঝার জন্য, শেষের ৪ অক্ষর দেখাবে)
                console.log(`Trying API Key ending in... ${apiKey.slice(-4)}`); 
                
                const response = await fetch(`https://generativelanguage.googleapis.com/v1beta/models/gemini-2.5-flash:generateContent?key=${apiKey}`, {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify({
                        contents: [{ parts: [{ text: prompt }] }]
                    })
                });

                const data = await response.json();

                // যদি রেসপন্স ঠিক থাকে এবং কোনো এরর না থাকে
                if (response.ok && !data.error) {
                    aiResponse = data.candidates?.[0]?.content?.parts?.[0]?.text;
                    if (aiResponse) {
                        success = true;
                        break; // কাজ হয়েছে, লুপ থামিয়ে দাও
                    }
                } else {
                    // যদি কোটা বা লিমিট এরর হয় (429), তাহলে কনসোলে ওয়ার্নিং দিয়ে পরের কী ট্রাই করবে
                    if (response.status === 429 || (data.error && data.error.code === 429)) {
                        console.warn("Key exhausted (429), waiting 1s then trying next key...");
                        await new Promise(r => setTimeout(r, 1000)); // 1 সেকেন্ড বিশ্রাম নিয়ে পরেরটিতে যাবে
                        continue; // পরের কী তে যাও
                    } else {
                        // অন্য কোনো এরর হলে লগ করো কিন্তু লুপ চালিয়ে যাও (যদি অন্য চাবি দিয়ে কাজ হয়)
                        console.warn("API Error:", data.error?.message);
                        continue; 
                    }
                }
            } catch (err) {
                console.warn("Network/API error with a key, trying next...", err);
                continue;
            }
        }

        if (!success || !aiResponse) {
            throw new Error("Global limit reached (All keys exhausted)");
        }

        // Success: Update Chat & Increment User Count
        setAiMessages(prev => [...prev, { role: 'model', text: aiResponse }]);
        usage.count += 1;
        localStorage.setItem(storageKey, JSON.stringify(usage));
        setAiUsageCount(usage.count);

    } catch (error) {
        console.error("AI Final Error:", error);
        let errorMsg = t.aiErrorGeneric;
        if (error.message.includes("Global limit reached")) {
            errorMsg = t.aiErrorLimit;
        }
        setAiMessages(prev => [...prev, { role: 'model', text: errorMsg }]);
    } finally {
        setIsAiLoading(false);
    }
  };

  // --- PWA STATE ---
  const [installPrompt, setInstallPrompt] = useState(null);

  const [watchHistory, setWatchHistory] = useState(() => {
    if (typeof window !== 'undefined') {
      const saved = localStorage.getItem('miniflix-history');
      return saved ? JSON.parse(saved) : [];
    }
    return [];
  });
  const [showHistory, setShowHistory] = useState(false);
  const [showPaymentHistory, setShowPaymentHistory] = useState(false);
  const [showWatchlist, setShowWatchlist] = useState(false);

  const [theme, setTheme] = useState(() => {
    if (typeof window !== 'undefined') return localStorage.getItem('miniflix-theme') || 'dark';
    return 'dark';
  });
  const [language, setLanguage] = useState(() => {
    if (typeof window !== 'undefined') return localStorage.getItem('miniflix-lang') || 'en';
    return 'en';
  });
  
  const [showSettings, setShowSettings] = useState(false);
  const [isLangMenuOpen, setIsLangMenuOpen] = useState(false); 
  const searchRef = useRef(null);
  const filterRef = useRef(null);

  const t = getT(language);
  // --- 🔙 SMART BACK BUTTON LOGIC (ব্যাক বাটন ফিক্স) ---
  useEffect(() => {
    // যখনই প্লেয়ার বা কোনো পপ-আপ ওপেন হবে, ফোনকে বোঝানো হবে যে নতুন পেজ এসেছে
    const isAnyModalOpen = view === 'player' || isMenuOpen || isAiOpen || showSettings || showHistory || showWatchlist || showPaymentHistory || showPremiumModal || showSmartDownload;
    
    if (isAnyModalOpen) {
      window.history.pushState({ noExit: true }, "");
    }
  }, [view, isMenuOpen, isAiOpen, showSettings, showHistory, showWatchlist, showPaymentHistory, showPremiumModal, showSmartDownload]);

  useEffect(() => {
    // ইউজার ব্যাক বাটনে চাপলে এই ফাংশনটি কাজ করবে (ধাপে ধাপে বন্ধ করার লজিক)
    const handleBackButton = () => {
      if (showSmartDownload) { setShowSmartDownload(false); return; }
      if (showPremiumModal) { setShowPremiumModal(false); return; }
      if (showPaymentHistory) { setShowPaymentHistory(false); return; }
      if (showWatchlist) { setShowWatchlist(false); return; }
      if (showHistory) { setShowHistory(false); return; }
      if (showSettings) { setShowSettings(false); return; }
      if (isAiOpen) { setIsAiOpen(false); return; }
      if (isMenuOpen) { setIsMenuOpen(false); return; }
      if (view === 'player') { setView('home'); return; }
    };

    window.addEventListener('popstate', handleBackButton);
    return () => window.removeEventListener('popstate', handleBackButton);
  }, [view, isMenuOpen, isAiOpen, showSettings, showHistory, showWatchlist, showPaymentHistory, showPremiumModal, showSmartDownload]);

  // Update Welcome Message when Language Changes
  useEffect(() => {
    setAiMessages(prev => {
      // Only update if the first message is from the model (Welcome Message)
      if (prev.length > 0 && prev[0].role === 'model') {
         const newMsgs = [...prev];
         newMsgs[0] = { ...newMsgs[0], text: t.aiWelcome };
         return newMsgs;
      }
      return prev;
    });
  }, [language, t.aiWelcome]);

  // --- PWA MANIFEST INJECTION ---
  useEffect(() => {
    const manifest = {
      "name": "ZiniPlay",
      "short_name": "ZiniPlay",
      "start_url": ".",
      "display": "standalone",
      "background_color": "#000000",
      "theme_color": "#dc2626",
      "orientation": "portrait-primary",
"icons": [
        {
          "src": "https://i.imgur.com/6fubsgM.jpeg", 
          "sizes": "192x192",
          "type": "image/jpeg",
          "purpose": "any maskable"
        },
        {
          "src": "https://i.imgur.com/6fubsgM.jpeg",
          "sizes": "512x512",
          "type": "image/jpeg",
          "purpose": "any maskable"
        }
      ]
    };
    const stringManifest = JSON.stringify(manifest);
    const blob = new Blob([stringManifest], {type: 'application/json'});
    const manifestURL = URL.createObjectURL(blob);
    
    let link = document.querySelector('link[rel="manifest"]');
    if (!link) {
      link = document.createElement('link');
      link.rel = 'manifest';
      document.head.appendChild(link);
    }
    link.href = manifestURL;
  }, []);

  // --- PWA INSTALL PROMPT LISTENER ---
  useEffect(() => {
    const handleBeforeInstallPrompt = (e) => {
      e.preventDefault();
      setInstallPrompt(e);
    };
    window.addEventListener('beforeinstallprompt', handleBeforeInstallPrompt);
    return () => {
      window.removeEventListener('beforeinstallprompt', handleBeforeInstallPrompt);
    };
  }, []);

  const handleInstallClick = async () => {
    if (!installPrompt) return;
    installPrompt.prompt();
    const { outcome } = await installPrompt.userChoice;
    if (outcome === 'accepted') {
      setInstallPrompt(null);
    }
  };

  useEffect(() => { localStorage.setItem('miniflix-theme', theme); }, [theme]);
  useEffect(() => { localStorage.setItem('miniflix-lang', language); }, [language]);
  useEffect(() => { 
      // Local Sync
      localStorage.setItem('miniflix-history', JSON.stringify(watchHistory)); 
      
      // Cloud Sync (If Logged In)
      if (user && !user.isAnonymous && watchHistory.length > 0) {
          const syncHistory = async () => {
              const userDocRef = doc(db, 'artifacts', appId, 'users', user.uid, 'data', 'history');
              try {
                  await setDoc(userDocRef, { history: watchHistory }, { merge: true });
              } catch(e) { console.error("History sync error:", e); }
          };
          const timeout = setTimeout(syncHistory, 2000);
          return () => clearTimeout(timeout);
      }
  }, [watchHistory, user]);

  useEffect(() => {
    function handleClickOutside(event) {
      if (filterRef.current && !filterRef.current.contains(event.target)) {
        setActiveFilterIndex(null);
      }
    }
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, [filterRef]);

  // --- FIREBASE AUTHENTICATION ---
  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, async (u) => { 
      if (u) {
          setUser(u);
          // Load History from Cloud if User is Real
          if (!u.isAnonymous) {
              const fetchHistory = async () => {
                  try {
                      const docRef = doc(db, 'artifacts', appId, 'users', u.uid, 'data', 'history');
                      const docSnap = await getDoc(docRef);
                      if (docSnap.exists() && docSnap.data().history) {
                          setWatchHistory(prev => {
                              const cloudHist = docSnap.data().history;
                              const combined = [...cloudHist, ...prev.filter(p => !cloudHist.some(c => c.id === p.id))];
                              return combined.slice(0, 50);
                          });
                      }
                  } catch(e) { console.error("Fetch history error", e); }
              };
              fetchHistory();
          }
      } else {
          // ইউজার লগিন না থাকলে তখন শুধুমাত্র গেস্ট (Anonymous) হিসেবে ডাটাবেসে কানেক্ট করাবে
          setUser(null);
          try {
            await signInAnonymously(auth);
          } catch (e) {
            console.error("Auth error:", e);
          }
      }
    });
    return () => unsubscribe();
  }, []);

  // --- FIREBASE DATA FETCHING (UPDATED FOR COINS) ---
  useEffect(() => {
    if (!user) return;
    
    // 1. PROFILE DATA (Coins, Premium, Watchlist & Expiry Check)
    if (user.isAnonymous) {
      // --- GUEST USER LOGIC ---
      const savedCoins = localStorage.getItem('miniflix_coins');
      const savedPremium = localStorage.getItem('miniflix_premium');
      const savedExpiry = localStorage.getItem('miniflix_premium_expiry'); 
      const savedPlanName = localStorage.getItem('miniflix_plan_name') || 'VIP Trial'; 
      setActivePlanName(savedPlanName);
      
      const savedList = JSON.parse(localStorage.getItem('miniflix_watchlist') || '[]');
      setUserWatchlist(savedList);
      setCoins(savedCoins ? Number(savedCoins) : 0);

      let isGuestPremium = savedPremium === 'true';
      if (isGuestPremium && savedExpiry) {
          const now = new Date();
          const expiry = new Date(savedExpiry);
          
          if (now > expiry) {
              console.log("Guest Plan Expired!");
              localStorage.setItem('miniflix_premium', 'false');
              localStorage.removeItem('miniflix_premium_expiry');
              isGuestPremium = false;
          } else {
              setPremiumExpiryDate(expiry);
          }
      }
      setIsPremium(isGuestPremium);
    } else {
      // --- LOGGED IN USER LOGIC ---
      const fetchUserProfile = async () => {
        try {
          const userDocRef = doc(db, 'artifacts', appId, 'users', user.uid);
          const docSnap = await getDoc(userDocRef);
          
          if (docSnap.exists()) {
            const data = docSnap.data();
            setUserWatchlist(data.watchlist || []);
            setCoins(data.coins || 0);
            setActivePlanName(data.planName || 'VIP');

            // 🔥 PREMIUM CHECK LOGIC 🔥
            let isUserPremium = data.isPremium === true;
            
            if (isUserPremium && data.premiumExpiry) {
                const now = new Date();
                const expiry = data.premiumExpiry.toDate(); 
                
                if (now > expiry) {
                    console.log("Plan Expired! Removing Premium...");
                    isUserPremium = false;
                    await updateDoc(userDocRef, { isPremium: false, isAdFree: false });
                } else {
                    setPremiumExpiryDate(expiry);
                }
            }

            const shouldRemoveAds = isUserPremium || (data.isAdFree === true);
            setIsPremium(shouldRemoveAds); 
            localStorage.setItem('ziniplay_premium', shouldRemoveAds);
            
            console.log("Profile Loaded: Ad Status Updated");
          }
        } catch (error) {
          console.log("Profile fetch error:", error);
        }
      };
      
      fetchUserProfile();
    }
  }, [user]);

  useEffect(() => {
    if (searchQuery.length > 0) {
      setSuggestions(movies.filter(m => (m.title || '').toLowerCase().includes(searchQuery.toLowerCase())));
    } else {
      setSuggestions([]);
    }
  }, [searchQuery, movies]);
// --- 5. SERVER-SIDE SEARCH & CATEGORY FILTER (UPDATED) ---
  useEffect(() => {
    const fetchData = async () => {
      setIsFetchingMore(true);
      try {
        // ইউজার হোম পেজে আছে কিনা তা চেক করা (কোনো সার্চ বা ফিল্টার ছাড়া)
        const isDefaultHome = searchQuery.trim().length === 0 && selectedCategory === 'All' && filterCountry === 'Any' && filterIndustry === 'Any' && filterYear === 'Any' && filterLang === 'Any' && filterGenre === 'Any';

        if (isDefaultHome) {
          // ১. গিটহাব থেকে সরাসরি JSON ডেটা রিড করা (Firebase Cost জিরো করতে)
          // দ্রষ্টব্য: গিটহাব ব্রাঞ্চের নাম main না হয়ে master হলে url-এ main পরিবর্তন করে master দেবেন
          const response = await fetch('https://raw.githubusercontent.com/zinix-dev-munna/miniflix-data/refs/heads/main/home_data.json?t=' + new Date().getTime(), { cache: "no-store" });
          const rawData = await response.json();
          
          let data = rawData;
          // 🔓 DECRYPTION LOGIC
          if (rawData.encrypted && rawData.data) {
              try {
                  const SECRET_KEY = "ZINIPLAY_SECURE_VAULT_2024";
                  const decoded = atob(rawData.data);
                  let result = '';
                  for(let i = 0; i < decoded.length; i++) {
                      result += String.fromCharCode(decoded.charCodeAt(i) ^ SECRET_KEY.charCodeAt(i % SECRET_KEY.length));
                  }
                  data = JSON.parse(decodeURIComponent(result));
              } catch(e) {
                  console.error("Decryption failed", e);
                  setMovies([]);
                  return;
              }
          }

          // সেকশন অনুযায়ী ট্যাগ লাগিয়ে দেওয়া (যাতে UI তে ঠিকঠাক শো করে)
          const homeData = data.home || [];
          const trendingData = (data.trending || []).map(m => ({ ...m, isTrendingSection: true }));
          const newReleaseData = (data.newRelease || []).map(m => ({ ...m, isNewRelease: true }));

          // ৩টি লিস্ট এক জায়গায় করে ডুপ্লিকেট ডেটা রিমুভ ও ট্যাগ (Tag) মার্জ করা
          const combinedData = [...homeData, ...trendingData, ...newReleaseData];
          const uniqueMoviesMap = new Map();
          
          combinedData.forEach(movie => {
            if (!uniqueMoviesMap.has(movie.id)) {
              uniqueMoviesMap.set(movie.id, { ...movie });
            } else {
              // যদি মুভিটি আগে থেকেই থাকে, তবে তার ট্রেন্ডিং বা নিউ রিলিজ ট্যাগ যুক্ত করে দাও
              const existingMovie = uniqueMoviesMap.get(movie.id);
              if (movie.isTrendingSection) existingMovie.isTrendingSection = true;
              if (movie.isNewRelease) existingMovie.isNewRelease = true;
            }
          });
          const finalMovies = Array.from(uniqueMoviesMap.values());

          setMovies(finalMovies);
          console.log("গিটহাব থেকে আসা Trending মুভি:", trendingData);
console.log("গিটহাব থেকে আসা New Release মুভি:", newReleaseData);
console.log("সাকসেস! গিটহাব থেকে হোম পেজের ডেটা এসেছে:", finalMovies);

          // Featured Logic
          const banners = data.banners || [];
          const featured = [...banners, ...finalMovies.filter(m => m.isFeatured)];
          setFeaturedMovies(featured.length > 0 ? featured : finalMovies.slice(0, 5));

          // Load More (Pagination) এর জন্য কাস্টম lastVisible সেট করা
          if (data.home && data.home.length > 0) {
            const lastMovie = data.home[data.home.length - 1];
            setLastVisible({ isCustomJson: true, ...lastMovie });
            setHasMore(data.home.length >= 20); // ২০টা থাকলে আরও লোড হবে
          } else {
            setLastVisible(null);
            setHasMore(false);
          }
        } else {
          // ২. সার্চ বা ফিল্টার করলে সরাসরি ফায়ারবেস থেকে ডেটা আসবে
          const moviesRef = collection(db, 'artifacts', appId, 'public', 'data', 'movies');
          let constraints = [];

          if (searchQuery.trim().length > 0) {
            const lowerCaseQuery = searchQuery.trim().toLowerCase(); 
            constraints.push(orderBy('titleLower'));
            constraints.push(where('titleLower', '>=', lowerCaseQuery));
            constraints.push(where('titleLower', '<=', lowerCaseQuery + '\uf8ff'));
          } else {
            if (selectedCategory !== 'All') constraints.push(where('category', '==', selectedCategory));
            if (filterCountry !== 'Any') constraints.push(where('country', '==', filterCountry));
            if (filterIndustry !== 'Any') constraints.push(where('industry', '==', filterIndustry));
            if (filterYear !== 'Any') constraints.push(where('year', '==', filterYear));
            if (filterLang !== 'Any') constraints.push(where('lang', '==', filterLang));
            if (filterGenre !== 'Any') constraints.push(where('genre', '==', filterGenre));

            constraints.push(orderBy('createdAt', 'desc'));
          }

          constraints.push(limit(20));
          const q = query(moviesRef, ...constraints);
          const snapshot = await getDocs(q);
          
          const newMovies = snapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
          setMovies(newMovies);

          if (snapshot.docs.length > 0) {
              setLastVisible(snapshot.docs[snapshot.docs.length - 1]);
              setHasMore(snapshot.docs.length === 20); 
          } else {
              setLastVisible(null);
              setHasMore(false);
          }
        }
      } catch (error) {
        console.error("Fetch Error:", error);
      }
      setIsFetchingMore(false);
    };

    const timer = setTimeout(() => {
      fetchData();
    }, 500);
    return () => clearTimeout(timer);
  }, [searchQuery, selectedCategory, filterCountry, filterIndustry, filterYear, filterLang, filterGenre]);

  // --- 3. LOAD MORE MOVIES (UPDATED WITH FILTERS) ---
  const fetchMoreMovies = async () => {
    if (isFetchingMore || !hasMore || !lastVisible) return;
    setIsFetchingMore(true);
    try {
      const moviesRef = collection(db, 'artifacts', appId, 'public', 'data', 'movies');
      let constraints = [];

      // A. সার্চ মোড (সার্চ থাকলে ফিল্টার কাজ করবে না)
      if (searchQuery.trim().length > 0) {
        const lowerCaseQuery = searchQuery.trim().toLowerCase();
        constraints.push(orderBy('titleLower'));
        constraints.push(where('titleLower', '>=', lowerCaseQuery));
        constraints.push(where('titleLower', '<=', lowerCaseQuery + '\uf8ff'));
      }
      // B. ফিল্টার মোড
      else {
        // ১. ক্যাটাগরি
        if (selectedCategory !== 'All') {
            constraints.push(where('category', '==', selectedCategory));
        }
        // ২. নতুন ফিল্টারসমূহ (Country, Genre, etc.)
        if (filterCountry !== 'Any') constraints.push(where('country', '==', filterCountry));
        if (filterIndustry !== 'Any') constraints.push(where('industry', '==', filterIndustry));
        if (filterYear !== 'Any') constraints.push(where('year', '==', filterYear));
        if (filterLang !== 'Any') constraints.push(where('lang', '==', filterLang));
        if (filterGenre !== 'Any') constraints.push(where('genre', '==', filterGenre));

        // ৩. সর্টিং (নতুন গুলো আগে)
        constraints.push(orderBy('createdAt', 'desc'));
      }

      // কমন কনস্ট্রেইন্টস
      if (lastVisible && lastVisible.isCustomJson) {
          // JSON থেকে আসা ডেটা হলে createdAt ফিল্ড ধরে ফায়ারবেস থেকে পরের ডেটা আনবে
          constraints.push(startAfter(lastVisible.createdAt));
      } else {
          // ফায়ারবেস থেকে আসা ডেটা হলে স্ন্যাপশট ধরে আনবে
          constraints.push(startAfter(lastVisible));
      }
      constraints.push(limit(20));

      const q = query(moviesRef, ...constraints);
      
      const snapshot = await getDocs(q);
      if (!snapshot.empty) {
        const newMovies = snapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
        setMovies(prev => {
            const combined = [...prev, ...newMovies];
            const uniqueMoviesMap = new Map();
            combined.forEach(movie => {
                if(!uniqueMoviesMap.has(movie.id)){
                    uniqueMoviesMap.set(movie.id, movie);
                }
            });
            return Array.from(uniqueMoviesMap.values());
        });
        setLastVisible(snapshot.docs[snapshot.docs.length - 1]);
      } else {
        setHasMore(false);
      }
    } catch (error) {
      console.error("Load more error:", error);
    }
    setIsFetchingMore(false);
  };
  // --- 6. INFINITE SCROLL OBSERVER (RE-ADDED) ---
  const observer = useRef();
  const lastElementRef = useCallback(node => {
    if (isFetchingMore) return;
    if (observer.current) observer.current.disconnect();
    observer.current = new IntersectionObserver(entries => {
      if (entries[0].isIntersecting && hasMore) {
        fetchMoreMovies();
      }
    });
    if (node) observer.current.observe(node);
  }, [isFetchingMore, hasMore]);
  const showNotification = (msg) => { setNotification(msg); setTimeout(() => setNotification(null), 3000); };
  
  const addToHistory = (movie) => {
    const freshData = movies.find(m => m.id === movie.id) || movie;
    setWatchHistory(prev => {
      const newHistory = [freshData, ...prev.filter(m => m.id !== movie.id)];
      return newHistory.slice(0, 50); 
    });
  };

  const incrementViewCount = async (movieId) => {
    if (!user) return;
    
    // স্মার্ট লজিক: চেক করা হচ্ছে ইউজার আগে এই মুভিটি দেখেছে কি না
    const viewedKey = `viewed_movie_${movieId}`;
    if (localStorage.getItem(viewedKey)) {
      return; // আগে দেখে থাকলে এখান থেকেই ফেরত যাবে, ফায়ারবেসে রাইট হবে না
    }

    try {
      const movieRef = doc(db, 'artifacts', appId, 'public', 'data', 'movies', movieId);
      await updateDoc(movieRef, {
        views: increment(1)
      });
      
      // ফায়ারবেসে ভিউ বাড়ার পর ইউজারের ডিভাইসে সেটি মনে রাখার জন্য সেভ করা হলো
      localStorage.setItem(viewedKey, 'true');
    } catch (error) {
      console.error("Error updating views:", error);
    }
  };

  const handlePlayMovie = async (movie) => {
    // ১. প্রথমে চেক করবে মুভিটি বর্তমানে লোড হওয়া লিস্টে আছে কিনা (এতে ফায়ারবেস রিড বাঁচবে)
    let freshMovie = movies.find(m => m.id === movie.id);

    // ২. যদি লিস্টে না থাকে, তবে ফায়ারবেস থেকে চেক করবে মুভিটি আসলেও আছে নাকি অ্যাডমিন মুছে দিয়েছে
    if (!freshMovie) {
      try {
        const movieRef = doc(db, 'artifacts', appId, 'public', 'data', 'movies', movie.id);
        const snap = await getDoc(movieRef);
        
        if (!snap.exists()) {
          // মুভিটি ডাটাবেসে নেই
          const deleteMsgs = {
              en: "Sorry, this content has been deleted!",
              bn: "দুঃখিত, এই কন্টেন্টটি মুছে ফেলা হয়েছে!",
              es: "¡Lo siento, este contenido ha sido eliminado!",
              hi: "क्षमा करें, यह सामग्री हटा दी गई है!",
              ar: "عذرًا، تم حذف هذا المحتوى!",
              pt: "Desculpe, este conteúdo foi excluído!",
              ru: "Извините, этот контент был удален!",
              ja: "申し訳ありませんが、このコンテンツは削除されました！",
              zh: "抱歉，此内容已被删除！",
              de: "Entschuldigung, dieser Inhalt wurde gelöscht!",
              id: "Maaf, konten ini telah dihapus!"
          };
          showNotification(deleteMsgs[language] || deleteMsgs['en']);
          removeFromHistory(null, movie.id); // হিস্ট্রি থেকে অটো ডিলিট করে দেওয়া হলো
          return; // প্লেয়ার ওপেন হবে না, এখানেই থেমে যাবে
        }
        freshMovie = { id: snap.id, ...snap.data() };
      } catch (error) {
        console.error("Error checking movie:", error);
        freshMovie = movie; // নেটওয়ার্ক সমস্যা থাকলে আগের ডাটা দিয়ে প্লে করবে
      }
    }

    if (freshMovie) {
        setCurrentMovie(freshMovie);
        addToHistory(freshMovie);
        incrementViewCount(freshMovie.id);
        setView('player');
    }
  };
  // 🌟 ডিপ লিংকিং (Deep Linking) লজিক: শেয়ার করা লিংক থেকে সরাসরি মুভি প্লে করার জন্য 🌟
  useEffect(() => {
    const checkDeepLink = async () => {
      const urlParams = new URLSearchParams(window.location.search);
      const sharedMovieId = urlParams.get('movie');

      if (sharedMovieId) {
        // ১. চেক করবে হোম পেজে বা লিস্টে মুভিটি আগে থেকেই লোড করা আছে কি না
        let movieToPlay = movies.find(m => m.id === sharedMovieId);

        // ২. যদি না থাকে, তবে ফায়ারবেস থেকে সরাসরি মুভিটি খুঁজবে
        if (!movieToPlay) {
          try {
            const docRef = doc(db, 'artifacts', appId, 'public', 'data', 'movies', sharedMovieId);
            const docSnap = await getDoc(docRef);
            if (docSnap.exists()) {
              movieToPlay = { id: docSnap.id, ...docSnap.data() };
            }
          } catch (error) {
            console.error("Deep Link Error:", error);
          }
        }

        // ৩. মুভিটি পাওয়া গেলে সরাসরি প্লে করে দেবে
        if (movieToPlay) {
          handlePlayMovie(movieToPlay);
          // প্লে হওয়ার পর URL থেকে আইডি মুছে দেবে, যাতে ইউজার রিলোড দিলে বারবার একই মুভি প্লে না হয়
          window.history.replaceState({}, document.title, window.location.pathname);
        }
      }
    };

    // মুভি লিস্ট লোড হওয়ার পর এই ফাংশনটি চেক করবে
    if (movies && movies.length > 0) {
      checkDeepLink();
    }
  }, [movies]);

  const toggleWatchlist = async (movieId) => {
    // 1. GUEST USER LOGIC (Local Storage)
    if (!user || user.isAnonymous) {
        let newList;
        if (userWatchlist.includes(movieId)) {
            newList = userWatchlist.filter(id => id !== movieId); // Remove
            showNotification(t.removeFromWatchlist || "Removed from List");
        } else {
            newList = [...userWatchlist, movieId]; // Add
            showNotification(t.addToWatchlist || "Added to My List");
        }
        setUserWatchlist(newList);
        localStorage.setItem('miniflix_watchlist', JSON.stringify(newList));
        return;
    }

    // 2. LOGGED IN USER LOGIC (Firebase)
    const userDocRef = doc(db, 'artifacts', appId, 'users', user.uid);
    const isAdded = userWatchlist.includes(movieId);
    try {
      const docSnap = await getDoc(userDocRef);
      if (!docSnap.exists()) {
        await setDoc(userDocRef, { watchlist: [] });
      }
      await updateDoc(userDocRef, {
        watchlist: isAdded ? arrayRemove(movieId) : arrayUnion(movieId)
      });
      setUserWatchlist(prev => isAdded ? prev.filter(id => id !== movieId) : [...prev, movieId]);
      showNotification(isAdded ? (t.removeFromWatchlist || "Removed") : (t.addToWatchlist || "Added"));
    } catch (error) {
      console.error(error);
      showNotification("Error updating list");
    }
  };

  const handleShare = (movie) => {
    if (navigator.share) {
      navigator.share({
        title: movie.title,
        text: `Watch ${movie.title} on ZiniPlay!`,
        url: window.location.href
      }).catch(console.error);
    } else {
      navigator.clipboard.writeText(`${movie.title} - Watch on ZiniPlay`);
      showNotification("Link Copied!");
    }
  };

  const removeFromHistory = (e, movieId) => {
    if(e) e.stopPropagation();
    setWatchHistory(prev => {
      const newHistory = prev.filter(m => m.id !== movieId);
      if (newHistory.length === 0 && user && !user.isAnonymous) {
        const userDocRef = doc(db, 'artifacts', appId, 'users', user.uid, 'data', 'history');
        setDoc(userDocRef, { history: [] }, { merge: true }).catch(err => console.log("Clear sync error:", err));
      }
      return newHistory;
    });
  };

  const clearAllHistory = () => {
    setWatchHistory([]);
    if (user && !user.isAnonymous) {
      const userDocRef = doc(db, 'artifacts', appId, 'users', user.uid, 'data', 'history');
      setDoc(userDocRef, { history: [] }, { merge: true }).catch(err => console.log("Clear sync error:", err));
    }
    showNotification(t.historyCleared);
  };

  // KEEP DEMO DATA LOGIC FOR USERS IF NEEDED
  const loadCleanDemoData = async () => {
    if (!user) return;
    setIsSetupLoading(true);
    const cleanData = [
      { title: "Jawan", category: "Movie", year: "2023", genre: "Action", country: "India", industry: "Bollywood", lang: "Hindi", imdbRating: "7.5", views: 4500, poster: "https://upload.wikimedia.org/wikipedia/en/3/39/Jawan_film_poster.jpg", videoUrl: "https://www.youtube.com/watch?v=COv52Qyctws", trailerUrl: "https://www.youtube.com/watch?v=COv52Qyctws", isFeatured: true, isTrendingSection: true, description: "A high-octane action thriller.", isSeries: false },
      { title: "Demon Slayer", category: "Anime", year: "2019", genre: "Action", country: "Japan", industry: "Anime", lang: "Japanese", imdbRating: "8.7", views: 3500, poster: "https://upload.wikimedia.org/wikipedia/en/2/21/Kimetsu_no_Yaiba_Mugen_Ressha_Hen_Poster.jpg", isFeatured: true, isTrendingSection: true, description: "Tanjiro Kamado's journey.", trailerUrl: "https://www.youtube.com/watch?v=21X5lGlDOfg", isSeries: true },
      { title: "Stranger Things", category: "Web Series", year: "2016", genre: "Sci-Fi", country: "USA", industry: "Hollywood", lang: "English", imdbRating: "8.7", views: 2100, poster: "https://upload.wikimedia.org/wikipedia/en/7/78/Stranger_Things_season_4.jpg", isFeatured: false, isTrendingSection: true, description: "Strange things happen.", trailerUrl: "https://www.youtube.com/watch?v=yQEondeGvKo", isSeries: true },
      { title: "Avatar 2", category: "Movie", year: "2022", genre: "Sci-Fi", country: "USA", industry: "Hollywood", lang: "English", imdbRating: "7.6", views: 1200, poster: "https://upload.wikimedia.org/wikipedia/en/5/54/Avatar_The_Way_of_Water_poster.jpg", isFeatured: true, isTrendingSection: true, description: "Jake Sully lives with his newfound family.", trailerUrl: "https://www.youtube.com/watch?v=d9MyqW3xTuE", isSeries: false },
      { title: "Tom & Jerry", category: "Animation", year: "1940", genre: "Comedy", country: "USA", industry: "Hollywood", lang: "English", imdbRating: "9.0", views: 900, poster: "https://upload.wikimedia.org/wikipedia/en/5/5f/TomandJerryTitleCardc.jpg", isFeatured: false, isTrendingSection: true, description: "Classic cat and mouse.", trailerUrl: "https://www.youtube.com/watch?v=kY7Z9c0fKjM", isSeries: true },
    ];

    try {
      for (const m of cleanData) {
        const docRef = await addDoc(collection(db, 'artifacts', appId, 'public', 'data', 'movies'), { ...m, createdAt: serverTimestamp() });
        if (m.isSeries) {
           const epsRef = collection(db, 'artifacts', appId, 'public', 'data', 'movies', docRef.id, 'episodes');
           await addDoc(epsRef, { title: "Pilot", season: "1", episode: "1", videoUrl: "https://www.youtube.com/watch?v=dQw4w9WgXcQ" });
        }
      }
      showNotification("Demo data loaded!");
    } catch (e) { showNotification(e.message); }
    setIsSetupLoading(false);
  };

  // --- GOOGLE LOGIN HANDLER (Updated for Database Save) ---
  const handleGoogleLogin = async () => {
    const provider = new GoogleAuthProvider();
    try {
        // ১. লগিন পপআপ ওপেন হবে
        const result = await signInWithPopup(auth, provider);
        const user = result.user;

        // ২. ডাটাবেসে ইউজারের তথ্য সেভ করা (খুব গুরুত্বপূর্ণ)
        const userRef = doc(db, 'artifacts', appId, 'users', user.uid);
        const userSnap = await getDoc(userRef);

        if (!userSnap.exists()) {
            // যদি নতুন ইউজার হয়, তবে ডাটাবেসে সেভ হবে
            await setDoc(userRef, {
                email: user.email,
                name: user.displayName || 'No Name',
                photo: user.photoURL || '',
                isPremium: false,
                isAdFree: false, // ডিফল্টভাবে অ্যাড অন থাকবে
                createdAt: serverTimestamp(), // অ্যাডমিন প্যানেলে সর্টিংয়ের জন্য জরুরি
                uid: user.uid
            });
            console.log("New User Saved to Database! ✅");
        } else {
            console.log("User already exists in Database.");
        }

        showNotification("Logged In Successfully");
        setLoginError(null);
    } catch (error) {
        console.error("Login failed Details:", error);
        let currentDomain = window.location.hostname;
        // ... আপনার এরর হ্যান্ডলিং কোড আগের মতোই থাকবে ...
        if (!currentDomain || currentDomain === "") {
            try {
                const origin = window.location.origin;
                if (origin && origin !== 'null') {
                    currentDomain = origin.replace(/^https?:\/\//, '');
                }
            } catch (e) {
                currentDomain = "Manually URL bar theke link copy koro";
            }
        }
        setLoginError({
            code: error.code,
            message: error.message,
            domain: currentDomain
        });
    }
  };
  // --- UPDATE MODAL COMPONENT ---
  function UpdateModal() {
    // --- CAPACITOR CHECK (Android App vs Website) ---
    // এই কোড চেক করবে এটি আসল অ্যাপ (Native) নাকি ওয়েবসাইট।
    // Capacitor অটোমেটিক window.Capacitor ইনজেক্ট করে যখন এটি অ্যাপ হিসেবে চলে।
    const isApp = typeof window !== 'undefined' && window?.Capacitor?.isNativePlatform();

    // যদি এটি অ্যাপ না হয় (মানে ওয়েবসাইট), তাহলে আপডেট পপ-আপ দেখাবে না (রিটার্ন নাল)।
    // এর ফলে ওয়েবসাইটে ফোর্স আপডেট থাকলেও ওয়েবসাইট নতুনের মতো চলবে।
    if (!isApp) return null;
    if (!updateInfo) return null;
    const isForceUpdate = updateInfo.forceUpdate === true; // এডমিন যদি জোর করে আপডেট করাতে চায়

    return (
      <div className="fixed inset-0 z-[99999] flex items-center justify-center p-4 bg-black/90 backdrop-blur-md animate-in fade-in">
        <div className="bg-gray-900 border border-red-600 rounded-2xl p-6 max-w-sm w-full text-center shadow-[0_0_50px_rgba(220,38,38,0.3)] relative">
          
          {/* আইকন */}
          <div className="mx-auto bg-red-600/20 w-16 h-16 rounded-full flex items-center justify-center mb-4 animate-bounce">
             <RefreshCcw size={32} className="text-red-500" />
          </div>

          <h2 className="text-2xl font-black text-white mb-2">New Update Available!</h2>
          <p className="text-gray-400 text-sm mb-6">
            Version <span className="text-red-500 font-bold">{updateInfo.latestVersion}</span> is now available. 
            {isForceUpdate ? " You must update to continue." : " Update for better experience."}
          </p>

          {/* আপডেট বাটন */}
          <button 
            onClick={() => window.open(updateInfo.updateUrl || '#', '_blank')}
            className="w-full py-3 bg-red-600 hover:bg-red-700 text-white font-bold rounded-xl shadow-lg transition-transform active:scale-95 flex items-center justify-center gap-2 mb-3"
          >
             <Download size={20}/> Update Now
          </button>

          {/* যদি Force Update না হয়, তাহলে ক্লোজ বাটন দেখাবে */}
          {!isForceUpdate && (
             <button 
               onClick={() => setUpdateInfo(null)}
               className="text-gray-500 text-xs font-bold hover:text-white transition uppercase tracking-wider"
             >
               Skip for now
             </button>
          )}
        </div>
      </div>
    );
  }
  // --- NEW: SEQUENTIAL PROMO COMPONENT ---
function SequentialPromoModal() {
  if (!currentPromo) return null;

  return (
    <div className="fixed inset-0 z-[9999] flex items-center justify-center p-4 bg-black/80 backdrop-blur-sm animate-in zoom-in duration-300">
      <div className="bg-gray-900 border border-red-600/50 rounded-2xl max-w-sm w-full overflow-hidden shadow-2xl relative">
        <button onClick={handleClosePromo} className="absolute top-2 right-2 bg-black/50 text-white p-1 rounded-full hover:bg-red-600 transition z-10"><X size={20}/></button>
        
        {currentPromo.image && (
          <img src={currentPromo.image} alt={currentPromo.title} className="w-full h-48 object-cover" />
        )}
        
        <div className="p-5 text-center">
          <h3 className="text-xl font-bold text-white mb-2">{currentPromo.title}</h3>
          <p className="text-gray-300 text-sm mb-4 whitespace-pre-wrap">{currentPromo.message}</p>
          
          <div className="flex flex-col gap-2">
            {currentPromo.buttons?.map((btn, idx) => (
              <button 
                key={idx}
                onClick={() => window.open(btn.url, '_blank')}
                className={`py-2 px-4 rounded-lg font-bold text-sm transition ${idx === 0 ? 'bg-red-600 text-white hover:bg-red-700' : 'bg-gray-700 text-white hover:bg-gray-600'}`}
              >
                {btn.text}
              </button>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}

// --- NEW: SMART DOWNLOAD MODAL ---
// --- UPDATED: SMART DOWNLOAD MODAL (FILTERED) ---
  function SmartDownloadModal() {
    if (!showSmartDownload) return null;

    // ১. ডাটা ফিল্টার লজিক
    const pcLink = appLinks.find(l => l.type === 'pc');
    // যদি টাইপ 'mobile' হয়, তবে পিসি দেখাবে না। অন্যথায় দেখাবে।
    const showPcSection = (downloadType === 'pc' || downloadType === 'all');
    
    // যদি টাইপ 'pc' হয়, তবে মোবাইল লিংক দেখাবে না।
    const mobileLinks = appLinks.filter(l => l.type === 'mobile');
    const showMobileSection = (downloadType === 'mobile' || downloadType === 'all');

    return (
      <div className="fixed inset-0 z-[9999] flex items-center justify-center p-4 bg-black/90 backdrop-blur-sm animate-in fade-in">
        <div className="bg-gray-900 border border-gray-700 rounded-xl w-full max-w-sm p-6 relative shadow-2xl">
          <button onClick={() => setShowSmartDownload(false)} className="absolute top-3 right-3 text-gray-500 hover:text-white"><X size={24}/></button>
          
          <h2 className="text-xl font-bold text-white mb-4 flex items-center gap-2">
            <Download className="text-red-600"/> Download App
          </h2>
          
          <div className="space-y-3">
            
            {/* --- PC DOWNLOAD SECTION --- */}
            {showPcSection && !isMobile && (
                <div className="bg-black/50 p-3 rounded-lg border border-gray-800 flex items-center justify-between group hover:border-red-600 transition">
                  <div className="flex items-center gap-3">
                    <div className="bg-gray-800 p-2 rounded-full group-hover:bg-red-600 transition">
                      <Monitor size={20} className="text-white"/>
                    </div>
                    <div>
                      <h4 className="font-bold text-sm text-white">Windows / PC</h4>
                      <p className="text-[10px] text-gray-400">Desktop Version</p>
                    </div>
                  </div>
                  
                  {/* পিসি লিংক থাকলে সেটি খুলবে, না থাকলে PWA বাটন দেখাবে */}
                  {pcLink ? (
                     <button onClick={() => window.open(pcLink.url, '_blank')} className="bg-white text-black px-3 py-1.5 rounded text-xs font-bold hover:bg-gray-200">
                       Download
                     </button>
                  ) : (
                      <button 
                       onClick={() => {
                          if(installPrompt) {
                              handleInstallClick();
                              setShowSmartDownload(false);
                          }
                       }} 
                       className="bg-white text-black px-3 py-1.5 rounded text-xs font-bold hover:bg-gray-200"
                     >
                       {installPrompt ? "Install App" : "Installed"}
                      </button>
                  )}
                </div>
            )}

            {/* --- MOBILE DOWNLOAD SECTION --- */}
            {showMobileSection && (
              mobileLinks.length > 0 ? (
                mobileLinks.map((link, idx) => (
                  <div key={idx} className="bg-black/50 p-3 rounded-lg border border-gray-800 flex items-center justify-between group hover:border-red-600 transition">
                    <div className="flex items-center gap-3">
                      <div className="bg-gray-800 p-2 rounded-full group-hover:bg-red-600 transition">
                        <Tv size={20} className="text-white"/>
                      </div>
                      <div>
                        <h4 className="font-bold text-sm text-white">{link.title}</h4>
                        <p className="text-[10px] text-gray-400">Mobile Version</p>
                      </div>
                    </div>
                    <button onClick={() => window.open(link.url, '_blank')} className="bg-white text-black px-3 py-1.5 rounded text-xs font-bold hover:bg-gray-200">
                      Get
                    </button>
                  </div>
                ))
              ) : (
                // মোবাইল সেকশন অন আছে কিন্তু লিংক নেই
                 showMobileSection && <p className="text-gray-500 text-xs text-center py-2">Mobile app coming soon.</p>
              )
            )}

          </div>
        </div>
      </div>
    );
  }

  // --- Helper Components ---
  function LoginErrorModal() {
    if (!loginError) return null;
    const isDomainError = loginError.code === 'auth/unauthorized-domain';
    
    return (
        <div className="fixed inset-0 z-[200] flex items-center justify-center p-4 bg-black/90 backdrop-blur-sm animate-in fade-in">
            <div className="bg-gray-900 border border-red-500 rounded-xl p-6 max-w-md w-full text-white shadow-2xl relative">
                <button onClick={() => setLoginError(null)} className="absolute top-3 right-3 text-gray-400 hover:text-white"><X size={20}/></button>
                <h3 className="text-xl font-bold text-red-500 mb-4 flex items-center gap-2">
                    <AlertTriangle/> Login Error
                </h3>
                {isDomainError ? (
                    <>
                        <div className="bg-yellow-600/20 border border-yellow-600/50 p-3 rounded mb-4">
                            <p className="text-sm text-yellow-200 font-bold">⚠️ LINK BODLE GECHE!</p>
                            <p className="text-xs text-gray-300 mt-1">
                                Canvas update hole majhe majhe notun Link toiri hoy. Doya kore nicher <b>NOTUN LINK</b> ti abar Firebase e add koro.
                            </p>
                        </div>
                        <div className="bg-black p-3 rounded border border-gray-700 mb-4">
                            <label className="text-[10px] text-gray-500 uppercase font-bold block mb-1">Notun Link Copy Koro:</label>
                            <code className="text-green-400 text-xs break-all select-all block bg-gray-900 p-2 rounded border border-gray-800">
                                {loginError.domain || "Domain paoa jacche na, URL bar check koro"}
                            </code>
                        </div>
                    </>
                ) : (
                    <div className="bg-red-900/20 p-3 rounded border border-red-900/50 mb-4 text-sm font-mono text-red-200 break-words">
                        {loginError.message}
                    </div>
                )}
                <button onClick={() => setLoginError(null)} className="w-full bg-gray-700 hover:bg-gray-600 py-3 rounded font-bold text-sm">Close Popup</button>
            </div>
        </div>
    );
  }

  const countries = ['USA', 'India', 'Japan', 'Korea', 'UK', 'China', 'Spain', 'Other'];
  const industries = ['Hollywood', 'Bollywood', 'Anime', 'K-Drama', 'Tollywood', 'Lollywood', 'Other'];
  const genres = ['Action', 'Adventure', 'Comedy', 'Drama', 'Horror', 'Sci-Fi', 'Thriller', 'Romance', 'Fantasy', 'K-Drama', 'Other'];
  const contentLanguages = ['English', 'Hindi', 'Bengali', 'Japanese', 'Korean', 'Spanish', 'Arabic', 'Other'];
  const currentYear = new Date().getFullYear();
  const years = [...Array.from({length: 40}, (_, i) => (currentYear + 2 - i).toString()), 'Other'];

  const styles = {
    bg: theme === 'dark' ? 'bg-black' : 'bg-gray-50',
    text: theme === 'dark' ? 'text-white' : 'text-gray-900',
    subText: theme === 'dark' ? 'text-gray-400' : 'text-gray-600',
    nav: theme === 'dark' ? 'bg-black/90 border-gray-800' : 'bg-white/90 border-gray-200 shadow-sm',
    card: theme === 'dark' ? 'bg-gray-800' : 'bg-white shadow-md border border-gray-100',
    input: theme === 'dark' ? 'bg-gray-800 text-white' : 'bg-gray-100 text-gray-900',
    button: theme === 'dark' ? 'hover:bg-gray-800' : 'hover:bg-gray-100',
    pillActive: 'bg-red-600 text-white',
    pillInactive: theme === 'dark' ? 'bg-gray-800 text-gray-400' : 'bg-gray-200 text-gray-600',
    modal: theme === 'dark' ? 'bg-gray-900 text-white border-gray-700' : 'bg-white text-gray-900 border-gray-200',
    filterBar: theme === 'dark' ? 'bg-gray-900 border-gray-800' : 'bg-white border-gray-200',
    dropdown: theme === 'dark' ? 'bg-gray-900 border-gray-700 text-white' : 'bg-white border-gray-300 text-gray-900',
  };

  const languages = [
    { code: 'en', name: 'English' }, { code: 'bn', name: 'বাংলা' }, { code: 'es', name: 'Español' }, { code: 'hi', name: 'हिन्दी' },
    { code: 'ar', name: 'العربية' }, { code: 'pt', name: 'Português' }, { code: 'ru', name: 'Русский' }, { code: 'ja', name: '日本語' },
    { code: 'zh', name: '中文' }, { code: 'de', name: 'Deutsch' }, { code: 'id', name: 'Bahasa Indonesia' },
  ];

  function Notification() {
    if (!notification) return null;
    return (
      <div className="fixed bottom-20 left-1/2 transform -translate-x-1/2 bg-red-600 text-white px-4 py-2 rounded-full shadow-lg z-[70] animate-fade-in-up flex items-center gap-2">
        <CheckCircle size={16} /> {notification}
      </div>
    );
  };

  function HeroSlider() {
    const [currentIndex, setCurrentIndex] = useState(0);
    const [isPaused, setIsPaused] = useState(false); // NEW: Pause state
    
    // সোয়াইপ (Touch/Swipe) ট্র্যাক করার জন্য নতুন স্টেট
    const [touchStart, setTouchStart] = useState(null);
    const [touchEnd, setTouchEnd] = useState(null);

    useEffect(() => {
      if (featuredMovies.length <= 1 || isPaused) return;
      // Increased time from 5000ms to 7000ms (7 seconds)
      const interval = setInterval(() => setCurrentIndex((prev) => (prev + 1) % featuredMovies.length), 7000);
      return () => clearInterval(interval);
    }, [featuredMovies.length, isPaused]);

    const nextSlide = () => setCurrentIndex((prev) => (prev + 1) % featuredMovies.length);
    const prevSlide = () => setCurrentIndex((prev) => (prev - 1 + featuredMovies.length) % featuredMovies.length);

    // টাচ বা সোয়াইপ করার লজিক
    const minSwipeDistance = 50; // কতোটুকু টানলে স্লাইড চেঞ্জ হবে
    
    const onTouchStart = (e) => {
      setTouchEnd(null);
      setTouchStart(e.targetTouches[0].clientX);
    };
    
    const onTouchMove = (e) => setTouchEnd(e.targetTouches[0].clientX);
    
    const onTouchEnd = () => {
      if (!touchStart || !touchEnd) return;
      const distance = touchStart - touchEnd;
      const isLeftSwipe = distance > minSwipeDistance;
      const isRightSwipe = distance < -minSwipeDistance;
      
      if (isLeftSwipe) nextSlide(); // বামে টানলে পরের স্লাইড
      if (isRightSwipe) prevSlide(); // ডানে টানলে আগের স্লাইড
    };

    if (featuredMovies.length === 0) return null;
    
    return (
      <div 
        // Adjusted heights based on feedback: shorter on mobile, clear on PC
        className="relative h-[35vh] sm:h-[40vh] md:h-[60vh] lg:h-[65vh] w-full group overflow-hidden bg-black"
        onTouchStart={(e) => { setIsPaused(true); onTouchStart(e); }}
        onTouchMove={onTouchMove}
        onTouchEnd={(e) => { setIsPaused(false); onTouchEnd(e); }}
        onMouseEnter={() => setIsPaused(true)}
        onMouseLeave={() => setIsPaused(false)}
      >
        <div className="flex h-full w-full transition-transform duration-700 ease-in-out" style={{ transform: `translateX(-${currentIndex * 100}%)` }}>
          {featuredMovies.map((movie) => (
            <div key={movie.id} className="min-w-full h-full relative">
              {/* BACKDROP IMAGE: Full opacity, no dimming so it's clear */}
              <img src={movie.banner || movie.poster} className="w-full h-full object-cover" alt={movie.title} />
              
              {/* GRADIENTS: Balanced for visibility and text readability */}
              <div className={`absolute inset-0 bg-gradient-to-t ${theme === 'dark' ? 'from-[#0f0f11] via-[#0f0f11]/70 md:via-[#0f0f11]/20' : 'from-gray-100 via-gray-100/70 md:via-white/20'} to-transparent`} />
              <div className={`hidden md:block absolute inset-0 bg-gradient-to-r ${theme === 'dark' ? 'from-[#0f0f11] via-[#0f0f11]/70' : 'from-gray-100 via-gray-100/70'} to-transparent w-[75%]`} />

              {/* CONTENT CONTAINER */}
              <div className={`absolute inset-0 flex flex-col md:flex-row items-center justify-end md:justify-start pb-4 md:pb-0 px-4 md:px-16 z-10 gap-3 md:gap-8 ${language === 'ar' ? 'md:flex-row-reverse text-right' : ''}`}>
                 
                 {/* FLOATING POSTER (Smaller on mobile to fit the new height) */}
                 <div className="w-20 sm:w-28 md:w-56 shrink-0 rounded-lg md:rounded-xl overflow-hidden shadow-[0_10px_30px_rgba(0,0,0,0.8)] border border-white/10 relative transform hover:scale-105 transition duration-500 mt-auto md:mt-0">
                    <img src={movie.poster} className="w-full h-full aspect-[2/3] object-cover" alt={movie.title} />
                 </div>

                 {/* TEXT INFO */}
                 <div className={`w-full md:w-1/2 flex flex-col items-center md:items-start text-center md:text-left`}>
                     <span className="bg-red-600 text-white text-[10px] md:text-xs px-2 md:px-3 py-1 rounded-sm font-bold mb-1.5 md:mb-3 shadow-md uppercase tracking-wider">{t.featured || 'Featured'}</span>
                     
                     <h2 className={`text-lg sm:text-2xl md:text-4xl lg:text-5xl font-black mb-1 md:mb-3 drop-shadow-xl line-clamp-1 md:line-clamp-2 ${theme === 'light' ? 'text-gray-900' : 'text-white'}`} style={{textShadow: '0 2px 10px rgba(0,0,0,0.8)'}}>{movie.title}</h2>
                     
                     <p className={`hidden md:block text-sm md:text-base mb-6 line-clamp-3 drop-shadow-md ${theme === 'light' ? 'text-gray-800 font-semibold' : 'text-gray-200'}`}>{movie.description}</p>
                     
                     <button onClick={() => { if (movie.actionUrl) { window.open(movie.actionUrl, '_blank'); } else { handlePlayMovie(movie); } }} className="bg-red-600 text-white px-5 md:px-8 py-1.5 md:py-3 rounded-full text-xs md:text-base font-bold flex items-center justify-center gap-2 hover:bg-red-700 shadow-[0_4px_15px_rgba(220,38,38,0.5)] transition-all transform hover:scale-105 hover:-translate-y-1">
                         {movie.actionUrl ? <ExternalLink size={18} className="w-3 h-3 md:w-5 md:h-5" /> : <Play fill="white" size={18} className="w-3 h-3 md:w-5 md:h-5" />} 
                         {movie.actionUrl ? (language === 'bn' ? 'ভিজিট করুন' : 'Visit Link') : t.playNow}
                     </button>
                 </div>
              </div>
            </div>
          ))}
        </div>
        
        {featuredMovies.length > 1 && (
          <>
            {/* মোবাইলে তীর চিহ্ন হাইড করে দেওয়া হয়েছে, কারণ এখন হাত দিয়ে স্লাইড করা যাবে */}
            <button onClick={prevSlide} className="hidden md:block absolute left-4 top-1/2 -translate-y-1/2 bg-black/30 p-3 rounded-full text-white hover:bg-red-600 transition z-20 backdrop-blur-sm"><ChevronLeft size={28} /></button>
            <button onClick={nextSlide} className="hidden md:block absolute right-4 top-1/2 -translate-y-1/2 bg-black/30 p-3 rounded-full text-white hover:bg-red-600 transition z-20 backdrop-blur-sm"><ChevronRight size={28} /></button>
            
            <div className="absolute bottom-4 md:bottom-6 right-4 md:right-6 flex gap-2 z-20">
               {featuredMovies.map((_, idx) => (
                 <button key={idx} onClick={() => setCurrentIndex(idx)} className={`h-1.5 md:h-2 rounded-full transition-all duration-300 ${idx === currentIndex ? 'w-6 md:w-8 bg-red-600' : 'w-1.5 md:w-2 bg-gray-400/70 hover:bg-white'}`}/>
               ))}
            </div>
          </>
        )}
      </div>
    );
  };

  function HistoryModal() {
    const [menuOpenId, setMenuOpenId] = useState(null); 
    const activeList = showHistory ? watchHistory : userWatchlist.map(id => movies.find(m => m.id === id)).filter(Boolean);
    const title = showHistory ? t.history : t.watchlist;

    if (!showHistory && !showWatchlist) return null;
    
    return (
      <div className="fixed inset-0 z-[60] flex items-center justify-center p-4 bg-black/50 backdrop-blur-sm animate-in fade-in" style={{direction: 'ltr'}}>
        <div className={`w-full max-w-md rounded-2xl p-6 shadow-2xl border relative ${styles.modal} max-h-[80vh] overflow-y-auto custom-scrollbar`}>
          <button onClick={() => { setShowHistory(false); setShowWatchlist(false); }} className="absolute top-4 right-4 text-gray-500 hover:text-red-500 transition"><X size={24} /></button>
          <div className="flex justify-between items-center mb-6">
             <h2 className="text-xl font-bold flex items-center gap-2">
               {showHistory ? <History size={24} className="text-red-600" /> : <Heart size={24} className="text-red-600" />} 
               {title}
             </h2>
             {showHistory && watchHistory.length > 0 && <button onClick={clearAllHistory} className="text-xs text-red-500 hover:underline font-bold uppercase">{t.clearHistory}</button>}
          </div>
          
          <div className="space-y-3">
             {activeList.length === 0 ? (
               <p className={`text-center py-8 ${styles.subText}`}>{showHistory ? t.noHistory : t.noWatchlist}</p>
             ) : (
               activeList.map((m, i) => (
                 <div key={i} className={`relative flex items-center gap-3 p-2 rounded-lg ${theme === 'dark' ? 'hover:bg-gray-800' : 'hover:bg-gray-100'} transition group`}>
                    <div className="flex-1 flex items-center gap-3 cursor-pointer" onClick={() => { handlePlayMovie(m); setShowHistory(false); setShowWatchlist(false); }}>
                      <img src={m.poster} className="w-12 h-16 object-cover rounded" alt={m.title} />
                      <div className="flex-1 min-w-0">
                          <h4 className={`font-bold text-sm truncate ${styles.text}`}>{m.title}</h4>
                          <p className={`text-xs ${styles.subText}`}>{m.category}</p>
                      </div>
                    </div>
                    <button onClick={(e) => { e.stopPropagation(); setMenuOpenId(menuOpenId === m.id ? null : m.id); }} className={`p-2 rounded-full hover:bg-gray-600/50 ${styles.subText}`}><MoreVertical size={18} /></button>
                    {menuOpenId === m.id && (
                       <div className="absolute right-8 top-8 z-20 bg-gray-900 border border-gray-700 rounded shadow-xl p-1 min-w-[160px] animate-in fade-in slide-in-from-right-2 duration-200">
                          <button onClick={(e) => { showHistory ? removeFromHistory(e, m.id) : toggleWatchlist(m.id); setMenuOpenId(null); }} className="w-full text-left px-3 py-2 text-xs font-bold text-red-500 hover:bg-gray-800 rounded flex items-center gap-2"><Trash2 size={14} /> {t.removeFromHistory}</button>
                       </div>
                    )}
                 </div>
               ))
             )}
          </div>
        </div>
      </div>
    );
  }
  // --- PAYMENT HISTORY MODAL ---
  function PaymentHistoryModal() {
    const [transactions, setTransactions] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        // ১. মডাল বন্ধ থাকলে কিছু করার দরকার নেই
        if (!showPaymentHistory) return;

        // ২. ইউজার লগইন না থাকলে লোডিং বন্ধ এবং লিস্ট খালি
        if (!user) {
            setLoading(false);
            setTransactions([]);
            return;
        }

        setLoading(true);

        try {
            // ৩. কুয়েরি অপ্টিমাইজ করা হলো (Limit ব্যবহার করে)
            const q = query(
                collection(db, 'artifacts', appId, 'admin', 'data', 'transactions'),
                where("uid", "==", user.uid),
                orderBy("createdAt", "desc"), // নতুনগুলো আগে দেখাবে
                limit(10) // মাত্র ১০টি ডাটা লোড হবে
            );

            const unsub = onSnapshot(q, (snap) => {
                // ৪. ডাটা আসার পর জাভাস্ক্রিপ্ট দিয়ে সর্টিং (নতুন তারিখ আগে)
                const data = snap.docs.map(d => ({ id: d.id, ...d.data() }));
                
                // ম্যানুয়ালি সর্টিং করা হচ্ছে
                data.sort((a, b) => {
                    const timeA = a.createdAt?.seconds || 0;
                    const timeB = b.createdAt?.seconds || 0;
                    return timeB - timeA; // বড় থেকে ছোট (Desc)
                });

                setTransactions(data);
                setLoading(false);
            }, (error) => {
                console.error("History Error:", error);
                setLoading(false);
            });

            return () => unsub();
        } catch (err) {
            console.error(err);
            setLoading(false);
        }

    }, [showPaymentHistory, user]);

    if (!showPaymentHistory) return null;

    return (
      <div className="fixed inset-0 z-[60] flex items-center justify-center p-4 bg-black/50 backdrop-blur-sm animate-in fade-in" style={{direction: 'ltr'}}>
        <div className={`w-full max-w-md rounded-2xl p-6 shadow-2xl border relative ${styles.modal} max-h-[80vh] overflow-y-auto custom-scrollbar`}>
          <button onClick={() => setShowPaymentHistory(false)} className="absolute top-4 right-4 text-gray-500 hover:text-red-500 transition"><X size={24} /></button>
          
          <h2 className="text-xl font-bold mb-6 flex items-center gap-2">
             <CreditCard size={24} className="text-yellow-500" /> Payment History
          </h2>

          <div className="space-y-3">
             {loading ? (
                 <div className="text-center py-10"><Loader className="animate-spin mx-auto text-red-600"/></div>
             ) : transactions.length === 0 ? (
               <div className="text-center py-8 opacity-60">
                   <p>No payment history found.</p>
               </div>
             ) : (
               transactions.map((trx, i) => (
                 <div key={i} className={`p-3 rounded-lg border ${theme === 'dark' ? 'bg-gray-800/50 border-gray-700' : 'bg-gray-50 border-gray-200'}`}>
                    
                    <div className="flex justify-between items-start mb-2">
                        <div>
                            <h4 className="font-bold text-sm text-yellow-500">{trx.planName || 'Plan Purchase'}</h4>
                            <p className="text-[10px] opacity-70">{trx.method} • {trx.userPhone}</p>
                            <p className="text-[10px] opacity-50 font-mono mt-1">TrxID: {trx.trxId}</p>
                        </div>
                        <div className="text-right">
                            <h4 className="font-black text-sm">৳{trx.amount}</h4>
                            <span className={`text-[10px] px-2 py-0.5 rounded font-bold uppercase mt-1 inline-block ${
                                trx.status === 'approved' ? 'bg-green-500/20 text-green-500' : 
                                trx.status === 'rejected' ? 'bg-red-500/20 text-red-500' : 'bg-yellow-500/20 text-yellow-500'
                            }`}>
                                {trx.status || 'pending'}
                            </span>
                        </div>
                    </div>

                    {/* রিজেক্ট হলে কারণ দেখাবে */}
                    {trx.status === 'rejected' && trx.rejectionReason && (
                        <div className="mt-2 bg-red-900/20 border border-red-900/50 p-2 rounded text-xs text-red-200">
                            <span className="font-bold">Reason:</span> {trx.rejectionReason}
                        </div>
                    )}

                    <div className="mt-2 pt-2 border-t border-gray-700/50 flex justify-between items-center">
                        <span className="text-[9px] opacity-40">{trx.createdAt?.toDate ? trx.createdAt.toDate().toLocaleString() : 'Just now'}</span>
                    </div>
                 </div>
               ))
             )}
          </div>
        </div>
      </div>
    );
  }

  // --- 🛒 PREMIUM STORE MODAL (NEW) ---
// --- 🛒 PREMIUM STORE MODAL (COMPACT & RESPONSIVE FIX) ---
// --- 🛒 PREMIUM STORE MODAL (FINAL PRO VERSION: PAYMENT GATEWAY & CUSTOM ALERTS) ---
// --- 🛒 PREMIUM STORE MODAL (FINAL VERSION WITH LOGIN & ADMIN SYNC) ---
function PremiumModal({ isOpen, onClose, user, coins, t, handleGoogleLogin, onPaymentSuccess }) {
  const [config, setConfig] = useState(null);
  const [loading, setLoading] = useState(false);
  const [view, setView] = useState('store'); // store | methods | payment | login_prompt
  const [selectedPlan, setSelectedPlan] = useState(null); 
  const [selectedMethod, setSelectedMethod] = useState(null); 
  const [trxId, setTrxId] = useState('');
  const [userPhone, setUserPhone] = useState(''); // ইউজারের ফোন নম্বরের জন্য নতুন স্টেট
  
  // Custom Toast State
  const [modalToast, setModalToast] = useState({ show: false, msg: '', type: '' });

  // --- WATCH & EARN STATE ---
  const [watchProgress, setWatchProgress] = useState({ time: 0, claimed: [] });
  // --- 🌟 NEW: DYNAMIC WATCH TASKS LOGIC 🌟 ---
  const [earnConfig, setEarnConfig] = useState({ minutes: 30, reward: 1 }); // ডিফল্ট ৩০ মিনিট

  // কয়েন কনফিগারেশন লোড করা (যাতে প্লেয়ার এবং লিস্ট একই থাকে)
  useEffect(() => {
    const unsub = onSnapshot(doc(db, 'artifacts', appId, 'public', 'data', 'coin_config', 'main'), (s) => {
        if(s.exists()) setEarnConfig(s.data());
    });
    return () => unsub();
  }, []);

  // অটোমেটিক টাস্ক জেনারেটর (৪টি ধাপ তৈরি হবে)
  const watchTasks = useMemo(() => {
      const mins = Number(earnConfig.minutes) || 30;
      const rew = Number(earnConfig.reward) || 1;
      return [
          { id: 1, minutes: mins * 1, reward: rew },
          { id: 2, minutes: mins * 2, reward: rew },
          { id: 3, minutes: mins * 3, reward: rew },
          { id: 4, minutes: mins * 4, reward: rew }
      ];
  }, [earnConfig]);

  // লোড করার সময় লোকাল স্টোরেজ থেকে ডাটা আনবে
  useEffect(() => {
      const today = new Date().toDateString();
      const savedData = JSON.parse(localStorage.getItem('miniflix_watch_data') || '{"date": "", "time": 0, "claimed": []}');
      
      if (savedData.date !== today) {
          // ২৪ ঘণ্টা পার হলে রিসেট
          setWatchProgress({ time: 0, claimed: [] });
          localStorage.setItem('miniflix_watch_data', JSON.stringify({ date: today, time: 0, claimed: [] }));
      } else {
          setWatchProgress({ time: savedData.time, claimed: savedData.claimed });
      }
  }, [isOpen]);

  // কয়েন ক্লেইম করার ফাংশন (লিস্ট থেকে)
  const claimWatchReward = async (task) => {
      if (watchProgress.claimed.includes(task.id)) return;

      const newClaimed = [...watchProgress.claimed, task.id];
      const today = new Date().toDateString();
      
      // আপডেট লোকাল স্টোরেজ
      const newData = { date: today, time: watchProgress.time, claimed: newClaimed };
      localStorage.setItem('miniflix_watch_data', JSON.stringify(newData));
      setWatchProgress(prev => ({ ...prev, claimed: newClaimed }));

      // ইউজারকে কয়েন দেওয়া
      if(user && !user.isAnonymous) {
          const userRef = doc(db, 'artifacts', appId, 'users', user.uid,);
          await updateDoc(userRef, { coins: increment(task.reward) });
          setCoins(prevCoins => prevCoins + task.reward);
      } else {
          const current = Number(localStorage.getItem('miniflix_coins') || 0);
          localStorage.setItem('miniflix_coins', current + task.reward);
      }
      showToast(`🎁 You earned ${task.reward} Coins!`, 'success');
  };
  // Daily Check-in State
  const [dailyCheckIn, setDailyCheckIn] = useState(() => {
      const saved = localStorage.getItem('miniflix_daily_check');
      return saved ? JSON.parse(saved) : { lastDate: '', streak: 0, claimedToday: false };
  });

  const showToast = (msg, type = 'error') => {
      setModalToast({ show: true, msg, type });
      setTimeout(() => setModalToast({ show: false, msg: '', type: '' }), 3000);
  };

  useEffect(() => {
    if (isOpen) {
        // Fetch Config Real-time
        const unsub = onSnapshot(doc(db, 'artifacts', appId, 'public', 'data', 'store_config', 'main'), (s) => {
            if(s.exists()) setConfig(s.data());
        });
        
        // Reset Check-in if needed
        const today = new Date().toDateString();
        if (dailyCheckIn.lastDate !== today) {
            setDailyCheckIn(prev => ({ ...prev, claimedToday: false }));
        }
        return () => unsub();
    } else {
        setView('store');
        setModalToast({ show: false, msg: '', type: '' });
    }
  }, [isOpen]);

  // 1. COIN PURCHASE LOGIC
  // 1. COIN PURCHASE LOGIC (VIP TRIAL + CUMULATIVE)
  const handleCoinPurchase = async (planCoins, days) => {
    // Guest User Logic
    if (!user || user.isAnonymous) {
        const currentCoins = Number(localStorage.getItem('miniflix_coins') || 0);
        if (currentCoins < planCoins) { showToast("⚠️ Not enough coins!", 'error'); return; }
        
        const now = new Date();
        let expiryDate = new Date(); 

        const savedExpiry = localStorage.getItem('miniflix_premium_expiry');
        if (savedExpiry) {
            const currentExpiry = new Date(savedExpiry);
            if (currentExpiry > now) {
                expiryDate = currentExpiry;
            }
        }
        
        expiryDate.setDate(expiryDate.getDate() + parseInt(days));

        localStorage.setItem('miniflix_coins', currentCoins - planCoins);
        localStorage.setItem('miniflix_premium', 'true');
        localStorage.setItem('miniflix_premium_expiry', expiryDate.toISOString()); 
        localStorage.setItem('miniflix_plan_name', 'VIP Trial'); // 🔥 নাম সেভ হলো 'VIP Trial'

        showToast(`🎉 Success! Added ${days} days Trial.`, 'success');
        setTimeout(() => window.location.reload(), 1500);
        return; 
    }

    // Logged In User Logic
    if (coins < planCoins) { showToast("⚠️ Not enough coins!", 'error'); return; }
    
    setLoading(true);
    try {
        const now = new Date();
        let expiryDate = new Date(); 

        if (isPremium && premiumExpiryDate) {
             if (premiumExpiryDate > now) {
                 expiryDate = new Date(premiumExpiryDate); 
             }
        }

        expiryDate.setDate(expiryDate.getDate() + parseInt(days));

        const userRef = doc(db, 'artifacts', appId, 'users', user.uid);
        await updateDoc(userRef, { 
            coins: increment(-planCoins), 
            isPremium: true, 
            premiumExpiry: expiryDate,
            planName: 'VIP Trial' // 🔥 ডাটাবেসে নাম সেভ হলো
        });
        showToast("🎉 VIP Trial Activated!", 'success');
        setTimeout(onClose, 1500);
    } catch (e) { showToast("Error processing request", 'error'); }
    setLoading(false);
  };

  // 2. DAILY CLAIM LOGIC (Dynamic from Admin)
  const handleDailyClaim = async (dayIndex) => {
      if(dailyCheckIn.claimedToday) return;
      
      // NEW LOGIC: Custom Day Reward Check
      let reward = 0;
      // যদি অ্যাডমিন প্যানেল থেকে লিস্ট সেট করা থাকে
      if (config?.dailyRewards && Array.isArray(config.dailyRewards) && config.dailyRewards[dayIndex] !== undefined) {
          reward = parseInt(config.dailyRewards[dayIndex]);
      } else {
          // যদি লিস্ট না থাকে তবে আগের মতো ডিফল্ট কাজ করবে
          const baseReward = config?.dailyRewardBase || 2;
          reward = (dayIndex + 1) * baseReward;
      }
      
      const today = new Date().toDateString();
      const newStatus = { lastDate: today, streak: dayIndex + 1, claimedToday: true };
      
      setDailyCheckIn(newStatus);
      localStorage.setItem('miniflix_daily_check', JSON.stringify(newStatus));

      if(user && !user.isAnonymous) {
          const userRef = doc(db, 'artifacts', appId, 'users', user.uid, );
          await updateDoc(userRef, { coins: increment(reward) });
          setCoins(prevCoins => prevCoins + reward);
      } else {
          const current = Number(localStorage.getItem('miniflix_coins') || 0);
          localStorage.setItem('miniflix_coins', current + reward);
      }
      showToast(`🎁 You claimed ${reward} Coins!`, 'success');
  };

  // 3. MONEY PURCHASE FLOW
  const initiateBuy = (price, days, name) => {
      // 🛑 Login Check: যদি লগিন না থাকে, লগিন স্ক্রিনে পাঠাও
      if(!user || user.isAnonymous) {
          setSelectedPlan({ price, days, name }); // প্ল্যান মনে রাখবে
          setView('login_prompt'); // লগিন ভিউ দেখাবে
          return;
      }
      setSelectedPlan({ price, days, name });
      setView('methods');
  };

  // 4. CONFIRM PAYMENT & SAVE TO DATABASE
  const confirmPayment = async () => {
      // ভ্যালিডেশন: ফোন এবং TrxID দুটোই চেক করা হচ্ছে
      if(!userPhone.trim() || userPhone.length < 11) { 
          showToast("⚠️ Enter valid phone number", 'error'); 
          return; 
      }
      if(!trxId.trim()) { 
          showToast("⚠️ Enter Transaction ID", 'error'); 
          return; 
      }
      
      setLoading(true);
      try {
          // Admin Panel এর জন্য ট্রানজ্যাকশন সেভ করা হচ্ছে
          await addDoc(collection(db, 'artifacts', appId, 'admin', 'data', 'transactions'), {
              uid: user.uid,
              userName: user.displayName,
              email: user.email, 
              userPhone: userPhone, // <--- নতুন: ইউজারের ফোন নম্বর পাঠানো হলো
              trxId: trxId,
              method: selectedMethod,
              amount: selectedPlan.price,
              planName: selectedPlan.name,
              planDays: selectedPlan.days,
              status: 'pending', 
              createdAt: serverTimestamp()
          });

          showToast("✅ Request Sent! Wait for approval.", 'success');
          
          // ফর্ম রিসেট করা
          setUserPhone('');
          setTrxId('');
          
          setTimeout(onPaymentSuccess, 2000);
      } catch (e) {
          console.error(e);
          showToast("Failed to send request", 'error');
      }
      setLoading(false);
  };

  if (!isOpen || !config) return null;

  return (
    <div className="fixed inset-0 z-[99999] flex items-center justify-center p-4 bg-black/90 backdrop-blur-sm animate-in zoom-in duration-200">
        
        <div className="bg-[#121212] border border-yellow-600/50 w-full max-w-sm max-h-[90vh] rounded-2xl overflow-hidden shadow-[0_0_40px_rgba(234,179,8,0.2)] flex flex-col relative">
            
            {/* Custom Toast */}
            {modalToast.show && (
                <div className={`absolute top-0 left-0 right-0 p-3 text-center text-xs font-bold text-white z-50 animate-in slide-in-from-top duration-300 ${modalToast.type === 'error' ? 'bg-red-600' : 'bg-green-600'}`}>
                    {modalToast.msg}
                </div>
            )}

            {/* Header */}
            <div className="bg-gradient-to-r from-yellow-800 to-yellow-600 p-4 flex justify-between items-center shrink-0">
                <div className="flex items-center gap-2">
                    {view !== 'store' && <button onClick={() => setView('store')}><ArrowLeft size={20} className="text-white"/></button>}
                    <Crown size={20} className="text-white fill-white"/>
                    <h2 className="text-sm font-black text-white uppercase italic tracking-wider">
                        {view === 'store' ? 'VIP Store' : view === 'login_prompt' ? 'Login Required' : 'Payment'}
                    </h2>
                </div>
                <button onClick={onClose} className="bg-black/20 hover:bg-red-600 p-1 rounded-full text-white transition"><X size={16}/></button>
            </div>

            {/* Content Body */}
            <div className="flex-1 overflow-y-auto custom-scrollbar p-4 space-y-5 bg-[#0a0a0a]">
                
                {/* --- VIEW 1: STORE FRONT --- */}
                {view === 'store' && (
                    <>
                        <div className="flex justify-between bg-gray-900/50 p-3 rounded-xl border border-white/5">
                            <span className="text-[10px] text-gray-300 flex items-center gap-1"><Check size={12} className="text-green-500"/> No Ads</span>
                            <span className="text-[10px] text-gray-300 flex items-center gap-1"><Check size={12} className="text-green-500"/> 4K Quality</span>
                            <span className="text-[10px] text-gray-300 flex items-center gap-1"><Check size={12} className="text-green-500"/> Download</span>
                        </div>

                        {/* Subscription Plans (Updated for 3 Plans) */}
                        {config.moneyPayActive && (
                            <div>
                                <h3 className="text-xs font-bold text-gray-400 uppercase tracking-widest pl-1 mb-2">Subscription Plans</h3>
                                <div className="grid grid-cols-3 gap-2">
                                    
                                    {/* Plan 1 */}
                                    <div className="bg-gray-800 p-3 rounded-xl border border-gray-700 hover:border-blue-500 transition text-center group cursor-pointer" 
                                         onClick={() => initiateBuy(config.plan1_price, config.plan1_days, `Plan 1 (${config.plan1_days} Days)`)}>
                                        <div className="text-[10px] text-gray-400">{config.plan1_days || 30} Days</div>
                                        <div className="text-sm font-black text-white my-1">৳{config.plan1_price || 0}</div>
                                        <div className="w-full bg-gray-700 group-hover:bg-blue-600 text-white text-[9px] py-1.5 rounded font-bold transition">Buy Now</div>
                                    </div>

                                    {/* Plan 2 (HOT) */}
                                    <div className="bg-gray-800 p-3 rounded-xl border border-yellow-500 relative text-center shadow-[0_0_10px_rgba(234,179,8,0.2)] cursor-pointer" 
                                         onClick={() => initiateBuy(config.plan2_price, config.plan2_days, `Plan 2 (${config.plan2_days} Days)`)}>
                                        <div className="absolute top-0 right-0 bg-yellow-600 text-[6px] text-black font-bold px-1.5 py-0.5 rounded-bl">HOT</div>
                                        <div className="text-[10px] text-gray-400">{config.plan2_days || 90} Days</div>
                                        <div className="text-sm font-black text-white my-1">৳{config.plan2_price || 0}</div>
                                        <div className="w-full bg-yellow-600 text-black text-[9px] py-1.5 rounded font-bold hover:bg-yellow-500 transition">Buy Now</div>
                                    </div>

                                    {/* Plan 3 */}
                                    <div className="bg-gray-800 p-3 rounded-xl border border-gray-700 hover:border-purple-500 transition text-center group cursor-pointer" 
                                         onClick={() => initiateBuy(config.plan3_price, config.plan3_days, `Plan 3 (${config.plan3_days} Days)`)}>
                                        <div className="text-[10px] text-gray-400">{config.plan3_days || 365} Days</div>
                                        <div className="text-sm font-black text-white my-1">৳{config.plan3_price || 0}</div>
                                        <div className="w-full bg-gray-700 group-hover:bg-purple-600 text-white text-[9px] py-1.5 rounded font-bold transition">Buy Now</div>
                                    </div>

                                </div>
                            </div>
                        )}

                        {/* Coin Redeem (Updated for 3 Plans) */}
                        {config.coinPayActive && (
                            <div>
                                <h3 className="text-xs font-bold text-gray-400 uppercase tracking-widest pl-1 mb-2">Redeem with Coins</h3>
                                <div className="grid grid-cols-3 gap-2">
                                    
                                    {/* Coin Plan 1 */}
                                    <button onClick={() => handleCoinPurchase(config.coinPlan1_price || 100, config.coinPlan1_days || 7)} 
                                            className="bg-gray-800 p-2 rounded-xl border border-gray-700 hover:border-yellow-500 transition text-center group">
                                        <div className="text-[9px] text-gray-400">{config.coinPlan1_days || 7} Days</div>
                                        <div className="text-xs font-black text-yellow-500 my-1">🪙 {config.coinPlan1_price || 100}</div>
                                        <div className="w-full bg-gray-700 group-hover:bg-yellow-600 group-hover:text-black text-white text-[9px] py-1 rounded font-bold transition">Redeem</div>
                                    </button>

                                    {/* Coin Plan 2 */}
                                    <button onClick={() => handleCoinPurchase(config.coinPlan2_price || 300, config.coinPlan2_days || 30)} 
                                            className="bg-gray-800 p-2 rounded-xl border border-gray-700 hover:border-yellow-500 transition text-center group">
                                        <div className="text-[9px] text-gray-400">{config.coinPlan2_days || 30} Days</div>
                                        <div className="text-xs font-black text-yellow-500 my-1">🪙 {config.coinPlan2_price || 300}</div>
                                        <div className="w-full bg-gray-700 group-hover:bg-yellow-600 group-hover:text-black text-white text-[9px] py-1 rounded font-bold transition">Redeem</div>
                                    </button>

                                    {/* Coin Plan 3 */}
                                    <button onClick={() => handleCoinPurchase(config.coinPlan3_price || 1000, config.coinPlan3_days || 100)} 
                                            className="bg-gray-800 p-2 rounded-xl border border-gray-700 hover:border-yellow-500 transition text-center group">
                                        <div className="text-[9px] text-gray-400">{config.coinPlan3_days || 100} Days</div>
                                        <div className="text-xs font-black text-yellow-500 my-1">🪙 {config.coinPlan3_price || 1000}</div>
                                        <div className="w-full bg-gray-700 group-hover:bg-yellow-600 group-hover:text-black text-white text-[9px] py-1 rounded font-bold transition">Redeem</div>
                                    </button>

                                </div>
                            </div>
                        )}

                        {/* Daily Check-in (Dynamic On/Off) */}
                        {config.dailyCheckInActive && (
                            <div className="bg-[#1a1a1a] p-3 rounded-xl border border-dashed border-gray-700 mt-2">
                                <h3 className="text-xs font-bold text-gray-300 mb-2 flex justify-between">
                                    <span>Check-in daily</span>
                                    <span className="text-yellow-500 text-[10px]">Streak: {dailyCheckIn.streak}</span>
                                </h3>
                                <div className="grid grid-cols-7 gap-1">
                                    {[0,1,2,3,4,5,6].map((day, idx) => {
                                        const isClaimed = idx < dailyCheckIn.streak;
                                        const isToday = idx === dailyCheckIn.streak;
                                        // NEW LOGIC: UI Display Reward
                                        let rewardAmount = 0;
                                        if (config?.dailyRewards && Array.isArray(config.dailyRewards) && config.dailyRewards[idx] !== undefined) {
                                            rewardAmount = parseInt(config.dailyRewards[idx]);
                                        } else {
                                            rewardAmount = (idx + 1) * (config?.dailyRewardBase || 2);
                                        }
                                        
                                        return (
                                            <button 
                                                key={idx} 
                                                disabled={!isToday || dailyCheckIn.claimedToday}
                                                onClick={() => handleDailyClaim(idx)}
                                                className={`aspect-square rounded flex flex-col items-center justify-center relative border 
                                                ${isClaimed ? 'bg-yellow-900/20 border-yellow-800' : (isToday && !dailyCheckIn.claimedToday ? 'bg-yellow-500 text-black border-yellow-400 animate-pulse' : 'bg-gray-800 border-gray-700 opacity-50')}`}
                                            >
                                                {isClaimed ? <Check size={12} className="text-yellow-500"/> : <span className="text-[9px] font-bold">+{rewardAmount}</span>}
                                                <span className="text-[7px] opacity-70 mt-0.5">D{idx+1}</span>
                                            </button>
                                        );
                                    })}
                                </div>
                            </div>
                        )}
                        {/* --- WATCH & EARN SECTION (NEW) --- */}
                        {earnConfig.active && (
                            <div className="bg-[#1a1a1a] p-3 rounded-xl border border-dashed border-gray-700 mt-3">
                                <h3 className="text-xs font-bold text-gray-300 mb-3 flex items-center gap-2">
                                    <Clock size={14} className="text-yellow-500"/> Watch & Earn (Daily)
                                </h3>
                                <div className="space-y-2">
                                    {watchTasks.map((task, idx) => {
                                        const currentMins = Math.floor(watchProgress.time / 60); // সেকেন্ড থেকে মিনিটে রূপান্তর
                                        const isCompleted = currentMins >= task.minutes;
                                        const isClaimed = watchProgress.claimed.includes(task.id);
                                        const progressPercent = Math.min((currentMins / task.minutes) * 100, 100);

                                        return (
                                            <div key={idx} className="bg-gray-800 p-2 rounded-lg border border-gray-700 flex items-center justify-between">
                                                <div className="flex-1 mr-3">
                                                    <div className="flex justify-between text-[10px] text-gray-400 mb-1">
                                                        <span>Watch {task.minutes} mins</span>
                                                        <span className={isCompleted ? "text-green-400" : ""}>{currentMins}/{task.minutes} mins</span>
                                                    </div>
                                                    {/* Progress Bar */}
                                                    <div className="w-full bg-gray-900 h-1.5 rounded-full overflow-hidden">
                                                        <div 
                                                            className={`h-full transition-all duration-500 ${isCompleted ? 'bg-green-500' : 'bg-yellow-500'}`} 
                                                            style={{ width: `${progressPercent}%` }}
                                                        ></div>
                                                    </div>
                                                    <div className="mt-1 flex items-center gap-1 text-[10px] text-yellow-500 font-bold">
                                                        🪙 +{task.reward} Coin
                                                    </div>
                                                </div>

                                                {/* Action Button */}
                                                {isClaimed ? (
                                                    <button disabled className="bg-gray-700 text-gray-500 px-3 py-1.5 rounded text-xs font-bold border border-gray-600">
                                                        Claimed
                                                    </button>
                                                ) : isCompleted ? (
                                                    <button 
                                                        onClick={() => claimWatchReward(task)}
                                                        className="bg-yellow-500 hover:bg-yellow-600 text-black px-4 py-1.5 rounded text-xs font-bold animate-pulse shadow-[0_0_10px_rgba(234,179,8,0.5)]"
                                                    >
                                                        Claim
                                                    </button>
                                                ) : (
                                                    <button 
                                                        onClick={onClose} // মডাল বন্ধ করে ভিডিও দেখতে পাঠাবে
                                                        className="bg-gray-700 hover:bg-gray-600 text-white px-4 py-1.5 rounded text-xs font-bold"
                                                    >
                                                        Watch
                                                    </button>
                                                )}
                                            </div>
                                        );
                                    })}
                                </div>
                            </div>
                        )}
                    </>
                )}
                
                {/* --- VIEW: LOGIN PROMPT --- */}
                {view === 'login_prompt' && (
                    <div className="animate-in fade-in zoom-in duration-300 text-center py-6">
                         <div className="w-16 h-16 bg-red-600/20 rounded-full flex items-center justify-center mx-auto mb-4 animate-bounce">
                             <User size={32} className="text-red-500"/>
                         </div>
                         <h3 className="text-xl font-bold text-white mb-2">Login Required</h3>
                         <p className="text-gray-400 text-sm mb-6 px-4">You need to login with Google to purchase a subscription for security reasons.</p>
                         
                         <button 
                            onClick={handleGoogleLogin} // App.js থেকে আসা ফাংশন কল হবে
                            className="w-full py-3 bg-white text-black rounded-xl font-bold flex items-center justify-center gap-3 hover:bg-gray-200 transition"
                         >
                             <img src="https://www.gstatic.com/firebasejs/ui/2.0.0/images/auth/google.svg" className="w-5 h-5" alt="Google"/>
                             Login with Google
                         </button>
                    </div>
                )}

                {/* --- VIEW: PAYMENT METHODS --- */}
                {/* --- VIEW: PAYMENT METHODS (FIXED LOGOS) --- */}
                {/* --- VIEW: PAYMENT METHODS (Updated: Image 2 Style) --- */}
                {view === 'methods' && (
                    <div className="animate-in slide-in-from-right duration-300 bg-gray-50 h-full rounded-xl overflow-hidden flex flex-col">
                        <div className="p-4 bg-white shadow-sm border-b border-gray-200">
                             <h3 className="text-gray-800 font-bold text-lg">Payment Method</h3>
                             <p className="text-xs text-gray-500">Please choose a payment method</p>
                        </div>

                        <div className="p-4 space-y-3">
                            {/* bKash Button */}
                            <button onClick={() => { setSelectedMethod('bKash'); setView('payment'); }} 
                                className="w-full bg-white border border-gray-200 p-4 rounded-xl flex items-center justify-between hover:border-pink-500 hover:shadow-md transition group">
                                <div className="flex items-center gap-4">
                                    <img 
                                        src="https://raw.githubusercontent.com/ahmedshahriar/bangladesh-payment-gateways/master/images/bkash-logo-0.png" 
                                        className="w-8 h-8 object-contain" 
                                        alt="bKash"
                                    />
                                    <span className="font-bold text-gray-700">bKash</span>
                                </div>
                                <div className="flex items-center gap-2">
                                    <span className="text-[10px] bg-orange-100 text-orange-600 px-2 py-0.5 rounded font-bold">Recommended</span>
                                    <ChevronRight size={18} className="text-gray-400 group-hover:text-pink-500"/>
                                </div>
                            </button>
                            
                            {/* Nagad Button */}
                            <button onClick={() => { setSelectedMethod('Nagad'); setView('payment'); }} 
                                className="w-full bg-white border border-gray-200 p-4 rounded-xl flex items-center justify-between hover:border-orange-500 hover:shadow-md transition group">
                                <div className="flex items-center gap-4">
                                    <img 
                                        src="https://raw.githubusercontent.com/ahmedshahriar/bangladesh-payment-gateways/master/images/nagad-logo-0.png" 
                                        className="w-8 h-8 object-contain" 
                                        alt="Nagad"
                                    />
                                    <span className="font-bold text-gray-700">Nagad</span>
                                </div>
                                <ChevronRight size={18} className="text-gray-400 group-hover:text-orange-500"/>
                            </button>

                            {/* Card Button (Inactive) */}
                            <button onClick={() => showToast("Card payment coming soon!", "error")} 
                                className="w-full bg-white border border-gray-200 p-4 rounded-xl flex items-center justify-between opacity-60">
                                <div className="flex items-center gap-4">
                                    <div className="bg-blue-600 text-white p-1 rounded">
                                       <CreditCard size={20}/>
                                    </div>
                                    <span className="font-bold text-gray-700">Card / Visa</span>
                                </div>
                                <span className="text-[10px] text-gray-400">Coming Soon</span>
                            </button>
                        </div>
                        
                        <div className="mt-auto p-4 bg-white border-t border-gray-200">
                             <div className="flex justify-between items-center text-sm">
                                 <span className="text-gray-500">Total Amount</span>
                                 <span className="font-black text-xl text-gray-800">৳{selectedPlan?.price}</span>
                             </div>
                        </div>
                    </div>
                )}

                {/* --- VIEW: PAYMENT INPUT (FIXED HEADER LOGO) --- */}
                {/* --- VIEW: PAYMENT INPUT (Updated: Hybrid of Image 1 & 3) --- */}
                {view === 'payment' && (
                    <div className="animate-in slide-in-from-right duration-300 h-full flex flex-col bg-gray-50 rounded-xl overflow-hidden">
                        
                        {(() => {
                            const isBkash = selectedMethod === 'bKash';
                            // 1st Picture Style Header Color
                            const headerColor = isBkash ? 'bg-[#E2136E]' : 'bg-[#F6921E]'; 
                            
                            return (
                                <div className="flex flex-col h-full">
                                    
                                    {/* HEADER AREA (Back Button & Title) */}
                                    <div className="bg-white p-3 flex items-center border-b border-gray-200 sticky top-0 z-10">
                                        <button onClick={() => setView('methods')} className="p-2 hover:bg-gray-100 rounded-full transition text-gray-600">
                                            <ArrowLeft size={20}/>
                                        </button>
                                        <h3 className="ml-2 font-bold text-gray-800">Payment Details</h3>
                                    </div>

                                    <div className="flex-1 overflow-y-auto custom-scrollbar p-4">
                                        
                                        {/* SECTION 1: ADMIN INFO (Like 1st Picture - Pink/Orange Box) */}
                                        <div className={`${headerColor} rounded-lg p-5 text-white shadow-lg mb-6 relative overflow-hidden`}>
                                            <div className="absolute top-0 right-0 p-4 opacity-10">
                                                <CreditCard size={100} />
                                            </div>
                                            
                                            <h4 className="font-bold text-lg mb-2 border-b border-white/20 pb-2">
                                                {config.paymentInstruction || "Send Money to this personal number."}
                                            </h4>
                                            
                                            

                                            <div className="bg-white/20 p-3 rounded-lg flex items-center justify-between border border-white/30">
                                                <div>
                                                    <p className="text-[10px] font-bold opacity-80 uppercase">Merchant/Personal Number</p>
                                                    <p className="text-xl font-mono font-black tracking-widest">{config.bkashNumber}</p>
                                                </div>
                                                <button onClick={() => {navigator.clipboard.writeText(config.bkashNumber); showToast("Copied!", "success")}} 
                                                    className="bg-white text-black p-2 rounded shadow hover:scale-105 transition">
                                                    <Check size={16}/>
                                                </button>
                                            </div>
                                            
                                            <div className="mt-3 flex justify-between items-center text-sm font-bold bg-black/20 p-2 rounded">
                                                <span>Amount to pay:</span>
                                                <span className="text-yellow-300 text-lg">৳{selectedPlan?.price}.00</span>
                                            </div>
                                        </div>

                                        {/* SECTION 2: USER INPUTS (Like 3rd Picture - Clean Form) */}
                                        <div className="space-y-4">
                                            <p className="text-sm font-bold text-gray-700 border-l-4 border-gray-800 pl-2">
                                                টাকা পাঠানোর পর নিচের তথ্যগুলো দিন:
                                            </p>

                                            {/* User Phone Input */}
                                            <div className="space-y-1">
                                                <label className="text-xs font-bold text-gray-500 ml-1">যে নাম্বার থেকে টাকা পাঠিয়েছেন</label>
                                                <div className="relative">
                                                    <span className="absolute left-3 top-3.5 text-gray-500 font-bold text-sm">+880</span>
                                                    <input 
                                                        type="number" 
                                                        placeholder="1XXXXXXXXX" 
                                                        className="w-full pl-14 bg-white border border-gray-300 p-3 rounded-xl text-gray-900 outline-none focus:border-blue-500 focus:ring-1 focus:ring-blue-500 transition font-bold text-lg shadow-sm"
                                                        value={userPhone}
                                                        onChange={(e) => setUserPhone(e.target.value)}
                                                    />
                                                </div>
                                            </div>

                                            {/* TrxID Input */}
                                            <div className="space-y-1">
                                                <label className="text-xs font-bold text-gray-500 ml-1">Transaction ID (TrxID)</label>
                                                <input 
                                                    type="text" 
                                                    placeholder="e.g. 8JSH7..." 
                                                    className="w-full bg-white border border-gray-300 p-3 rounded-xl text-gray-900 outline-none focus:border-blue-500 focus:ring-1 focus:ring-blue-500 transition font-bold font-mono uppercase text-lg shadow-sm"
                                                    value={trxId}
                                                    onChange={(e) => setTrxId(e.target.value)}
                                                />
                                                <p className="text-[10px] text-gray-400 ml-1">টাকা পাঠানোর পর মেসেজে পাওয়া TrxID টি এখানে দিন।</p>
                                            </div>

                                        </div>
                                    </div>

                                    {/* FOOTER BUTTON */}
                                    <div className="p-4 bg-white border-t border-gray-200">
                                        <button 
                                            onClick={confirmPayment} 
                                            disabled={loading} 
                                            className={`w-full py-3.5 rounded-xl font-bold text-white text-lg shadow-lg hover:shadow-xl active:scale-95 transition-all flex items-center justify-center gap-2 ${isBkash ? 'bg-[#E2136E]' : 'bg-[#F6921E]'}`}
                                        >
                                            {loading ? <Loader className="animate-spin" size={24}/> : "PAY NOW"}
                                        </button>
                                    </div>
                                </div>
                            );
                        })()}
                    </div>
                )}
            </div>
        </div>
    </div>
  );
}
  function SideMenu() {
    if (!isMenuOpen) return null;
    return (
      <div className="fixed inset-0 z-[9999] bg-black/50 backdrop-blur-sm animate-in fade-in" onClick={() => setIsMenuOpen(false)} style={{direction: 'ltr'}}>
        {/* Sidebar Container */}
        <div 
            className={`h-full w-[80%] max-w-[300px] shadow-2xl overflow-y-auto custom-scrollbar transition-transform duration-300 ${theme === 'dark' ? 'bg-gray-900 text-white' : 'bg-white text-gray-900'}`} 
            onClick={(e) => e.stopPropagation()}
        >
          
          {/* Header with User Profile */}
          <div className={`p-6 border-b ${theme === 'dark' ? 'border-gray-700 bg-black/20' : 'border-gray-200 bg-gray-50'}`}>
             <div className="flex items-center justify-between mb-4">
                 <h2 className="text-xl font-black text-red-600">MENU</h2>
                 <button onClick={() => setIsMenuOpen(false)}><X size={24} className="opacity-70 hover:opacity-100 hover:text-red-500"/></button>
             </div>
             
             {/* USER INFO SECTION (UPDATED FOR COINS) */}
             <div className="flex items-center gap-3 mb-4">
                {/* 1. PROFILE IMAGE */}
                {user && !user.isAnonymous && user.photoURL ? (
                    <img src={user.photoURL} className={`w-14 h-14 rounded-full border-2 ${isPremium ? 'border-yellow-500' : 'border-red-600'}`} alt="Profile"/>
                ) : (
                    <div className={`w-14 h-14 rounded-full flex items-center justify-center font-bold text-white text-xl ${isPremium ? 'bg-yellow-600' : 'bg-gray-700'}`}>
                        {user && !user.isAnonymous && user.displayName ? user.displayName.charAt(0) : <User size={24}/>}
                    </div>
                )}
                
                {/* 2. NAME, BADGE & COINS */}
                <div className="overflow-hidden flex-1">
                    {/* Name & VIP Badge */}
                    <div className="flex items-center gap-2">
                        <div className="font-bold text-sm truncate">
                            {user && !user.isAnonymous ? user.displayName : t.guestUser}
                        </div>
                        
                        {/* পরিবর্তন ১: এখানে showPremiumMenu চেক যুক্ত করা হয়েছে */}
                        {showPremiumMenu && isPremium && (
                            <span className="bg-yellow-500 text-black text-[9px] font-black px-1.5 py-0.5 rounded flex items-center gap-1 animate-pulse">
                               <Crown size={10} fill="black"/> {activePlanName}
                            </span>
                        )}
                    </div>
                  {/* VIP Validity Display */}
                    {showPremiumMenu && isPremium && premiumExpiryDate && (
                        <div className="mb-1">
                            <span className="text-[10px] text-green-400 font-mono font-bold bg-green-900/30 px-2 py-0.5 rounded border border-green-800">
                                VIP Expire: {premiumExpiryDate.toLocaleDateString()}
                                {/* আপনি চাইলে দিন বাকি দেখাতে পারেন: */}
                                {/* {Math.ceil((premiumExpiryDate - new Date()) / (1000 * 60 * 60 * 24))} days left */}
                            </span>
                        </div>
                    )}

                    {/* 🪙 COIN BALANCE (নিচের কোড যেমন আছে তেমনই থাকবে) */}
                    {/* 🪙 COIN BALANCE */}
                    {/* পরিবর্তন ২: এখানে showPremiumMenu চেক যুক্ত করা হয়েছে, তাই মেনু অফ থাকলে কয়েনও দেখাবে না */}
                    {showPremiumMenu && (
                        <div className="flex items-center gap-1.5 mt-1 bg-gray-800/90 w-fit px-3 py-1 rounded-full border border-gray-600 shadow-sm">
                            <div className="w-3 h-3 rounded-full bg-yellow-500 flex items-center justify-center text-[8px] border border-yellow-300 shadow">🪙</div>
                            <span className="text-xs font-mono font-bold text-yellow-500">{coins} Coins</span>
                        </div>
                    )}

                    {/* Email or Status */}
                    <div className="text-[10px] opacity-70 truncate mt-1 text-gray-400">
                        {user && !user.isAnonymous ? user.email : 'Guest Account'}
                    </div>
                </div>
             </div>

             {/* Action Buttons */}
             {user && !user.isAnonymous ? (
                <button 
                    onClick={() => { signOut(auth); setIsMenuOpen(false); showNotification("Logged Out"); }} 
                    className="w-full bg-gray-800 hover:bg-red-600 py-2 rounded-lg text-white transition border border-gray-600 flex items-center justify-center gap-2 text-xs font-bold"
                >
                    <LogOut size={14}/> {t.logout}
                </button>
             ) : (
                <button onClick={handleGoogleLogin} className="w-full py-2 bg-red-600 text-white rounded-lg font-bold text-xs flex items-center justify-center gap-2 hover:bg-red-700 transition shadow-lg">
                    <img src="https://www.gstatic.com/firebasejs/ui/2.0.0/images/auth/google.svg" className="w-4 h-4 bg-white rounded-full p-0.5" alt=""/> {t.loginGoogle}
                </button>
             )}
          </div>

          {/* Menu Items */}
          <div className="p-4 space-y-2">
            {/* 👑 PREMIUM BUTTON (NEW) - Controlled by Admin */}
            {showPremiumMenu && (
                <button 
                    onClick={() => { setShowPremiumModal(true); setIsMenuOpen(false); }} 
                    className="w-full mb-2 bg-gradient-to-r from-yellow-600 to-yellow-700 text-white p-3 rounded-xl font-black text-sm flex items-center gap-3 shadow-lg hover:scale-105 transition transform"
                >
                    <Crown size={20} className="animate-pulse"/> GET PREMIUM
                </button>
            )}
            {/* 1. History & Watchlist */}
            <button onClick={() => { setShowWatchlist(true); setIsMenuOpen(false); }} className={`w-full flex items-center gap-3 p-3 rounded-xl font-bold text-sm transition ${theme === 'dark' ? 'hover:bg-gray-800' : 'hover:bg-gray-100'}`}>
                <Heart size={20} className="text-red-500"/> {t.watchlist}
            </button>
            <button onClick={() => { setShowHistory(true); setIsMenuOpen(false); }} className={`w-full flex items-center gap-3 p-3 rounded-xl font-bold text-sm transition ${theme === 'dark' ? 'hover:bg-gray-800' : 'hover:bg-gray-100'}`}>
                <Clock size={20} className="text-blue-500"/> {t.history}
            </button>
            {isCapacitor && (
                <button onClick={() => { setView('downloads'); setIsMenuOpen(false); }} className={`w-full flex items-center justify-between p-3 rounded-xl font-bold text-sm transition bg-green-500/10 text-green-500 hover:bg-green-500/20`}>
                    <div className="flex items-center gap-3"><Download size={20}/> My Downloads</div>
                    <span className="text-[10px] bg-green-500 text-white px-2 py-0.5 rounded-full uppercase">Offline</span>
                </button>
            )}
            {reportEmail && (
                <button onClick={() => { 
                    setIsMenuOpen(false);
                    const isMobileDev = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
                    if (isMobileDev) {
                        window.location.href = `mailto:${reportEmail}?subject=Report Content / DMCA Request`;
                    } else {
                        window.open(`https://mail.google.com/mail/?view=cm&fs=1&to=${reportEmail}&su=Report Content / DMCA Request`, '_blank');
                    }
                }} className={`w-full flex items-center gap-3 p-3 rounded-xl font-bold text-sm transition ${theme === 'dark' ? 'hover:bg-gray-800' : 'hover:bg-gray-100'}`}>
                    <MessageSquare size={20} className="text-purple-500"/> Report / DMCA
                </button>
            )}
            {/* New Payment History Button - Only for Logged In Users */}
            {user && !user.isAnonymous && (
                <button onClick={() => { setShowPaymentHistory(true);
                setIsMenuOpen(false); }} className={`w-full flex items-center gap-3 p-3 rounded-xl font-bold text-sm transition ${theme === 'dark' ?
                'hover:bg-gray-800' : 'hover:bg-gray-100'}`}>
                    <CreditCard size={20} className="text-yellow-500"/> Payment History
                </button>
            )}
            
            <div className={`my-2 border-t ${theme === 'dark' ? 'border-gray-800' : 'border-gray-200'}`}></div>

            {/* 2. Theme & Language */}
            <div className="p-2">
                <label className="text-xs font-bold opacity-60 uppercase mb-2 block">{t.theme}</label>
                <div className="grid grid-cols-2 gap-2 bg-black/10 p-1 rounded-lg">
                    <button onClick={() => setTheme('dark')} className={`flex items-center justify-center gap-2 py-2 rounded-md text-xs font-bold transition ${theme === 'dark' ? 'bg-black text-white shadow' : 'opacity-50'}`}><Moon size={14}/> {t.dark}</button>
                    <button onClick={() => setTheme('light')} className={`flex items-center justify-center gap-2 py-2 rounded-md text-xs font-bold transition ${theme === 'light' ? 'bg-white text-black shadow' : 'opacity-50'}`}><Sun size={14}/> {t.light}</button>
                </div>
            </div>

            <div className="p-2">
                <label className="text-xs font-bold opacity-60 uppercase mb-2 block">{t.language}</label>
                <div className="grid grid-cols-2 gap-2">
                  {languages.map((lang) => (
                    <button key={lang.code} onClick={() => setLanguage(lang.code)} className={`py-2 px-2 rounded-lg border text-xs font-bold transition ${language === lang.code ? 'border-red-600 text-red-500 bg-red-600/10' : 'border-transparent hover:bg-black/5'}`}>
                        {lang.name}
                    </button>
                  ))}
                </div>
            </div>

             {/* 3. Install App */}
             {installPrompt && (
                <div className="mt-4 p-3 bg-gradient-to-r from-green-600 to-emerald-600 rounded-xl text-white shadow-lg">
                    <div className="flex items-center gap-3 mb-2">
                        <Download size={20}/>
                        <div>
                            <div className="font-bold text-sm">{t.installApp}</div>
                            <div className="text-[10px] opacity-90">Install for best experience</div>
                        </div>
                    </div>
                    <button onClick={handleInstallClick} className="w-full bg-white text-green-700 py-1.5 rounded-lg text-xs font-bold hover:bg-gray-100 transition">Install Now</button>
                </div>
             )}
          </div>
          
          {/* Footer */}
          <div className="p-6 text-center text-[10px] opacity-40 font-mono mt-4">
              Version {CURRENT_APP_VERSION} <br/>
              © 2026 ZiniPlay<br/>
              <span className="text-[8px] leading-tight block mt-2 opacity-70">
                Disclaimer: We do not host any files on our servers. All videos are provided by non-affiliated third parties.
              </span>
          </div>
        </div>
      </div>
    );
  }
  function SettingsModal() {
    if (!showSettings) return null;
    return (
      <div className="fixed inset-0 z-[60] flex items-center justify-center p-4 bg-black/50 backdrop-blur-sm animate-in fade-in" style={{direction: 'ltr'}}>
        <div className={`w-full max-w-sm rounded-2xl p-6 shadow-2xl border relative ${styles.modal} max-h-[90vh] overflow-y-auto custom-scrollbar`}>
          <button onClick={() => { setShowSettings(false); setIsLangMenuOpen(false); }} className="absolute top-4 right-4 text-gray-500 hover:text-red-500 transition"><X size={24} /></button>
          <h2 className="text-xl font-bold mb-6 flex items-center gap-2"><Settings size={24} className="text-red-600" /> {t.settings}</h2>
          <div className="space-y-6">
            
            {/* ACCOUNT SECTION */}
            <div className={`p-4 rounded-xl border ${theme === 'dark' ? 'border-gray-700 bg-gray-800/50' : 'border-gray-200 bg-gray-50'}`}>
                <h3 className="text-sm font-bold flex items-center gap-2 mb-3"><User size={16}/> {t.account}</h3>
                {user && !user.isAnonymous ? (
                    <div className="flex flex-col gap-3">
                        <div className="flex items-center gap-3">
                            {user.photoURL ? (
                                <img src={user.photoURL} className="w-10 h-10 rounded-full border border-gray-500" alt="Profile"/>
                            ) : (
                                <div className="w-10 h-10 rounded-full bg-red-600 flex items-center justify-center font-bold text-white">
                                    {user.displayName ? user.displayName.charAt(0) : 'U'}
                                </div>
                            )}
                            <div>
                                <div className="font-bold text-sm">{user.displayName || 'User'}</div>
                                <div className="text-xs opacity-70 truncate max-w-[150px]">{user.email}</div>
                            </div>
                        </div>
                        <div className="text-[10px] text-green-500 font-bold flex items-center gap-1 bg-green-500/10 p-1.5 rounded">
                            <Cloud size={12}/> {t.syncOn}
                        </div>
                        <button onClick={handleGoogleLogin} className="w-full py-2 bg-white text-black rounded font-bold text-sm flex items-center justify-center gap-2 hover:bg-gray-200 transition">
                             <img src="https://www.gstatic.com/firebasejs/ui/2.0.0/images/auth/google.svg" className="w-4 h-4" alt=""/> {t.loginGoogle}
                        </button>
                    </div>
                ) : (
                    <div className="text-center">
                         <div className="flex flex-col items-center mb-3">
                            <div className="w-10 h-10 rounded-full bg-gray-700 flex items-center justify-center mb-2">
                                <User size={20} className="text-gray-400"/>
                            </div>
                            <p className="font-bold text-sm">{t.guestUser}</p>
                            <p className="text-[10px] text-yellow-500 mt-1 flex items-center gap-1"><CloudOff size={10}/> {t.syncOff}</p>
                         </div>
                         <button onClick={handleGoogleLogin} className="w-full py-2 bg-white text-black rounded font-bold text-sm flex items-center justify-center gap-2 hover:bg-gray-200 transition">
                             <img src="https://www.gstatic.com/firebasejs/ui/2.0.0/images/auth/google.svg" className="w-4 h-4" alt=""/> {t.loginGoogle}
                         </button>
                    </div>
                )}
            </div>

            {/* INSTALL APP SECTION */}
            {installPrompt && (
                <div className={`p-4 rounded-xl border ${theme === 'dark' ? 'border-green-900/30 bg-green-900/10' : 'border-green-200 bg-green-50'}`}>
                    <div className="flex items-center gap-3">
                        <div className="bg-green-600 p-2 rounded-full text-white">
                            <Download size={20} />
                        </div>
                        <div className="flex-1">
                            <h4 className="font-bold text-sm">{t.getApp}</h4>
                            <p className="text-[10px] opacity-70">{t.appDesc}</p>
                        </div>
                        <button onClick={handleInstallClick} className="bg-green-600 text-white px-3 py-1.5 rounded-lg text-xs font-bold hover:bg-green-700 transition">
                            {t.installApp}
                        </button>
                    </div>
                </div>
            )}

            <div>
              <label className={`block text-sm font-bold mb-3 ${styles.subText}`}>{t.theme}</label>
              <div className="grid grid-cols-2 gap-3">
                <button onClick={() => setTheme('dark')} className={`flex items-center justify-center gap-2 p-3 rounded-xl border transition-all ${theme === 'dark' ? 'border-red-600 bg-red-600/10 text-red-500 font-bold' : 'border-gray-700 hover:border-gray-500'}`}><Moon size={18} /> {t.dark}</button>
                <button onClick={() => setTheme('light')} className={`flex items-center justify-center gap-2 p-3 rounded-xl border transition-all ${theme === 'light' ? 'border-red-600 bg-red-600/10 text-red-500 font-bold' : 'border-gray-700 hover:border-gray-500'}`}><Sun size={18} /> {t.light}</button>
              </div>
            </div>
            <div>
              <button onClick={() => setIsLangMenuOpen(!isLangMenuOpen)} className={`w-full flex justify-between items-center text-sm font-bold mb-2 ${styles.subText} hover:text-white transition-colors`}><span>{t.language}</span><div className="flex items-center gap-2"><span className="text-xs font-normal opacity-70 bg-gray-800 px-2 py-1 rounded">{languages.find(l => l.code === language)?.name}</span>{isLangMenuOpen ? <ChevronUp size={16}/> : <ChevronDown size={16}/>}</div></button>
              {isLangMenuOpen && (
                <div className="grid grid-cols-2 gap-2 animate-in slide-in-from-top-2 duration-200 mt-2">
                  {languages.map((lang) => (
                    <button key={lang.code} onClick={() => setLanguage(lang.code)} className={`flex items-center justify-center gap-2 p-2 rounded-lg border transition-all text-sm ${language === lang.code ? 'border-red-600 bg-red-600/10 text-red-500 font-bold' : 'border-gray-700 hover:border-gray-500'}`}>{lang.name}</button>
                  ))}
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    );
  };

  function ReviewsSection({ movieId }) {
    const [reviews, setReviews] = useState([]);
    const [rating, setRating] = useState(0);
    const [comment, setComment] = useState('');
    
    
useEffect(() => {
      if (!user) return;
      
      const fetchReviews = async () => {
        try {
          // 👈 জাদুকরী লিমিট এখানে যোগ করা হয়েছে
          const q = query(
             collection(db, 'artifacts', appId, 'public', 'data', 'movies', movieId, 'reviews'), 
             orderBy('createdAt', 'desc'), 
             limit(10) 
          );
          const snapshot = await getDocs(q);
          setReviews(snapshot.docs.map(d => ({ id: d.id, ...d.data() })));
        } catch (error) {
          console.error("Error fetching reviews:", error);
        }
      };

      fetchReviews();
    }, [movieId, user]);

    const submitReview = async (e) => {
      e.preventDefault();
      if (rating === 0 && !comment.trim()) {
          showNotification(t.reviewError || "Please add a rating or comment!");
          return;
      }
      await addDoc(collection(db, 'artifacts', appId, 'public', 'data', 'movies', movieId, 'reviews'), {
        rating,
        comment: comment.trim(),
        user: user?.isAnonymous ? t.guestUser : (user?.displayName || 'User'),
        createdAt: serverTimestamp()
      });
      setComment('');
      setRating(0);
      showNotification("Review Added!");
    };

    return (
      <div className="mt-8 pb-8 border-t border-gray-800 pt-6">
        <h3 className="text-lg font-bold mb-4">{t.reviews}</h3>
        <form onSubmit={submitReview} className={`p-4 rounded-xl mb-6 ${theme === 'dark' ? 'bg-gray-800' : 'bg-gray-100'}`}>
           <div className="flex items-center gap-2 mb-3">
             {[1,2,3,4,5].map(s => (
               <Star key={s} size={20} className={`cursor-pointer transition ${s <= rating ? 'text-yellow-500 fill-yellow-500' : 'text-gray-400'}`} onClick={() => setRating(s)} />
             ))}
           </div>
           <textarea className={`w-full p-3 rounded-lg text-sm outline-none resize-none ${theme === 'dark' ? 'bg-gray-900 text-white' : 'bg-white text-black'}`} placeholder={t.writeReview} rows="2" value={comment} onChange={(e) => setComment(e.target.value)} />
           <div className="flex justify-end mt-2"><button type="submit" className="bg-red-600 text-white px-4 py-1.5 rounded-lg text-sm font-bold flex items-center gap-2"><Send size={14} /> {t.submit}</button></div>
        </form>
        <div className="space-y-4">
           {reviews.length === 0 ? <p className="text-gray-500 text-sm italic">{t.noReviews}</p> : reviews.map(r => (<div key={r.id} className={`p-3 rounded-lg ${theme === 'dark' ? 'bg-gray-800/50' : 'bg-gray-50'}`}><div className="flex justify-between items-start mb-1"><span className="font-bold text-sm">{r.user}</span>{r.rating > 0 && <div className="flex items-center gap-0.5"><Star size={12} className="text-yellow-500 fill-yellow-500" /><span className="text-xs font-bold">{r.rating}</span></div>}</div>{r.comment && <p className={`text-sm ${styles.subText}`}>{r.comment}</p>}</div>))}
        </div>
      </div>
    );
  };

  // --- MOVIE CARD COMPONENT FOR HOVER PREVIEW ---
  function MovieCard({ movie, handlePlayMovie, theme, styles }) {
    const [isHovered, setIsHovered] = useState(false);
    const [showPreview, setShowPreview] = useState(false);
    const timerRef = useRef(null);

    const handleMouseEnter = () => {
      setIsHovered(true);
      timerRef.current = setTimeout(() => {
        setShowPreview(true);
      }, 1500); 
    };

    const handleMouseLeave = () => {
      setIsHovered(false);
      setShowPreview(false);
      if (timerRef.current) clearTimeout(timerRef.current);
    };

    return (
      <div 
        className="relative group cursor-pointer transition-transform duration-500 hover:scale-105 hover:z-10"
        onMouseEnter={handleMouseEnter}
        onMouseLeave={handleMouseLeave}
        onTouchStart={handleMouseEnter}
        onClick={() => handlePlayMovie(movie)}
      >
        <div className={`aspect-[2/3] rounded-lg overflow-hidden relative shadow-lg ${theme === 'dark' ? 'bg-gray-800' : 'bg-gray-200'}`}>
          {showPreview && movie.videoUrl ? (
             <div className="w-full h-full bg-black">
                <iframe 
                  src={getEmbedUrl(movie.videoUrl, true, true, true)} 
                  className="w-full h-full pointer-events-none scale-150" 
                  title={movie.title}
                  frameBorder="0"
                />
                <div className="absolute bottom-2 right-2 bg-black/60 text-white text-[10px] px-1 rounded">Preview</div>
             </div>
          ) : (
            <img src={movie.poster} alt={movie.title} className="w-full h-full object-cover" loading="lazy" />
          )}
          
          {isHovered && !showPreview && (
             <div className="absolute inset-0 bg-black/40 flex items-center justify-center">
                <Play className="text-white fill-white opacity-80" size={32}/>
             </div>
          )}

          {movie.lang && !showPreview && <div className="absolute top-0 right-0 bg-black/80 text-white text-[10px] font-bold px-2 py-1 rounded-bl-md shadow-sm border-b border-l border-white/10">{movie.lang}</div>}
        </div>
        <div className="mt-2">
           <h4 className={`text-xs font-bold truncate ${styles.subText}`}>{movie.title}</h4>
           {movie.year && <p className="text-[10px] text-gray-500">{movie.year} • {movie.genre}</p>}
        </div>
      </div>
    );
  };

  // --- 🌟 DOWNLOADS VIEW 🌟 ---
  function DownloadsView() {
      if(selectedSeriesForDownload) {
          return (
              <div className="w-full h-full pb-20 overflow-y-auto">
                  <div className={`flex items-center gap-4 p-4 sticky top-0 z-10 border-b ${theme === 'dark' ? 'bg-black border-gray-800' : 'bg-white border-gray-200'}`}>
                      <button onClick={() => setSelectedSeriesForDownload(null)} className={theme === 'dark' ? 'text-white' : 'text-black'}><ArrowLeft size={24}/></button>
                      <h2 className="text-xl font-bold truncate">{selectedSeriesForDownload.title}</h2>
                  </div>
                  <div className="p-4 space-y-3">
                      {selectedSeriesForDownload.episodes.map(ep => (
                          <div key={ep.id} className={`flex gap-4 p-3 rounded-xl items-center border ${theme === 'dark' ? 'bg-gray-900 border-gray-800' : 'bg-gray-50 border-gray-200'}`}>
                              <div className="relative w-28 h-16 bg-gray-800 rounded-lg overflow-hidden flex-shrink-0">
                                  <img src={selectedSeriesForDownload.poster} className="w-full h-full object-cover opacity-50" />
                                  <div className="absolute inset-0 flex items-center justify-center">
                                      <div className="bg-black/60 rounded-full p-1"><Play size={16} fill="white" className="text-white"/></div>
                                  </div>
                                  <div className="absolute top-1 left-1 bg-black/80 px-1 rounded text-[8px] font-bold text-white flex items-center gap-1">
                                      <Tv size={8}/> EP
                                  </div>
                              </div>
                              <div className="flex-1 min-w-0">
                                  <h4 className="text-sm font-bold truncate">{ep.title}</h4>
                                  <p className="text-xs text-green-500 mt-1 font-bold">Offline Ready</p>
                              </div>
                              <button 
                                  onClick={() => playOfflineVideo(selectedSeriesForDownload, ep)}
                                  className="bg-green-600 hover:bg-green-500 text-white px-4 py-1.5 rounded-full text-xs font-bold transition flex-shrink-0 shadow-[0_0_10px_rgba(34,197,94,0.3)]">
                                  Play
                              </button>
                          </div>
                      ))}
                  </div>
              </div>
          );
      }

      return (
          <div className="w-full h-full pb-24 overflow-y-auto pt-4 px-4 space-y-6">
              <h2 className="text-2xl font-black mb-4">Downloads</h2>

              {/* DOWNLOADING SECTION */}
              {downloadingItems.length > 0 && (
                  <div>
                      <h3 className="text-sm font-bold text-gray-400 mb-3 uppercase flex items-center gap-2">
                          Downloading ({downloadingItems.length})
                      </h3>
                      <div className="space-y-3">
                          {downloadingItems.map(item => (
                              <div key={item.id} className={`p-3 rounded-xl border flex items-center gap-4 relative overflow-hidden ${theme === 'dark' ? 'bg-gray-900 border-gray-800' : 'bg-gray-50 border-gray-200'}`}>
                                  {/* Progress Background */}
                                  <div className="absolute left-0 top-0 bottom-0 bg-blue-900/20" style={{ width: `${item.progress}%` }} />
                                  <div className={`relative z-10 w-16 h-16 rounded flex items-center justify-center flex-shrink-0 ${theme === 'dark' ? 'bg-gray-800' : 'bg-gray-200'}`}>
                                      <Download size={24} className="text-blue-500"/>
                                  </div>
                                  <div className="relative z-10 flex-1 min-w-0">
                                      <h4 className="text-sm font-bold truncate">{item.title}</h4>
                                      <div className="flex items-center gap-2 mt-2">
                                          <div className={`flex-1 h-1 rounded-full overflow-hidden ${theme === 'dark' ? 'bg-gray-800' : 'bg-gray-200'}`}>
                                              <div className="h-full bg-blue-500" style={{width: `${item.progress}%`}} />
                                          </div>
                                          <span className="text-xs text-blue-500 font-bold w-8">{item.progress}%</span>
                                      </div>
                                  </div>
                              </div>
                          ))}
                      </div>
                  </div>
              )}

              {/* DOWNLOADED SECTION */}
              <div>
                  <div className="flex justify-between items-end mb-3">
                      <h3 className="text-sm font-bold text-gray-400 uppercase">Downloaded</h3>
                  </div>
                  {downloadedItems.length === 0 ? (
                      <div className="text-center py-10 opacity-50">
                          <FolderPlus size={48} className="mx-auto mb-3" />
                          <p className="font-bold">No downloaded videos</p>
                          <p className="text-xs mt-1">Download movies & series to watch offline.</p>
                      </div>
                  ) : (
                      <div className="space-y-3">
                          {downloadedItems.map(item => (
                              <div key={item.id} className={`flex gap-4 p-3 rounded-xl items-center border ${theme === 'dark' ? 'bg-gray-900 border-gray-800' : 'bg-gray-50 border-gray-200'}`}>
                                  <div className="relative w-16 h-24 md:w-24 md:h-32 bg-gray-800 rounded-lg overflow-hidden flex-shrink-0">
                                      <img src={item.poster} className="w-full h-full object-cover" />
                                      {item.isSeries && (
                                          <div className="absolute top-1 left-1 bg-black/80 px-1 rounded text-[8px] font-bold text-white flex items-center gap-1">
                                              <Layers size={8}/> {item.episodes.length} EP
                                          </div>
                                      )}
                                  </div>
                                  <div className="flex-1 min-w-0">
                                      <h4 className="font-bold truncate text-sm md:text-base">{item.title}</h4>
                                      <p className="text-xs text-gray-400 mt-1">
                                          {item.isSeries ? `${item.episodes.length} episodes | offline` : `Movie | offline`}
                                      </p>
                                      <div className="mt-2 text-[10px] text-green-500 bg-green-500/10 px-2 py-0.5 rounded inline-block font-bold">
                                          Securely Downloaded
                                      </div>
                                  </div>
                                  <button 
                                      onClick={() => item.isSeries ? setSelectedSeriesForDownload(item) : playOfflineVideo(item)}
                                      className={`px-4 py-1.5 rounded-full text-xs font-bold transition flex-shrink-0 shadow-lg ${item.isSeries ? 'bg-indigo-600 text-white hover:bg-indigo-500' : 'bg-green-600 text-white hover:bg-green-500'}`}>
                                      {item.isSeries ? 'View' : 'Play'}
                                  </button>
                              </div>
                          ))}
                      </div>
                  )}
              </div>
          </div>
      );
  }

  function HomeView() {
    const [activeMenuId, setActiveMenuId] = useState(null); 
    // --- TRENDING SCROLL FIX START ---
  const trendingRef = useRef(null);
  // --- NEW RELEASE SCROLL LOGIC ---
  const newReleaseRef = useRef(null);
  const scrollNewRelease = (direction) => {
    if (newReleaseRef.current) {
      const scrollAmount = direction === 'left' ? -300 : 300;
      newReleaseRef.current.scrollBy({ left: scrollAmount, behavior: 'smooth' });
    }
  };

  const scrollTrending = (direction) => {
    if (trendingRef.current) {
      const { current } = trendingRef;
      const scrollAmount = direction === 'left' ? -300 : 300;
      current.scrollBy({ left: scrollAmount, behavior: 'smooth' });
    }
  };
  // --- TRENDING SCROLL FIX END ---
    
    // --- INFINITE SCROLL STATE ---
    const [visibleLimit, setVisibleLimit] = useState(20);
    const observer = useRef();

    const categories = ['All', 'Movie', 'Web Series', 'Anime', 'TV Show', 'Animation'];
    const displayCategories = { 'All': t.catAll, 'Movie': t.catMovie, 'Web Series': t.catWebSeries, 'Anime': t.catAnime, 'TV Show': t.catTvShow, 'Animation': t.catAnimation };
    
    
 // --- 6. INFINITE SCROLL TRIGGER (FIXED: MANUAL BUTTON) ---
  // অটোমেটিক স্ক্রল বন্ধ করে বাটন সিস্টেম করা হলো, তাই এটি এখন খালি থাকবে
  

  // UI-তে দেখানোর জন্য ভেরিয়েবল (আগের কোড যাতে এরর না দেয়)
  const displayedMovies = movies;
  // --- MISSING LISTS RESTORED ---
  const continueWatchingList = watchHistory.slice(0, 5);

  const trendingList = movies
    .filter(m => m.isTrendingSection || (m.views && m.views > 0))
    .sort((a, b) => {
      if (a.isTrendingSection && !b.isTrendingSection) return -1;
      if (!a.isTrendingSection && b.isTrendingSection) return 1;
      return (b.views || 0) - (a.views || 0);
    })
    .slice(0, trendingLimit);

  const newReleaseList = movies
    .filter(m => m.isNewRelease)
    .sort((a, b) => {
       const timeA = a.updatedAt?.seconds || a.createdAt?.seconds || 0;
       const timeB = b.updatedAt?.seconds || b.createdAt?.seconds || 0;
       return timeB - timeA; 
    })
    .slice(0, newReleaseLimit);


    return (
      <div className={`min-h-screen pb-20 font-sans transition-colors duration-300 ${styles.bg} ${styles.text}`} dir={language === 'ar' ? 'rtl' : 'ltr'}>
<nav className={`flex items-center justify-between p-3 md:p-4 sticky top-0 z-50 backdrop-blur-md border-b transition-colors duration-300 ${styles.nav} ${isCapacitor ? 'pt-[max(1rem,env(safe-area-inset-top))]' : ''}`}>
          <div className="flex items-center gap-3">
            {/* 1. MENU BUTTON */}
            <button onClick={() => setIsMenuOpen(true)} className="p-2 rounded-full hover:bg-gray-800 transition">
                <Menu size={24} className={theme === 'dark' ? 'text-white' : 'text-black'} />
            </button>

            {/* LOGO */}
            <div className="flex items-center gap-2 cursor-pointer" onClick={() => window.location.reload()}>
              <div className="bg-red-600 p-1 rounded"><Film className="text-white w-4 h-4 md:w-5 md:h-5" /></div>
              <h1 
  className="text-3xl md:text-4xl uppercase cursor-pointer hover:scale-105 transition-transform" 
  style={{ fontFamily: '"Helvetica Neue", Arial, sans-serif', fontWeight: '900', letterSpacing: '-1.5px', transform: 'scaleY(1.15)' }} 
  onClick={() => window.location.reload()}
>
  <span className={theme === 'light' ? 'text-black' : 'text-white'}>ZINI</span>
  <span className="text-[#E50914]">PLAY</span>
</h1>
            </div>
          </div>

          <div className="flex items-center gap-2 md:gap-3 relative" ref={searchRef}>
             {/* SEARCH BAR */}
             <div className={`flex items-center transition-all ${isSearchOpen ? `${styles.input} rounded-full px-3 py-1` : ''}`}>
               {isSearchOpen && <input autoFocus className="bg-transparent border-none outline-none w-28 md:w-40 text-sm ml-1" placeholder={t.searchPlaceholder} value={searchQuery} onChange={e => setSearchQuery(e.target.value)} />}
               <button onClick={() => { if (isSearchOpen) { setSearchQuery(''); setSuggestions([]); } setIsSearchOpen(!isSearchOpen); }} className={`${styles.subText} p-1.5 rounded-full hover:bg-gray-700/50`}>{isSearchOpen ? <X size={20} /> : <Search size={22} />}</button>
             </div>

             {/* SEARCH DROPDOWN */}
             {isSearchOpen && searchQuery.length > 0 && suggestions.length > 0 && (
                <div className={`absolute top-full right-0 mt-2 w-60 border rounded-lg shadow-xl z-50 max-h-60 overflow-y-auto ${styles.modal}`}>
                   {suggestions.map(m => (
                      <div key={m.id} onClick={() => { handlePlayMovie(m); setIsSearchOpen(false); setSearchQuery(''); setSuggestions([]); }} className={`flex items-center gap-3 p-3 cursor-pointer border-b border-gray-700/20 ${styles.button}`}>
                          <img src={m.poster} className="w-8 h-10 object-cover rounded" alt="" />
                          <div className="truncate text-sm font-bold">{m.title}</div>
                      </div>
                   ))}
                </div>
             )}
             
             {/* --- DOWNLOAD BUTTONS --- */}
             {/* Logic: বাটনগুলো দেখাবে, কিন্তু সার্চ বার ওপেন থাকলে মোবাইল ভিউতে বাটন হাইড হয়ে যাবে */}
             
             {/* PC VIEW BUTTONS (Full Text) */}
             <div className="hidden md:flex items-center gap-3 ml-2">
                {!isCapacitor && (
                    <button 
                      onClick={() => handleAppDownload('mobile')} 
                      className="flex items-center gap-2 bg-green-600 hover:bg-green-700 text-white px-3 py-1.5 rounded-lg transition shadow-lg group"
                    >
                        <div className="bg-white/20 p-1 rounded-full"><Tv size={14}/></div>
                        <div className="text-left leading-none">
                            <div className="text-[10px] font-bold">Download App</div>
                        </div>
                    </button>
                )}

                {!isPwa && (
                    <button 
                      onClick={() => handleAppDownload('pc')}
                      className="flex items-center gap-2 bg-blue-600 hover:bg-blue-700 text-white px-3 py-1.5 rounded-lg transition shadow-lg group"
                    >
                        <div className="bg-white/20 p-1 rounded-full"><Monitor size={14}/></div>
                        <div className="text-left leading-none">
                            <div className="text-[10px] font-bold">Download PC App</div>
                        </div>
                    </button>
                )}
             </div>

             {/* MOBILE VIEW BUTTON (Full Text) */}
             {/* Only show if Search is CLOSED (!isSearchOpen) to save space */}
             {!isSearchOpen && (
                 <div className="md:hidden animate-in fade-in zoom-in">
                    {!isCapacitor ? (
                        <button 
                            onClick={() => handleAppDownload('mobile')}
                            className="flex items-center gap-1.5 bg-gradient-to-r from-emerald-500 to-green-600 text-white px-3 py-1.5 rounded-full shadow-lg active:scale-95 transition-transform"
                        >
                            <Download size={14} />
                            <span className="text-xs font-bold">Download App</span>
                        </button>
                    ) : (
                        !isPwa && (
                            <button 
                                onClick={() => handleAppDownload('pc')}
                                className="flex items-center gap-1.5 bg-gradient-to-r from-blue-500 to-cyan-600 text-white px-3 py-1.5 rounded-full shadow-lg active:scale-95 transition-transform"
                            >
                                <Monitor size={14} />
                                <span className="text-xs font-bold">Download PC App</span>
                            </button>
                        )
                    )}
                 </div>
             )}

             {/* PWA INSTALL ICON (Mobile only fallback) */}
             {installPrompt && !isCapacitor && !isPwa && !isSearchOpen && (
                <button onClick={handleInstallClick} className="md:hidden bg-red-600 text-white p-1.5 rounded-full shadow-lg animate-bounce">
                    <Download size={14} />
                </button>
             )}
          </div>
        </nav>

        {!searchQuery && <HeroSlider />}
        
        {/* CONTINUE WATCHING */}
        {!searchQuery && continueWatchingList.length > 0 && (
          <div className="px-4 mt-6">
             <h3 className="text-lg font-bold mb-4 flex items-center gap-2 border-l-4 border-blue-500 pl-3">{t.continueWatching}</h3>
            <div className="flex gap-4 overflow-x-auto pb-4 custom-scrollbar">
              {continueWatchingList.map((m, i) => (
                <div key={i} className="min-w-[140px] w-36 relative group flex-shrink-0">
                   <div onClick={() => handlePlayMovie(m)} className="cursor-pointer">
                      <div className="relative">
                          <img src={m.poster} className="w-full h-24 object-cover rounded-lg opacity-80 group-hover:opacity-100 transition" alt={m.title} />
                          <div className="absolute inset-0 flex items-center justify-center"><div className="bg-black/50 rounded-full p-2 group-hover:scale-110 transition"><Play size={20} fill="white" className="text-white" /></div></div>
                          <div className="absolute bottom-0 left-0 w-full h-1 bg-gray-700 rounded-b-lg overflow-hidden"><div className="h-full bg-red-600 w-1/2"></div></div>
                      </div>
                      <h4 className={`mt-2 text-xs font-bold truncate ${styles.subText}`}>{m.title}</h4>
                   </div>
                   <button 
                     onClick={(e) => { e.stopPropagation(); setActiveMenuId(activeMenuId === m.id ? null : m.id); }} 
                     className="absolute top-1 right-1 bg-black/60 text-white p-1 rounded-full hover:bg-red-600 transition z-10"
                   >
                     <MoreVertical size={14} />
                   </button>
                   {activeMenuId === m.id && (
                     <div className="absolute top-8 right-0 z-20 bg-gray-900 border border-gray-700 rounded shadow-xl p-1 min-w-[120px] animate-in fade-in slide-in-from-top-2 duration-200">
                       <button onClick={(e) => { removeFromHistory(e, m.id); setActiveMenuId(null); }} className="w-full text-left px-2 py-1.5 text-[10px] font-bold text-red-500 hover:bg-gray-800 rounded flex items-center gap-1.5"><Trash2 size={12} /> {t.removeFromHistory}</button>
                     </div>
                   )}
                </div>
              ))}
            </div>
          </div>
        )}

        {/* Trending Section */}
        {/* --- TRENDING SECTION FIXED (With Views + Manual) --- */}
        {!searchQuery && trendingList.length > 0 && (
          <div className="px-4 mt-6 relative group/section">
            <div className="flex justify-between items-center mb-4 px-3 border-l-4 border-red-600">
                <h3 className="text-lg font-bold flex items-center gap-2">{t.trending}</h3>
                
                {/* PC Scroll Buttons */}
                <div className="hidden md:flex gap-2">
                    <button 
                      onClick={() => scrollTrending('left')} 
                      className="bg-gray-800 hover:bg-red-600 p-1.5 rounded-full text-white transition shadow-lg z-20"
                    >
                      <ChevronLeft size={20}/>
                    </button>
                    <button 
                      onClick={() => scrollTrending('right')} 
                      className="bg-gray-800 hover:bg-red-600 p-1.5 rounded-full text-white transition shadow-lg z-20"
                    >
                      <ChevronRight size={20}/>
                    </button>
                </div>
            </div>
            
            {/* Slider Container */}
            <div 
                ref={trendingRef}
                className="flex gap-4 overflow-x-auto pb-6 custom-scrollbar scroll-smooth"
                style={{ scrollbarWidth: 'none', msOverflowStyle: 'none' }} 
            >
              {trendingList.map((m, i) => (
                <div 
                  key={m.id} 
                  onClick={() => handlePlayMovie(m)} 
                  className="min-w-[100px] w-28 md:min-w-[140px] md:w-36 cursor-pointer relative group flex-shrink-0 transition-transform hover:scale-105 duration-300"
                >
                  {/* Poster */}
                  <div className={`aspect-[2/3] rounded-lg overflow-hidden relative shadow-lg ${theme === 'dark' ? 'bg-gray-800' : 'bg-gray-200'}`}>
                    <img src={m.poster} className="w-full h-full object-cover" alt={m.title} loading="lazy" />
                    
                    {/* Rank Badge */}
                    <div className="absolute top-0 left-0 bg-red-600 text-white text-xl font-black px-2 pt-1 pb-2 rounded-br-lg shadow-md leading-none z-10">
                        {i + 1}
                    </div>

                    {/* Play Overlay */}
                    <div className="absolute inset-0 bg-black/40 opacity-0 group-hover:opacity-100 transition-opacity flex items-center justify-center z-10">
                        <Play size={32} className="text-white fill-white"/>
                    </div>
                    
                    {/* Language Badge */}
                    {m.lang && (
                      <div className="absolute bottom-0 right-0 bg-black/80 text-white text-[10px] font-bold px-2 py-1 rounded-tl-md shadow-sm z-10">
                        {m.lang}
                      </div>
                    )}
                  </div>

                  {/* Info */}
                  <h4 className={`mt-2 text-sm font-bold truncate ${styles.subText} group-hover:text-red-500 transition-colors`}>
                    {m.title}
                  </h4>
                  <div className="flex justify-between items-center text-[10px] text-gray-500">
                    <span>{m.genre}</span>
                    {/* Views দেখাতে চাইলে নিচের লাইন আনকমেন্ট করতে পারেন */}
                    {/* <span className="flex items-center gap-1"><Eye size={10}/> {m.views || 0}</span> */}
                  </div>
                </div>
              ))}
            </div>
          </div>
        )}

       {/* --- NEW RELEASE SECTION (WITH BUTTONS) --- */}
        {!searchQuery && newReleaseList.length > 0 && (
          <div className="px-4 mt-8 relative group/section">
            <div className="flex justify-between items-center mb-4 px-3 border-l-4 border-cyan-400">
                <h3 className="text-lg font-bold flex items-center gap-2 text-cyan-400"><Sparkles size={18}/> New Releases</h3>
                
                {/* Scroll Buttons (Only for PC) */}
                <div className="hidden md:flex gap-2">
                    <button 
                      onClick={() => scrollNewRelease('left')} 
                      className="bg-gray-800 hover:bg-cyan-600 p-1.5 rounded-full text-white transition shadow-lg z-20"
                    >
                      <ChevronLeft size={20}/>
                    </button>
                     <button 
                      onClick={() => scrollNewRelease('right')} 
                      className="bg-gray-800 hover:bg-cyan-600 p-1.5 rounded-full text-white transition shadow-lg z-20"
                    >
                       <ChevronRight size={20}/>
                    </button>
                </div>
            </div>
            
            <div 
                ref={newReleaseRef} // <--- এই লাইনটি খুব গুরুত্বপূর্ণ
                className="flex gap-4 overflow-x-auto pb-6 custom-scrollbar scroll-smooth" 
                style={{ scrollbarWidth: 'none', msOverflowStyle: 'none' }}
            >
              {newReleaseList.map((m, i) => (
                <div key={m.id} onClick={() => handlePlayMovie(m)} 
                className="min-w-[100px] w-28 md:min-w-[140px] md:w-36 cursor-pointer relative group flex-shrink-0 transition-transform hover:scale-105 duration-300">
                  <div className={`aspect-[2/3] rounded-lg overflow-hidden relative shadow-lg ${theme === 'dark' ? 'bg-gray-800' : 'bg-gray-200'}`}>
                    <img src={m.poster} className="w-full h-full object-cover" alt={m.title} loading="lazy" />
                    
                    {/* New Badge */}
                    <div className="absolute top-2 left-0 bg-cyan-500 text-black text-[9px] font-black px-2 py-0.5 rounded-r shadow-md z-10 uppercase tracking-wider">
                        NEW
                    </div>

                    <div className="absolute inset-0 bg-black/40 opacity-0 group-hover:opacity-100 transition-opacity flex items-center justify-center z-10">
                        <Play size={32} className="text-white fill-white"/>
                    </div>
                  </div>
                  <h4 className={`mt-2 text-sm font-bold truncate ${styles.subText} group-hover:text-cyan-400 transition-colors`}>
                    {m.title}
                  </h4>
                  <p className="text-[10px] text-gray-500">{m.genre}</p>
                </div>
              ))}
            </div>
          </div>
        )}
        {/* Filter Row */}
        <div className="px-4 mt-6 flex gap-3 items-center">
           <button onClick={() => {
             if (showFilters) {
               setFilterCountry('Any');
               setFilterIndustry('Any');
               setFilterYear('Any');
               setFilterLang('Any');
               setFilterGenre('Any');
               setActiveFilterIndex(null);
             }
             setShowFilters(!showFilters);
           }} className={`px-3 py-2 rounded-lg border flex items-center gap-2 transition-colors ${showFilters ? 'bg-red-600 text-white border-red-600' : (theme === 'dark' ? 'border-gray-700 text-gray-400 hover:border-gray-500' : 'border-gray-300 text-gray-600')}`}><SlidersHorizontal size={16} /><span className="text-xs font-bold">{t.filter}</span></button>
           <div className="flex gap-2 overflow-x-auto pb-2 flex-1 custom-scrollbar">
            {categories.map(cat => (
              <button key={cat} onClick={() => setSelectedCategory(cat)} className={`px-5 py-2 rounded-full text-sm font-bold transition-colors whitespace-nowrap ${selectedCategory === cat ? styles.pillActive : styles.pillInactive}`}>{displayCategories[cat]}</button>
            ))}
          </div>
        </div>

        {/* Filters UI */}
        {showFilters && (
          <div className={`mx-4 mt-4 p-4 rounded-xl border animate-in slide-in-from-top-2 ${styles.filterBar}`} ref={filterRef}>
             <div className="grid grid-cols-2 md:grid-cols-5 gap-3">
                {[{ label: t.country, value: filterCountry, setter: setFilterCountry, options: countries },
                  { label: t.industry, value: filterIndustry, setter: setFilterIndustry, options: industries },
                  { label: t.releaseYear, value: filterYear, setter: setFilterYear, options: years },
                  { label: t.audioLanguage, value: filterLang, setter: setFilterLang, options: contentLanguages },
                  { label: t.genre, value: filterGenre, setter: setFilterGenre, options: genres }].map((f, i) => (
                  <div key={i} className="relative">
                    <label className={`text-xs font-bold mb-1 block ${styles.subText}`}>{f.label}</label>
                    <button onClick={() => setActiveFilterIndex(activeFilterIndex === i ? null : i)} className={`w-full p-2 rounded border text-xs flex items-center justify-between ${styles.dropdown}`}><span className="truncate">{f.value === 'Any' ? t.any : (f.label === t.industry && f.value === 'Anime' ? t.animeInd : (t[f.value.toLowerCase()] || f.value))}</span><ChevronDown size={14} className={`transition-transform ${activeFilterIndex === i ? 'rotate-180' : ''}`} /></button>
                    {activeFilterIndex === i && (
                      <div className={`absolute top-full left-0 mt-1 w-full max-h-40 overflow-y-auto z-20 rounded shadow-xl border ${styles.modal}`}>
                          <div onClick={() => { f.setter('Any'); setActiveFilterIndex(null); }} className={`p-2 text-xs cursor-pointer hover:bg-red-600 hover:text-white transition ${f.value === 'Any' ? 'bg-red-600/10 text-red-500' : ''}`}>{t.any}</div>
                          {f.options.map(o => (<div key={o} onClick={() => { f.setter(o); setActiveFilterIndex(null); }} className={`p-2 text-xs cursor-pointer hover:bg-red-600 hover:text-white transition ${f.value === o ? 'bg-red-600/10 text-red-500' : ''}`}>{t[o === 'Anime' ? 'animeInd' : o.toLowerCase()] || o}</div>))}
                      </div>
                    )}
                  </div>
                ))}
             </div>
          </div>
        )}

        {/* Content Grid */}
        <div className="p-4 pb-20">
          <div className="flex justify-between items-end mb-4">
            <h3 className="text-lg font-bold flex items-center gap-2"><span className="w-1 h-5 bg-red-600 rounded-full"></span>{searchQuery ? t.searchResults : (selectedCategory === 'All' ? t.library : displayCategories[selectedCategory])}</h3>
            {movies.length > 0 && <span className="text-[10px] text-gray-500 font-medium">{t.showing} {movies.length} {t.of} {hasMore ? 'More...' : movies.length}</span>}
          </div>
          
          {movies.length === 0 ? (
            isFetchingMore ? (
              <div className="flex justify-center items-center py-20"><div className="w-10 h-10 border-4 border-red-600 border-t-transparent rounded-full animate-spin"></div></div>
            ) : (
              <div className={`text-center py-10 ${styles.subText}`}><p>{t.noContent}</p><button onClick={loadCleanDemoData} className="text-red-500 underline mt-2">{t.loadDemo}</button></div>
            )
          ) : (
            <>
              <div className="grid grid-cols-3 md:grid-cols-5 lg:grid-cols-7 gap-3 pb-20 px-2">
                {displayedMovies.map(m => (
                 <div 
                  key={m.id} 
                  onClick={() => handlePlayMovie(m)} 
                  className="relative group cursor-pointer flex flex-col gap-2 animate-in fade-in duration-500"
                >
                  {/* MOVIE POSTER (2:3 PORTRAIT RATIO) */}
                  <div className={`aspect-[2/3] rounded-lg overflow-hidden relative shadow-lg border border-white/5 ${theme === 'dark' ? 'bg-gray-800' : 'bg-gray-200'} transition-transform duration-300 group-hover:scale-105 group-hover:shadow-red-900/20`}>
                      <img 
                        src={m.poster} 
                        alt={m.title}
                        loading="lazy"
                        className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-110"
                        onError={(e) => e.target.src = 'https://placehold.co/400x600?text=No+Poster'}
                      />
                      
                      {/* HOVER PLAY BUTTON */}
                      <div className="absolute inset-0 bg-black/40 opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex items-center justify-center backdrop-blur-[1px]">
                         <div className="bg-red-600 text-white p-3 rounded-full shadow-lg transform scale-0 group-hover:scale-100 transition-transform duration-300 delay-75">
                            <Play size={24} fill="currentColor" />
                         </div>
                      </div>
  
                      {/* BADGES */}
                      {m.isPremium && <span className="absolute top-2 left-2 bg-red-600 text-white text-[9px] font-bold px-1.5 py-0.5 rounded flex items-center gap-1 shadow-md"><Crown size={10} fill="currentColor"/></span>}
                      {m.lang && <span className="absolute top-2 right-2 bg-black/70 text-white text-[9px] font-bold px-1.5 py-0.5 rounded backdrop-blur-md shadow-sm border border-white/10 uppercase tracking-wider">{m.lang}</span>}
                      
                      {/* IMDb RATING */}
                      {m.imdbRating && (
                        <div className="absolute bottom-2 right-2 bg-yellow-500 text-black text-[9px] font-bold px-1.5 py-0.5 rounded flex items-center gap-1 shadow-sm">
                          <span className="font-black">IMDb</span> {m.imdbRating}
                        </div>
                      )}
                  </div>
  
                  {/* MOVIE INFO */}
                  <div className="px-1">
                     <h3 className={`font-bold text-xs truncate ${theme === 'dark' ? 'text-gray-200' : 'text-gray-800'} group-hover:text-red-500 transition-colors`}>{m.title}</h3>
                     <div className="flex items-center justify-between text-[10px] opacity-60 mt-0.5 font-medium">
                        <span>{m.year || '2024'}</span>
                        <span>{m.category || 'Movie'}</span>
                     </div>
                  </div>
                </div>
                ))}
              </div>
              
              {/* LOAD MORE SPINNER */}
          {hasMore && (
             <div ref={lastElementRef} className="w-full py-8 flex flex-col justify-center items-center mt-4">
                <div className="flex flex-col items-center animate-pulse">
                    <Loader className="animate-spin text-red-600 mb-2" size={24} />
                    <span className="text-xs text-gray-400">Loading more movies...</span>
                </div>
            </div>
          )}
            </>
          )}
        </div>

        {/* FLOATING AI BUTTON */}
       {!isAiOpen && (
    <button 
        onClick={() => setIsAiOpen(true)}
        className="fixed bottom-40 right-4 z-40 bg-gradient-to-r from-indigo-500 to-purple-600 text-white px-4 py-2 rounded-full shadow-lg hover:from-indigo-600 hover:to-purple-700 transition transform hover:scale-105 border border-purple-500/50 flex items-center gap-2"
    >
      <img src="https://i.imgur.com/gF1Ujaz_d.png?maxwidth=520&shape=thumb&fidelity=high" alt="Brand Logo" className="w-10 h-10 object-contain" />
      <span className="font-bold text-xs">{t.askAi}</span>
    </button>
)}
      </div>
    );
  };
function PlayerView() {
    // --- EXISTING STATES ---
    const [episodes, setEpisodes] = useState([]);
    const [activeEp, setActiveEp] = useState(null);
    const [selectedSeason, setSelectedSeason] = useState('1');
    const [avgRating, setAvgRating] = useState(0);
    const [isAutoPlay, setIsAutoPlay] = useState(true);
    const [currentVideoTime, setCurrentVideoTime] = useState(0);
    const [duration, setDuration] = useState(0);
    const currentVideoTimeRef = useRef(0);
    const durationRef = useRef(0);
    const currentTimeRef = useRef(0);
    const [showRewindAnim, setShowRewindAnim] = useState(false);
    const [showForwardAnim, setShowForwardAnim] = useState(false);
    const [isPlaying, setIsPlaying] = useState(true); 
    const [isBuffering, setIsBuffering] = useState(true);
    const [zoomLevel, setZoomLevel] = useState(1); 
    const [isFlipped, setIsFlipped] = useState(false);
    const [isSettingsOpen, setIsSettingsOpen] = useState(false);
    const [playbackRate, setPlaybackRate] = useState(1);
const [isFastForwarding, setIsFastForwarding] = useState(false);
const speedTimeoutRef = useRef(null);
const isLongPressRef = useRef(false);
    const [volume, setVolume] = useState(100);
    const [showVolOverlay, setShowVolOverlay] = useState(false);
    const [brightness, setBrightness] = useState(100);
    const [showBrightnessOverlay, setShowBrightnessOverlay] = useState(false);
    const touchStartRef = useRef({ y: 0, type: null, startValue: 0 });
    const volOverlayTimerRef = useRef(null);
    const [isMuted, setIsMuted] = useState(false);
    const [isFullscreen, setIsFullscreen] = useState(false);
    const [isCssFullscreen, setIsCssFullscreen] = useState(false);
    const [showControls, setShowControls] = useState(true);
    const controlTimeoutRef = useRef(null);

    // --- MANAGE CURRENT TIME ON EPISODE CHANGE ---
    useEffect(() => {
        if (!activeEp || !currentMovie) return;
        let targetTime = 0;
        try {
            const progress = JSON.parse(localStorage.getItem('miniflix-progress') || '{}');
            if (progress[currentMovie.id]) {
                const p = progress[currentMovie.id];
                if (!currentMovie.isSeries || (p.season === activeEp.season && p.episode === activeEp.episode)) {
                    targetTime = p.time || 0;
                }
            }
        } catch(e) {}
        
        currentTimeRef.current = targetTime;
        setCurrentVideoTime(targetTime);
        window.lastSavedTime = targetTime;
    }, [activeEp, currentMovie]);

    const saveLocalProgress = (time) => {
        if (!currentMovie) return;
        const lastSaved = window.lastSavedTime || 0;
        if (Math.abs(time - lastSaved) > 5) { // Save every 5 seconds
            window.lastSavedTime = time;
            try {
                const progress = JSON.parse(localStorage.getItem('miniflix-progress') || '{}');
                progress[currentMovie.id] = {
                    time: time,
                    season: activeEp?.season || null,
                    episode: activeEp?.episode || null,
                    timestamp: Date.now()
                };
                localStorage.setItem('miniflix-progress', JSON.stringify(progress));
            } catch(e) {}
        }
    };

    // Initial auto-hide for controls
    useEffect(() => {
        controlTimeoutRef.current = setTimeout(() => setShowControls(false), 4000);
        return () => clearTimeout(controlTimeoutRef.current);
    }, []);
    const [activeServerUrl, setActiveServerUrl] = useState('');
    // --- 🚦 সার্ভার লিস্ট টেনে আনার স্টেট 🚦 ---
    const [renderServers, setRenderServers] = useState([]);

    useEffect(() => {
        const fetchServers = async () => {
            try {
                // ১. প্রথমে চেক করা মেমোরিতে ডাটা আছে কি না
                const cachedData = localStorage.getItem('ziniplay_render_servers');
                if (cachedData) {
                    const parsedData = JSON.parse(cachedData);
                    const now = new Date().getTime();
                    // ২. ১৫ মিনিটের (৯,০০,০০০ মিলিসেকেন্ড) লজিক
                    if (now - parsedData.timestamp < 900000) {
                        setRenderServers(parsedData.list);
                        return; // ১৫ মিনিট পার না হলে ফায়ারবেসে যাবে না, এখান থেকেই লিংক দিয়ে দেবে
                    }
                }

                // ৩. ১৫ মিনিট পার হলে বা প্রথমবার ঢুকলে ফায়ারবেস থেকে নতুন লিংক আনবে
                const docSnap = await getDoc(doc(db, 'artifacts', appId, 'public', 'data', 'server_config', 'main'));
                if (docSnap.exists() && docSnap.data().list) {
                    const serverList = docSnap.data().list;
                    setRenderServers(serverList);
                    
                    // ৪. নতুন লিংকগুলো আবার আগামী ১৫ মিনিটের জন্য সেভ করে রাখবে
                    localStorage.setItem('ziniplay_render_servers', JSON.stringify({
                        list: serverList,
                        timestamp: new Date().getTime()
                    }));
                }
            } catch (error) {
                console.log("Error loading render servers:", error);
            }
        };
        fetchServers();
    }, []);
const [activeQuality, setActiveQuality] = useState(''); // এটি বর্তমান কোয়ালিটি ট্র্যাক করবে

// এই ম্যাজিক ফাংশনটি অটো-কোয়ালিটি এবং বাটনে ক্লিক—উভয় ক্ষেত্রেই লিংক ঠিক করবে
// এই ম্যাজিক ফাংশনটি অটো-কোয়ালিটি এবং বাটনে ক্লিক—উভয় ক্ষেত্রেই লিংক ঠিক করবে
    const formatAndSetUrl = (serverObj) => {
        if (!serverObj || !serverObj.url) return;
        setActiveQuality(serverObj.name); // কোন বাটনটিতে ক্লিক হলো তা সেভ করা
        
        let url = serverObj.url.trim();

        // --- 🚦 THE TRAFFIC POLICE LOGIC 🚦 ---
        // যদি লিংকটি টেলিগ্রামের হয় (https://t.me/c/...)
        if (url.includes('t.me/c/')) {
            // লিংক থেকে শুধু আইডিটা বের করে আনা (যেমন: 3787257015/4)
            const pathParts = url.split('t.me/c/')[1]; 

            // ডাটাবেস থেকে পাওয়া রেন্ডার সার্ভারগুলো চেক করা
            if (renderServers.length > 0) {
                // ম্যাজিক: র‍্যান্ডমলি যেকোনো একটা সার্ভার বেছে নেওয়া (ইউজার ভাগ করে দেওয়া)
                const randomServer = renderServers[Math.floor(Math.random() * renderServers.length)];
                // নতুন টেস্ট লিংক তৈরি করা (সাথে -100 যুক্ত করা)
                url = `${randomServer}/stream/-100${pathParts}`;
            } else {
                // যদি ফায়ারবেসে কোনো সার্ভার না থাকে, তবে ডিফল্ট আপনার ২য় সার্ভার দিয়ে দেওয়া
                url = `https://mp-api-v2.onrender.com/stream/-100${pathParts}`;
            }
        }
        // --------------------------------------

        if (url.includes('localhost')) { url = url.replace('localhost', window.location.hostname); }
        
        if (url.includes('youtube.com') || url.includes('youtu.be')) {
            const hasParams = url.includes('?');
            url = `${url}${hasParams ? '&' : '?'}enablejsapi=1&autoplay=${isAutoPlay ? 1 : 0}&controls=1&rel=0&modestbranding=1&showinfo=0&iv_load_policy=3`;
        } 
        else if (!url.includes('.mp4') && !url.includes('.mkv') && url.startsWith('http') && !url.includes('localhost:5000') && !url.includes('/stream/') && !url.includes('t.me/')) {
            url = `http://${window.location.hostname}:5000/api/stream?url=${encodeURIComponent(url)}`;
        }
        
        setActiveServerUrl(url);
        setVideoError(false);
    };
    const [videoError, setVideoError] = useState(false);
    const [showReportModal, setShowReportModal] = useState(false);
    const [reportIssue, setReportIssue] = useState('');
    const [showTrailer, setShowTrailer] = useState(false);
    const [showShareModal, setShowShareModal] = useState(false);

    const iframeRef = useRef(null);
    const relatedRef = useRef(null);
    const episodesRef = useRef(null);
const seasonsRef = useRef(null);
const scrollSeasons = (direction) => {
    if (seasonsRef.current) {
        const scrollAmount = direction === 'left' ? -300 : 300;
        seasonsRef.current.scrollBy({ left: scrollAmount, behavior: 'smooth' });
    }
};
    const scrollEpisodes = (direction) => {
    if (episodesRef.current) {
        const scrollAmount = direction === 'left' ? -300 : 300;
        episodesRef.current.scrollBy({ left: scrollAmount, behavior: 'smooth' });
    }
};
    const scrollRelated = (direction) => {
        if (relatedRef.current) {
            const scrollAmount = direction === 'left' ? -300 : 300;
            relatedRef.current.scrollBy({ left: scrollAmount, behavior: 'smooth' });
        }
    };
    const playerContainerRef = useRef(null);
    const videoRef = useRef(null);
    const clickTimeoutRef = useRef(null);

    // --- 🌟 SMART AD SYSTEM STATES 🌟 ---
    const [adStatus, setAdStatus] = useState({
        active: false,    
        type: null,       
        canSkip: false,   
        timeLeft: 0,      
        skipTimer: 0      
    });
    const lastAdTimeRef = useRef(0); 

    // --- 🪙 SMART EARNING STATES (NEW) ---
    const [earnConfig, setEarnConfig] = useState({ active: false, minutes: 10, reward: 1 });
    // --- SMART WATCH TIMER (Global Sync) ---
    const watchTimer = useRef((() => {
        // লোড করার সময় আজকের জমানো সময় নিয়ে শুরু করবে
        const today = new Date().toDateString();
        const saved = JSON.parse(localStorage.getItem('miniflix_watch_data') || '{"date": "", "time": 0}');
        return saved.date === today ? saved.time : 0;
    })()); // কতোক্ষণ দেখছে (সেকেন্ডে)
    const [showClaimBtn, setShowClaimBtn] = useState(false); // ক্লেইম বাটন দেখাবে কিনা
    
    // ১. ডাটাবেস থেকে কনফিগারেশন লোড করা (এবং না থাকলে অটোমেটিক তৈরি করা)
    useEffect(() => {
        const configRef = doc(db, 'artifacts', appId, 'public', 'data', 'coin_config', 'main');
        
        // A. অটোমেটিক চেক: ফাইল না থাকলে তৈরি করো (ডিফল্ট: ৫ মিনিট = ১০ কয়েন)
        // এতে আপনাকে ফায়ারবেসে গিয়ে কিছু করতে হবে না।
        getDoc(configRef).then((snap) => {
            if (!snap.exists()) {
                setDoc(configRef, { active: true, minutes: 5, reward: 10 });
                console.log("Auto-created coin config for Admin Panel");
            }
        });

        // B. রিয়েল-টাইম আপডেট: অ্যাডমিন প্যানেল থেকে চেঞ্জ করলে সাথে সাথে এখানে চেঞ্জ হবে
        const unsub = onSnapshot(configRef, (snap) => {
            if (snap.exists()) {
                setEarnConfig(snap.data());
            }
        });
        return () => unsub();
    }, []);

    // ২. ওয়াচ টাইমার লজিক (Advanced: Local Storage + Smart Trigger)
    useEffect(() => {
        let interval;
        // CHANGE: অ্যাডমিন প্যানেল থেকে active না থাকলে টাইমার চলবে না
        if (isPlaying && !adStatus.active && earnConfig.active) {
            interval = setInterval(() => {
                watchTimer.current += 1; // 👈 জাদুকরী আপডেট (রিলোড ছাড়াই সময় বাড়বে)
                const newTime = watchTimer.current;
                
                // ১. লোকাল স্টোরেজে সময় আপডেট করা
                const today = new Date().toDateString();
                const currentData = JSON.parse(localStorage.getItem('miniflix_watch_data') || '{"date": "", "time": 0, "claimed": []}');
                
                if (currentData.date !== today) {
                    localStorage.setItem('miniflix_watch_data', JSON.stringify({ date: today, time: newTime, claimed: [] }));
                } else {
                    localStorage.setItem('miniflix_watch_data', JSON.stringify({ ...currentData, time: newTime }));
                }

                // 2. লাইভ পপ-আপ লজিক (Smart Trigger)
                const intervalSeconds = (earnConfig.minutes || 30) * 60; 
                const maxLimitSeconds = intervalSeconds * 4;
                
                if (newTime > 0 && newTime <= maxLimitSeconds && newTime % intervalSeconds === 0) {
                    const taskId = Math.floor(newTime / intervalSeconds);
                    if (!currentData.claimed.includes(taskId)) {
                        setShowClaimBtn(true);
                        setTimeout(() => setShowClaimBtn(false), 5000);
                    }
                }
            }, 1000);
        }
        return () => clearInterval(interval);
    }, [isPlaying, adStatus.active, earnConfig]);

    // ৩. স্মার্ট কয়েন ক্লেইম ফাংশন (এরর ফিক্সড ভার্সন)
    const handleClaimCoin = async () => {
        const rewardAmount = Number(earnConfig.reward) || 1;
        const intervalSeconds = (earnConfig.minutes || 30) * 60;
        
        // বর্তমান সময়ের ওপর ভিত্তি করে টাস্ক আইডি বের করা
       const currentTaskID = Math.floor(watchTimer.current / intervalSeconds);

        // A. লোকাল স্টোরেজে 'Claimed' হিসেবে মার্ক করা
        const today = new Date().toDateString();
        const savedData = JSON.parse(localStorage.getItem('miniflix_watch_data') || '{"date": "", "time": 0, "claimed": []}');
        
        if (!savedData.claimed.includes(currentTaskID)) {
            const newClaimed = [...savedData.claimed, currentTaskID];
            localStorage.setItem('miniflix_watch_data', JSON.stringify({ ...savedData, claimed: newClaimed }));
            // নোট: setWatchProgress লাইনটি মুছে ফেলা হয়েছে কারণ এটি এখানে দরকার নেই
        }

        // B. ইউজারকে নোটিফিকেশন দেওয়া
        showNotification(`🎉 You earned ${rewardAmount} Coin!`);
        setShowClaimBtn(false); 

        // C. কয়েন ডাটাবেসে বা লোকাল ব্যালেন্সে যোগ করা
        if (user && !user.isAnonymous) {
            const userRef = doc(db, 'artifacts', appId, 'users', user.uid,);
            try {
                await updateDoc(userRef, { coins: increment(rewardAmount) });
                setCoins(prevCoins => prevCoins + rewardAmount);
            } catch (e) { console.error("Coin add error:", e); }
        } else {
            // গেস্ট ইউজার
            const currentCoins = Number(localStorage.getItem('miniflix_coins') || 0);
            const newBalance = currentCoins + rewardAmount;
            localStorage.setItem('miniflix_coins', newBalance);
            // যদি setCoins অ্যাপের মেইন স্কোপে থাকে তবে এটি কাজ করবে, না করলে সমস্যা নেই, লোকাল স্টোরেজ আপডেটই যথেষ্ট
            if (typeof setCoins === 'function') {
                setCoins(newBalance);
            }
        }
    };

    // Device & Ad Settings Check (Safe Access)
    const pauseAdSettings = isMobile ? (adConfig?.pauseAd?.mobile || {}) : (adConfig?.pauseAd?.pc || {});
    const midRollSettings = adConfig?.midRoll || {};
    const bottomAdSettings = isMobile ? (adConfig?.underVideo?.mobile || {}) : (adConfig?.underVideo?.pc || {});
    // 🆕 EXTERNAL AD SETTINGS (Scenario C)
    const externalAdSettings = adConfig?.external || { interval: 180, skipTime: 5, autoClose: 30 };

    const isOffline = typeof navigator !== 'undefined' && !navigator.onLine;
    let relatedMovies = movies.filter(m => m.id !== currentMovie.id && (m.genre === currentMovie.genre || m.category === currentMovie.category)).slice(0, 20);

    if (currentMovie.isOfflineMode) {
        if (currentMovie.seriesData && currentMovie.seriesData.episodes) {
            relatedMovies = currentMovie.seriesData.episodes
                .filter(e => currentMovie.title.indexOf(e.title) === -1)
                .map(e => ({ id: e.id, title: e.title, poster: currentMovie.poster, isOfflineEp: true, epData: e, seriesData: currentMovie.seriesData }));
        } else {
            relatedMovies = downloadedItems
                .filter(i => i.id !== currentMovie.id)
                .slice(0, 10)
                .map(i => ({ id: i.id, title: i.title, poster: i.poster, isOfflineMovie: true, itemData: i }));
        }
    }
    const isInWatchlist = userWatchlist.includes(currentMovie.id);
    const downloadLink = activeEp?.downloadUrl || currentMovie?.downloadUrl;

    // --- HELPER: Identify Source Type ---
    // --- HELPER: Identify Source Type (NEW LOGIC) ---
    // আমরা চেক করছি লিঙ্কটি ইউটিউব বা অন্য কোনো এম্বেড সাইট কিনা
    // --- HELPER: Identify Source Type (FINAL FIXED) ---
    
    // ১. প্রথমে চেক করছি এটা ইউটিউব কিনা (কালো পর্দার জন্য এটা লাগবেই)
    const isYoutube = activeServerUrl?.includes('youtube') || activeServerUrl?.includes('youtu.be');

    // ২. চেক করছি এটা এম্বেড প্লেয়ার কিনা (Youtube + Facebook + অন্যান্য)
    // এটি Iframe প্লেয়ারের জন্য ব্যবহার হবে
    // ২. চেক করছি এটা এম্বেড প্লেয়ার কিনা (Youtube + Facebook + অন্যান্য)
    let isEmbed = isYoutube ||
                    activeServerUrl?.includes('ok.ru') || 
                    activeServerUrl?.includes('facebook') || 
                    activeServerUrl?.includes('dailymotion') || 
                    activeServerUrl?.includes('vimeo') || 
                    activeServerUrl?.includes('embed');

    // ফিক্স: যদি লিংকটি আমাদের Node.js সার্ভারের (/api/stream) হয়, তবে এটি কোনোভাবেই Iframe হবে না।
    // ফিক্স: যদি লিংকটি আমাদের Node.js সার্ভারের বা টেলিগ্রাম সার্ভারের (/stream/) হয়, তবে এটি কোনোভাবেই Iframe হবে না।
    if (activeServerUrl?.includes('/api/stream') || activeServerUrl?.includes('/stream/')) {
        isEmbed = false;
    }
    // ৩. বাকি সব লিঙ্ক (টেলিগ্রাম/সার্ভার/MP4) ডাইরেক্ট ভিডিও হিসেবে ধরব
    // এটি Native Video Player এর জন্য ব্যবহার হবে
    const isDirectFile = !isEmbed;

    // ৪. পুরানো কোডের এরর ঠেকানোর জন্য এটি রাখা হলো
    const isExternal = !isYoutube && !isDirectFile;
    // --- HELPER: GET SERVERS ---
    const getServers = (data) => {
      if (data?.servers && Array.isArray(data.servers) && data.servers.length > 0) return data.servers;
      const s = [];
      if (data?.videoUrl) s.push({ name: "Server 1", url: data.videoUrl });
      if (data?.videoUrl2) s.push({ name: "Server 2", url: data.videoUrl2 });
      if (data?.videoUrl3) s.push({ name: "Server 3", url: data.videoUrl3 });
      return s;
    };

    // --- EPISODE LOADING ---
    useEffect(() => { 
      if (!user) return;
      
      if (currentMovie?.isSeries) { 
        const fetchEpisodes = async () => {
          try {
            const q = query(collection(db, 'artifacts', appId, 'public', 'data', 'movies', currentMovie.id, 'episodes')); 
            const snapshot = await getDocs(q);
            const eps = snapshot.docs.map(doc => ({ id: doc.id, ...doc.data() })); 
            setEpisodes(eps); 
            
            // --- LOAD LOCAL PROGRESS ---
            let targetEp = null;
            try {
                const progress = JSON.parse(localStorage.getItem('miniflix-progress') || '{}');
                if (progress[currentMovie.id] && progress[currentMovie.id].season && progress[currentMovie.id].episode) {
                    targetEp = eps.find(e => e.season === progress[currentMovie.id].season && e.episode === progress[currentMovie.id].episode);
                    if (targetEp) {
                        setSelectedSeason(targetEp.season);
                    }
                }
            } catch(e) {}

            if (targetEp) {
                setActiveEp(targetEp);
            } else {
                const s1ep1 = eps.find(e => e.season === '1' && e.episode === '1'); 
                if (s1ep1) setActiveEp(s1ep1); 
                else if (eps.length > 0) setActiveEp(eps[0]); 
            }
          } catch (error) {
            console.error("Error fetching episodes:", error);
          }
        };
        fetchEpisodes();
      } else { 
        setActiveEp(currentMovie); 
      } 
    }, [currentMovie, user]);

   // --- SERVER & YOUTUBE PARAMS (UPDATED FOR QUALITY SWITCHER) ---
    useEffect(() => {
      if (!activeEp) return;

      const playSource = activeEp;
      if (playSource) {
        const servers = getServers(playSource);
        if (servers.length > 0) {
          
          let targetQualityName = "720p"; 
          if (navigator.connection && navigator.connection.downlink) {
              const speed = navigator.connection.downlink; 
              if (speed >= 5) targetQualityName = "1080p";
              else if (speed >= 2) targetQualityName = "720p";
              else targetQualityName = "480p";
          }
          let selectedServer = servers.find(s => s.name === targetQualityName && s.url.trim() !== '');
          if (!selectedServer) {
              selectedServer = servers.find(s => s.url && s.url.trim() !== '') || servers[0];
          }
          
          // আমাদের নতুন ফাংশনটিকে কল করে দিলাম
          formatAndSetUrl(selectedServer);
          
        } else {
          setActiveServerUrl('');
        }
      }
    }, [activeEp, currentMovie, isAutoPlay, renderServers]);

   // --- RATING FETCH (OPTIMIZED FOR 1 READ LIMIT) ---
    useEffect(() => { 
        if (!currentMovie?.id) return;

        const fetchAverageRating = async () => {
            try {
                const reviewsRef = collection(db, 'artifacts', appId, 'public', 'data', 'movies', currentMovie.id, 'reviews');
                
                // ফায়ারবেসের সার্ভার নিজে গড় রেটিং হিসাব করবে
                const snapshot = await getAggregateFromServer(reviewsRef, {
                    avgRating: average('rating')
                });
                
                const avg = snapshot.data().avgRating;
                if (avg !== null) {
                    setAvgRating(avg.toFixed(1));
                } else {
                    setAvgRating(0);
                }
            } catch (error) {
                console.error("Average rating fetch error:", error);
                setAvgRating(0);
            }
        };

        fetchAverageRating();
    }, [currentMovie.id]);
    const playSource = activeEp || currentMovie;
    const servers = getServers(playSource);

    // --- 🆕 PRE-ROLL AD TRIGGER (NEW) ---
    useEffect(() => {
        const prConfig = isMobile ? adConfig?.preRoll?.mobile : adConfig?.preRoll?.pc;
        const generalConfig = adConfig?.preRoll || {};

        // পরিবর্তন: এখানে && !isPremium যোগ করা হয়েছে
        if (prConfig?.active && !isPremium) {
            console.log("Pre-Roll Ad Started");
            setIsPlaying(false); 
            setAdStatus({
                active: true,
                type: 'preroll',
                canSkip: false,
                timeLeft: Number(generalConfig.autoClose) || 30,
                skipTimer: Number(generalConfig.skipTime) || 5
            });
        }
    }, [isPremium]); // ডিপেন্ডেন্সিতে isPremium যোগ করুন
    // --- 🌟 SMART AD LOGIC (TIMER & SKIP) 🌟 ---
    useEffect(() => {
        let interval;
        if (adStatus.active) {
            interval = setInterval(() => {
                setAdStatus(prev => {
                    if (prev.timeLeft > 0 && prev.timeLeft - 1 <= 0) {
                          handleAdClose(); 
                          return { ...prev, active: false, timeLeft: 0 };
                    }
                    const newSkipTimer = prev.skipTimer > 0 ? prev.skipTimer - 1 : 0;
                    const newSkipTimerCanSkip = newSkipTimer === 0;
                    return { ...prev, timeLeft: prev.timeLeft > 0 ? prev.timeLeft - 1 : 0, skipTimer: newSkipTimer, canSkip: newSkipTimerCanSkip };
                });
            }, 1000);
        }
        return () => clearInterval(interval);
    }, [adStatus.active]);

    // --- 🆕 GLOBAL TIMER AD (SCENARIO C: EXTERNAL SOURCES) FIXED ---
    useEffect(() => {
        // ১. সেফটি চেক: যদি সেটিংস লোড না হয়ে থাকে, তবে অপেক্ষা করবে
        if (!externalAdSettings) return;

        // ২. বর্তমানে স্ক্রিনে অ্যাড আছে কি না চেক করা
        if (adStatus.active) return; 

        // [FIXED LOGIC] ৩. ডিভাইস অনুযায়ী 'Active' স্ট্যাটাস চেক করা
        const isSmallScreen = typeof window !== 'undefined' ? window.innerWidth < 768 : false;
        const currentActiveStatus = isSmallScreen 
            ? externalAdSettings.mobile?.active  // মোবাইলের জন্য
            : externalAdSettings.pc?.active;     // পিসির জন্য

        // পরিবর্তন: যদি অ্যাড বন্ধ থাকে অথবা ইউজার প্রিমিয়াম হয়, তবে রিটার্ন করবে
        if (!currentActiveStatus || isPremium) return;

        // ৪. টাইমার সেটআপ (অ্যাডমিন প্যানেলের ভ্যালু ব্যবহার করে)
        const intervalSeconds = parseInt(externalAdSettings.interval || 180);
        if (intervalSeconds <= 0) return;

        const timer = setInterval(() => {
             setAdStatus({
                active: true,
                type: 'external_timer',
                canSkip: false,
                timeLeft: parseInt(externalAdSettings.autoClose || 30),
                skipTimer: parseInt(externalAdSettings.skipTime || 5)
            });
        }, intervalSeconds * 1000);
        return () => clearInterval(timer);
    }, [adStatus.active, externalAdSettings, isPremium]); // ডিপেন্ডেন্সিতে isPremium যোগ করুন


    const handleAdClose = () => {
        const currentType = adStatus.type; 
        setAdStatus({ active: false, type: null, canSkip: false, timeLeft: 0, skipTimer: 0 });

        // লজিক: Pre-Roll বা Midroll শেষ হলে ভিডিও চালু হবে
        if ((currentType === 'midroll' || currentType === 'preroll') && !isPlaying && !isExternal) {
            togglePlay();
        }
    };
    // --- 🌟 AUTO PAUSE LOGIC (ALL PLAYERS) 🌟 ---
    useEffect(() => {
        if (adStatus.active) {
            // ১. যদি টেলিগ্রাম বা MP4 ভিডিও চলে, তবে থামাও (এটি ১০০% কাজ করবে)
            if (videoRef.current) {
                videoRef.current.pause();
            }

            // ২. যদি ইউটিউব বা আইফ্রেম চলে, তবে থামানোর মেসেজ পাঠাও (এটি সব সময় কাজ নাও করতে পারে)
            if (iframeRef.current) {
                // ইউটিউব এবং কিছু সাপোর্টেড প্লেয়ার এই কমান্ডে থামবে
                iframeRef.current.contentWindow.postMessage(JSON.stringify({ "event": "command", "func": "pauseVideo", "args": [] }), '*');
            }
        } else {
            // অ্যাড শেষ হলে আবার চালু করার চেষ্টা করো (শুধুমাত্র যদি প্লে অবস্থায় থাকে)
            if (isPlaying) {
                if (videoRef.current) {
                    videoRef.current.play().catch(e => console.log("Auto-resume blocked:", e));
                }
                if (iframeRef.current) {
                    iframeRef.current.contentWindow.postMessage(JSON.stringify({ "event": "command", "func": "playVideo", "args": [] }), '*');
                }
            }
        }
    }, [adStatus.active, isPlaying]);

    const handleReportSubmit = async () => {
       if (!reportIssue.trim()) return;
       try {
         await addDoc(collection(db, 'artifacts', appId, 'public', 'data', 'reports'), {
           movieId: currentMovie.id, movieTitle: currentMovie.title, episode: activeEp && currentMovie.isSeries ? `S${activeEp.season} E${activeEp.episode}` : 'N/A', server: activeServerUrl, issue: reportIssue, status: 'open', createdAt: serverTimestamp()
         });
         showNotification(t.reportSent); setShowReportModal(false); setReportIssue('');
       } catch(e) { console.error(e); }
    };

   const seekRelative = (seconds) => {
        const newTime = currentTimeRef.current + seconds;
        
        if (isEmbed && iframeRef.current) {
            iframeRef.current.contentWindow.postMessage(JSON.stringify({ "event": "command", "func": "seekTo", "args": [newTime, true] }), '*');
        } else if (!isEmbed && videoRef.current) {
            videoRef.current.currentTime = newTime;
        }
        
        setCurrentVideoTime(newTime);
        currentTimeRef.current = newTime;
    };

    const handleSeek = (e) => {
        const newTime = parseFloat(e.target.value);
        setCurrentVideoTime(newTime);
        currentTimeRef.current = newTime;

        if (isEmbed && iframeRef.current) {
            iframeRef.current.contentWindow.postMessage(JSON.stringify({ "event": "command", "func": "seekTo", "args": [newTime, true] }), '*');
        } else if (!isEmbed && videoRef.current) {
            // ডাইরেক্ট ভিডিও টেনে দেখার লজিক
            videoRef.current.currentTime = newTime;
        }
    };

    // --- KEYBOARD SHORTCUTS (Only for Custom Player) ---
    useEffect(() => {
        const handleKeyDown = (e) => {
            if (!isDirectFile || adStatus.active) return; 
            
            if (e.key === "ArrowRight") { 
                seekRelative(10); setShowForwardAnim(true); setTimeout(() => setShowForwardAnim(false), 500); 
            } else if (e.key === "ArrowLeft") { 
                seekRelative(-10); setShowRewindAnim(true); setTimeout(() => setShowRewindAnim(false), 500); 
            } else if (e.key === " " || e.key === "Spacebar") { 
                e.preventDefault(); // পেজ যেন নিচে নেমে না যায়
                togglePlay(); 
            }
        };
        window.addEventListener("keydown", handleKeyDown);
        return () => window.removeEventListener("keydown", handleKeyDown);
    }, [isDirectFile, isPlaying, adStatus.active]);

    const playNextEpisode = useCallback(() => {
        if (!currentMovie.isSeries || !activeEp) return;
        const sortedEps = [...episodes].sort((a, b) => (Number(a.season) - Number(b.season)) || (Number(a.episode) - Number(b.episode)));
        const currentIndex = sortedEps.findIndex(e => e.id === activeEp.id);
        if (currentIndex !== -1 && currentIndex < sortedEps.length - 1) {
            const nextEp = sortedEps[currentIndex + 1];
            
            // Clear saved time for the NEXT episode so it starts from beginning
            try {
                const progress = JSON.parse(localStorage.getItem('miniflix-progress') || '{}');
                if (progress[currentMovie.id]) {
                    progress[currentMovie.id] = { time: 0, season: nextEp.season, episode: nextEp.episode, timestamp: Date.now() };
                    localStorage.setItem('miniflix-progress', JSON.stringify(progress));
                }
            } catch (e) {}

            setActiveEp(nextEp); setSelectedSeason(nextEp.season); showNotification(`Playing S${nextEp.season} E${nextEp.episode}`);
        }
    }, [episodes, activeEp, currentMovie.isSeries]);

    // --- VIDEO EVENT LISTENER (Handling YouTube & compatible players) ---
    useEffect(() => {
        const handleMessage = (event) => {
            if (typeof event.data === 'string') {
                try {
                    const data = JSON.parse(event.data);
                    if (data.event === 'infoDelivery' && data.info) {
                        
                        if (data.info.duration) setDuration(data.info.duration);

                        if (data.info.currentTime) {
                            const time = data.info.currentTime;
                            setCurrentVideoTime(time);
                            currentTimeRef.current = time;
                            saveLocalProgress(time);

                            // 🌟 MID-ROLL AD LOGIC (Scenario A & B) 🌟
                            const intervalSec = parseInt(midRollSettings.interval || 60); 

                            // Only run Mid-roll logic if NOT external (External uses Global Timer)
                            // পরিবর্তন: এখানে && !isPremium যোগ করা হয়েছে
                            if (!isExternal && intervalSec > 0 && isPlaying && !adStatus.active && !isPremium) {
                                const timeInSeconds = Math.floor(time);
                                if (timeInSeconds > 0 && timeInSeconds % intervalSec === 0 && Math.abs(timeInSeconds - lastAdTimeRef.current) > 2) {
                                    lastAdTimeRef.current = timeInSeconds;
                                    setIsPlaying(false);
                                    if (iframeRef.current) iframeRef.current.contentWindow.postMessage(JSON.stringify({ "event": "command", "func": "pauseVideo", "args": [] }), '*');
                                    setAdStatus({
                                        active: true,
                                        type: 'midroll',
                                        canSkip: false,
                                        timeLeft: midRollSettings.autoClose || 30,
                                        skipTimer: midRollSettings.skipTime || 5
                                    });
                                }
                            }
                        }
                        if (data.info.playerState !== undefined) {
                            if (data.info.playerState === 1) setIsPlaying(true);
                            if (data.info.playerState === 2) setIsPlaying(false);
                            if (data.info.playerState === 0) {
                                setIsPlaying(false);
                                if (currentMovie?.isSeries) playNextEpisode();
                            }
                        }
                    }
                } catch (e) {}
            }
        };
        window.addEventListener('message', handleMessage);
        return () => window.removeEventListener('message', handleMessage);
    }, [isAutoPlay, playNextEpisode, midRollSettings, isPlaying, adStatus.active, isExternal]);

    useEffect(() => {
        const handleFullscreenChange = () => {
            const isNativeFs = !!document.fullscreenElement;
            setIsFullscreen(isNativeFs);
            if (!isNativeFs) { setIsCssFullscreen(false); if (window.screen?.orientation?.unlock) try { window.screen.orientation.unlock(); } catch (err) {} }
        };
        document.addEventListener("fullscreenchange", handleFullscreenChange);
        return () => document.removeEventListener("fullscreenchange", handleFullscreenChange);
    }, []);

    const togglePlay = () => {
        // ১. ইউটিউব বা Iframe এর জন্য
        if (isEmbed && iframeRef.current) {
            const command = isPlaying ? "pauseVideo" : "playVideo";
            iframeRef.current.contentWindow.postMessage(JSON.stringify({ "event": "command", "func": command, "args": [] }), '*');
        } 
        // ২. আমাদের ডাইরেক্ট ভিডিওর জন্য (নতুন লজিক)
        else if (!isEmbed && videoRef.current) {
            if (isPlaying) {
                videoRef.current.pause();
            } else {
                // ব্রাউজারের সিকিউরিটি এরর হ্যান্ডেল করা হলো
                const playPromise = videoRef.current.play();
                if (playPromise !== undefined) {
                    playPromise.catch(error => {
                        console.log("Play blocked by browser:", error);
                        // ব্রাউজার প্লে করতে না দিলে প্লে বাটন দেখিয়ে পজ অবস্থায় রাখবে
                        setIsPlaying(false); 
                    });
                }
            }
        }

        // Pause Ad Logic 
        if (!isExternal && !isPremium) {
            if (isPlaying && pauseAdSettings?.active) {
                 setAdStatus({ active: true, type: 'pause', canSkip: true, timeLeft: 0, skipTimer: 0 });
            } else if (adStatus.active && adStatus.type === 'pause') {
                 setAdStatus(prev => ({ ...prev, active: false }));
            }
        }
        setIsPlaying(!isPlaying);
    };

    const handleTouchStart = (e) => {
        if (!isDirectFile) return; // শুধু ডাইরেক্ট ভিডিওর জন্য কাজ করবে
        const touch = e.touches[0];
        const screenWidth = window.innerWidth;
        const isRightSide = touch.clientX > screenWidth / 2;

        touchStartRef.current = {
            y: touch.clientY,
            type: isRightSide ? 'volume' : 'brightness',
            startValue: isRightSide ? volume : brightness
        };
    };

    const handleTouchMove = (e) => {
        if (!touchStartRef.current.type || !isDirectFile) return;
        
        const touch = e.touches[0];
        const deltaY = touchStartRef.current.y - touch.clientY; 
        
        // ২০০ পিক্সেল সোয়াইপ করলে ১০০% পরিবর্তন হবে
        const change = (deltaY / 200) * 100; 
        let newValue = Math.min(Math.max(touchStartRef.current.startValue + change, 0), 100);

        if (touchStartRef.current.type === 'volume') {
            handleVolume(newValue);
        } else {
            setBrightness(newValue);
            setShowBrightnessOverlay(true);
            clearTimeout(volOverlayTimerRef.current);
            volOverlayTimerRef.current = setTimeout(() => setShowBrightnessOverlay(false), 2000);
        }
    };

    const handleTouchEnd = () => {
        touchStartRef.current = { y: 0, type: null, startValue: 0 };
    };
    const handleVolume = (newVolume) => {
        setVolume(newVolume);
        if(newVolume > 0) setIsMuted(false);
        if (isEmbed && iframeRef.current) {
            iframeRef.current.contentWindow.postMessage(JSON.stringify({ "event": "command", "func": "setVolume", "args": [newVolume] }), '*');
        } else if (!isEmbed && videoRef.current) {
            videoRef.current.volume = newVolume / 100;
        }
        
        // স্ক্রিনে পপআপ দেখানোর লজিক
        setShowVolOverlay(true);
        clearTimeout(volOverlayTimerRef.current);
        volOverlayTimerRef.current = setTimeout(() => setShowVolOverlay(false), 2000);
    };

    const toggleMute = () => {
        if (isMuted) {
            if (!isEmbed && videoRef.current) videoRef.current.muted = false;
            if (isEmbed && iframeRef.current) iframeRef.current.contentWindow.postMessage(JSON.stringify({ "event": "command", "func": "unMute", "args": [] }), '*');
            
            setIsMuted(false);
            const restoreVolume = volume > 0 ? volume : 100;
            handleVolume(restoreVolume);
        } 
        else { 
            setIsMuted(true);
            if (!isEmbed && videoRef.current) videoRef.current.muted = true;
            if (isEmbed && iframeRef.current) iframeRef.current.contentWindow.postMessage(JSON.stringify({ "event": "command", "func": "mute", "args": [] }), '*');
            
            // স্ক্রিনে মিউট পপআপ দেখানোর লজিক
            setShowVolOverlay(true);
            clearTimeout(volOverlayTimerRef.current);
            volOverlayTimerRef.current = setTimeout(() => setShowVolOverlay(false), 2000);
        }
    };

    const changeQuality = (quality) => {
        if (iframeRef.current) { iframeRef.current.contentWindow.postMessage(JSON.stringify({ "event": "command", "func": "setPlaybackQuality", "args": [quality] }), '*'); showNotification(`${t.quality}: ${quality}`); }
        setIsSettingsOpen(false);
    };

    const toggleFullscreen = async () => {
        const elem = playerContainerRef.current;
        if (!elem) return;

        if (isCssFullscreen && !document.fullscreenElement) {
             // Just exit CSS fullscreen if that's what's currently active
             setIsCssFullscreen(false);
             setIsFullscreen(false);
             try { await ScreenOrientation.unlock(); } catch(e) {}
             if (window.screen?.orientation?.unlock) try { window.screen.orientation.unlock(); } catch (err) {}
             return;
        }

        try {
            if (!document.fullscreenElement && !document.webkitFullscreenElement) {
                // ১. ভিডিও কন্টেইনারকে ফুলস্ক্রিন করা
                if (elem.requestFullscreen) {
                    await elem.requestFullscreen();
                } else if (elem.webkitRequestFullscreen) { 
                    await elem.webkitRequestFullscreen();
                }

                // ২. স্ক্রিন ঘোরানো (৩০০ মিলি-সেকেন্ড সময় দিয়ে, যেন ব্রাউজার ক্র্যাশ না করে)
                setTimeout(async () => {
                    try {
                        // APK (Capacitor) এর জন্য নেটিভ রোটেশন
                        await ScreenOrientation.lock({ orientation: 'landscape' });
                    } catch(e) { 
                        console.log("APK Orientation Lock Error:", e); 
                        // ওয়েবসাইটের জন্য ব্যাকআপ রোটেশন
                        if (window.screen && window.screen.orientation && window.screen.orientation.lock) {
                            window.screen.orientation.lock('landscape').catch(err => console.log("Web Orientation Lock Error:", err));
                        }
                    }
                }, 300);
                setIsFullscreen(true);
            } else {
                // ১. ফুলস্ক্রিন থেকে বের হওয়া
                if (document.exitFullscreen) {
                    await document.exitFullscreen();
                } else if (document.webkitExitFullscreen) { 
                    await document.webkitExitFullscreen();
                }
                
                // ২. স্ক্রিন আবার সোজা (portrait) করা
                try {
                    await ScreenOrientation.unlock();
                } catch(e) { 
                    console.log("APK Orientation Unlock Error:", e); 
                    if (window.screen && window.screen.orientation && window.screen.orientation.unlock) {
                        window.screen.orientation.unlock();
                    }
                }
                
                setIsFullscreen(false);
            }
       } catch (err) { 
            // ১. আপনার বাগ ধরার জন্য কনসোলে এরর দেখাবে
            console.log("Fullscreen API failed", err);
            
            // ২. ইউজারের জন্য ব্যাকআপ হিসেবে CSS ফুলস্ক্রিন চালু করে দেবে
            setIsCssFullscreen(!isFullscreen);
        }
    };

    const togglePiP = async () => {
        try { 
            if (document.pictureInPictureElement) {
                await document.exitPictureInPicture();
            } else if (!isEmbed && videoRef.current) {
                // ডাইরেক্ট ভিডিওর জন্য PiP চালু করা
                await videoRef.current.requestPictureInPicture();
            } else {
                showNotification("PiP is not supported for this video"); 
            }
        } catch (error) { 
            console.error("PiP Error:", error); 
        }
    };

    const handleZoneClick = (type) => {
        if (!isDirectFile || adStatus.active) return;

        if (clickTimeoutRef.current) {
            // ডাবল ট্যাপ: ভিডিও টানা
            clearTimeout(clickTimeoutRef.current);
            clickTimeoutRef.current = null;
            if (type === 'rewind') { 
                seekRelative(-10); setShowRewindAnim(true); setTimeout(() => setShowRewindAnim(false), 500);
            } else { 
                seekRelative(10); setShowForwardAnim(true); setTimeout(() => setShowForwardAnim(false), 500); 
            }
        } else { 
            // সিঙ্গেল ট্যাপ: শুধু কন্ট্রোলার দেখাবে বা লুকাবে (ভিডিও পজ হবে না)
            clickTimeoutRef.current = setTimeout(() => { 
                setShowControls(prev => {
                    const willShow = !prev;
                    if (willShow) {
                        clearTimeout(controlTimeoutRef.current);
                        controlTimeoutRef.current = setTimeout(() => setShowControls(false), 6000);
                    }
                    return willShow;
                });
                clickTimeoutRef.current = null; 
            }, 250);
        }
    };

    const handleFlip = () => setIsFlipped(!isFlipped);
    // --- 2x Speed Hold Logic ---
    const handlePointerDown = () => {
        if (!isDirectFile || !isPlaying) return;
        isLongPressRef.current = false; // নতুন ক্লিকে রিসেট
        speedTimeoutRef.current = setTimeout(() => {
            isLongPressRef.current = true; // এটি একটি লং প্রেস (চেপে ধরা) হিসেবে মার্ক হলো
            if (videoRef.current) videoRef.current.playbackRate = 2;
            setIsFastForwarding(true);
        }, 500); 
    };

    const handlePointerUp = () => {
        if (speedTimeoutRef.current) {
            clearTimeout(speedTimeoutRef.current);
            speedTimeoutRef.current = null;
        }
        if (isFastForwarding) {
            if (videoRef.current) videoRef.current.playbackRate = playbackRate; 
            setIsFastForwarding(false);
            // ছেড়ে দেওয়ার পর সামান্য সময় নেবে যাতে ভুল করে পজ না হয়ে যায়
            setTimeout(() => { isLongPressRef.current = false; }, 100);
        }
    };
    const handleZoom = () => { setZoomLevel(zoomLevel === 1 ? 1.2 : (zoomLevel === 1.2 ? 1.5 : 1)); };
    const handleSpeed = () => {
        let newRate = playbackRate === 1 ? 1.25 : (playbackRate === 1.25 ? 1.5 : (playbackRate === 1.5 ? 2 : (playbackRate === 2 ? 0.5 : 1)));
        setPlaybackRate(newRate);
        
        if (isEmbed && iframeRef.current) {
            iframeRef.current.contentWindow.postMessage(JSON.stringify({ "event": "command", "func": "setPlaybackRate", "args": [newRate] }), '*');
        } else if (!isEmbed && videoRef.current) {
            videoRef.current.playbackRate = newRate;
        }
    };

    if (!currentMovie) return null;
    const currentSeasonEpisodes = episodes.filter(ep => ep.season === selectedSeason).sort((a, b) => Number(a.episode) - Number(b.episode));
    const uniqueSeasons = [...new Set(episodes.map(ep => ep.season))].sort((a, b) => Number(a) - Number(b));
    if (uniqueSeasons.length === 0 && currentMovie.isSeries) uniqueSeasons.push('1');

    // ✅ DECISION: Show Custom Controls ONLY for MP4 (Scenario B)
    // Youtube gets native controls. External gets nothing.
    // ✅ DECISION: Show Custom Controls ONLY for MP4 (Scenario B)
    // Youtube gets native controls. External gets nothing.
    const showCustomControls = isDirectFile;

    return (
      <div className="fixed inset-0 bg-black z-[100] overflow-y-auto animate-in fade-in duration-300" dir={language === 'ar' ? 'rtl' : 'ltr'}>
        
        {/* PLAYER CONTAINER */}
        <div ref={playerContainerRef} className={`relative w-full bg-black flex items-center justify-center group ${isFullscreen || isCssFullscreen ? 'fixed inset-0 z-[9999] h-full w-full' : 'w-full aspect-video'}`}
            onPointerMove={(e) => { if (e.pointerType === 'mouse') { setShowControls(true); clearTimeout(controlTimeoutRef.current); controlTimeoutRef.current = setTimeout(() => setShowControls(false), 6000); } }}>
             {/* BACK BUTTON - Z-Index 60 (Kept safe) */}
             <div className={`absolute top-0 left-0 right-0 p-4 z-[60] transition-opacity duration-300 ${showControls ? 'opacity-100' : 'opacity-0'} pointer-events-none`}>
                <div className="flex justify-between items-center">
                    <button onClick={(e) => { e.stopPropagation(); if(document.fullscreenElement) document.exitFullscreen(); if(isCssFullscreen) setIsCssFullscreen(false); if(isCapacitor) ScreenOrientation.lock({ orientation: 'portrait' }).catch(()=>{}); setView('home'); }} className="bg-black/50 p-2 rounded-full hover:bg-red-600 text-white backdrop-blur-sm border border-white/10 pointer-events-auto"><ArrowLeft size={24}/></button>
                    <h2 className="text-white font-bold truncate px-4 drop-shadow-md flex-1 text-center pointer-events-none">
    {currentMovie.title} {currentMovie.isSeries && activeEp ? `- S${activeEp.season} E${activeEp.episode}` : ''}
</h2>
                    <div className="w-10"></div> 
                </div>
             </div>

             {/* PLAYER WRAPPER - HYBRID MODE (NEW CODE) */}
             <div className="w-full h-full overflow-hidden relative flex items-center justify-center bg-black" 
                  onTouchStart={handleTouchStart} 
                  onTouchMove={handleTouchMove} 
                  onTouchEnd={handleTouchEnd}>
                 <div className={`w-full h-full bg-black relative`}>
                  {/* Simulated Brightness Overlay */}
                    <div className="absolute inset-0 bg-black pointer-events-none z-20" style={{ opacity: 1 - (brightness / 100) }}></div>
                    
                    {isEmbed ? (
                        // 1. FOR YOUTUBE & EMBED SITES (IFRAME)
                        <>
                            <iframe 
                                ref={iframeRef} 
                                src={adStatus.active && adStatus.type === 'preroll' ? '' : getEmbedUrl(activeServerUrl, true, false, true)}
                                className="w-full h-full border-none transition-transform duration-300 origin-center bg-black" 
                                style={{ transform: `scale(${zoomLevel}) scaleX(${isFlipped ? -1 : 1})` }} 
                                allowFullScreen 
                                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" 
                                title={currentMovie.title}
                            ></iframe>
                            
                            
                        </>
                    ) : (
                        // 2. FOR TELEGRAM & DIRECT LINKS (NATIVE VIDEO)
                        <>
                       <video 
                            ref={videoRef}
                            src={activeServerUrl} 
                            autoPlay={isAutoPlay}
                            playsInline
                            webkit-playsinline="true"
                            className="w-full h-full object-contain"
                            style={{ 
                                transform: `scale(${zoomLevel}) scaleX(${isFlipped ? -1 : 1})`,
                                boxShadow: 'none',
                                backgroundColor: 'transparent',
                                zIndex: 10,
                                position: 'relative'
                            }}
                            onTimeUpdate={() => {
                                if (videoRef.current) {
                                    setCurrentVideoTime(videoRef.current.currentTime);
                                    currentTimeRef.current = videoRef.current.currentTime;
                                    saveLocalProgress(videoRef.current.currentTime);
                                }
                            }}
                            onLoadedMetadata={() => {
                                if (videoRef.current) {
                                     setDuration(videoRef.current.duration);
                                     // কোয়ালিটি চেঞ্জ করলে আগের জায়গা থেকে শুরু করার লজিক
                                     if (currentTimeRef.current > 0) {
                                         videoRef.current.currentTime = currentTimeRef.current;
                                     }
                                     
                                     // অটো-প্লে ব্লক হলে প্লেয়ারকে জানিয়ে দেওয়ার লজিক
                                     if (isAutoPlay) {
                                         const playPromise = videoRef.current.play();
                                         if (playPromise !== undefined) {
                                             playPromise.catch((error) => {
                                                 console.log("Browser blocked auto-play on reload", error);
                                                 setIsPlaying(false); // প্লেয়ারকে বলে দেওয়া যে ভিডিও পজ হয়ে আছে
                                             });
                                         }
                                     }
                                }
                            }}
                            onPlay={() => setIsPlaying(true)}
                            onPause={() => setIsPlaying(false)}
                            onLoadStart={() => setIsBuffering(true)}
                            onWaiting={() => setIsBuffering(true)}
                            onPlaying={() => { setIsBuffering(false); setIsPlaying(true); }}
                            onCanPlay={() => setIsBuffering(false)}
                            onEnded={() => {
                                setIsPlaying(false);
                                if (currentMovie?.isSeries) playNextEpisode();
                            }}
                            onError={(e) => { console.log("Video Error:", e); setVideoError(true); }}
                       />
                            {videoError && (() => {
                                const videoErrorTexts = {
                                    en: { title: "Video playback failed.", desc: "Please try another server." },
                                    bn: { title: "ভিডিওটি প্লে করা যাচ্ছে না।", desc: "দয়া করে অন্য সার্ভার চেষ্টা করুন।" },
                                    es: { title: "Error de reproducción.", desc: "Por favor, intente con otro servidor." },
                                    hi: { title: "वीडियो नहीं चल रहा है।", desc: "कृपया अन्य सर्वर का प्रयास करें।" },
                                    ar: { title: "فشل تشغيل الفيديو.", desc: "يرجى تجربة خادم آخر." },
                                    pt: { title: "Falha na reprodução.", desc: "Tente outro servidor." },
                                    ru: { title: "Ошибка воспроизведения.", desc: "Попробуйте другой сервер." },
                                    ja: { title: "動画の再生に失敗しました。", desc: "別のサーバーをお試しください。" },
                                    zh: { title: "视频播放失败。", desc: "请尝试其他服务器。" },
                                    de: { title: "Videowiedergabe fehlgeschlagen.", desc: "Versuchen Sie einen anderen Server." },
                                    id: { title: "Gagal memutar video.", desc: "Silakan coba server lain." }
                                };
                                const errorText = videoErrorTexts[language] || videoErrorTexts['en'];

                                return (
                                    <div className="absolute inset-0 flex flex-col items-center justify-center bg-black/80 z-[20] text-center px-4">
                                        <AlertCircle size={40} className="text-red-500 mb-2" />
                                        <p className="text-white text-sm font-bold">{errorText.title}</p>
                                        <p className="text-gray-400 text-xs mt-1">{errorText.desc}</p>
                                    </div>
                                );
                            })()}
                        </>
                    )}

                 </div>
             </div>

            {/* 🪙 CLAIM REWARD BUTTON (NEW) */}
            {showClaimBtn && (
                <div className="absolute top-20 right-4 z-[80] animate-bounce">
                    <button 
                        onClick={handleClaimCoin}
                        className="bg-yellow-500 text-black font-black px-4 py-2 rounded-full shadow-[0_0_20px_rgba(234,179,8,0.6)] border-2 border-white hover:scale-110 transition flex items-center gap-2"
                    >
                        <span>🎁 Claim {earnConfig.reward} Coin</span>
                    </button>
                </div>
            )}
            {/* PAUSE AD OVERLAY (Small Banner Style) */}
            {adStatus.active && adStatus.type === 'pause' && (
                <div className="absolute inset-0 z-[100] flex items-center justify-center pointer-events-none">
                    <div 
                        className="relative w-[85%] max-w-[320px] bg-gray-900 rounded-lg shadow-2xl overflow-hidden border border-gray-700 pointer-events-auto group animate-in zoom-in duration-300"
                        onClick={(e) => e.stopPropagation()}
                    >
                        {/* Close Button 'X' */}
                        <button 
                            onClick={(e) => { e.stopPropagation(); handleAdClose(); }} 
                            className="absolute top-2 right-2 bg-black/70 text-white p-1.5 rounded-full hover:bg-red-600 transition z-20 shadow-md border border-white/10"
                        >
                            <X size={16} />
                        </button>
                        
                        <div className="absolute top-2 left-2 bg-yellow-500 text-black text-[10px] font-bold px-2 py-0.5 rounded shadow z-20 uppercase tracking-widest">Ad</div>
                        
                        {/* Ad Content */}
                        {(() => {
                           if (pauseAdSettings?.provider === 'custom' && pauseAdSettings?.image) {
                             return <img src={pauseAdSettings.image} alt="Advertisement" className="w-full aspect-video object-cover cursor-pointer hover:opacity-90 transition" onClick={(e) => { e.stopPropagation(); window.open(pauseAdSettings.link || '#', '_blank'); }} />;
                           } else {
                             return <div className="w-full aspect-video flex items-center justify-center bg-gray-800 text-white text-sm font-bold cursor-pointer hover:bg-gray-700 transition" onClick={(e) => { e.stopPropagation(); window.open(pauseAdSettings?.link || '#', '_blank'); }}>Advertisement (Click Here)</div>;
                           }
                        })()}
                    </div>
                </div>
            )}

            {/* OTHER ADS OVERLAY (Midroll, Preroll, External Timer) */}
            {adStatus.active && adStatus.type !== 'pause' && (
                <div className="absolute inset-0 z-[100] bg-black flex flex-col items-center justify-center">
                    <div className="relative w-full h-full max-w-4xl max-h-[80vh] p-4 flex items-center justify-center" onClick={(e) => e.stopPropagation()}>
                        {(() => {
                           let imgSettings;
                           if (adStatus.type === 'midroll') imgSettings = midRollSettings;
                           else if (adStatus.type === 'preroll') imgSettings = isMobile ? adConfig?.preRoll?.mobile : adConfig?.preRoll?.pc;
                           else imgSettings = externalAdSettings; 

                           if (imgSettings?.provider === 'custom' && imgSettings?.image) {
                             return <img src={imgSettings.image} alt="Advertisement" className="max-w-full max-h-full object-contain cursor-pointer shadow-2xl border border-gray-700" onClick={() => window.open(imgSettings.link || '#', '_blank')} />;
                           } else {
                             return <div className="w-full h-64 flex items-center justify-center bg-gray-800 text-white text-lg font-bold border border-gray-600 rounded cursor-pointer" onClick={() => window.open(imgSettings?.link || '#', '_blank')}>Adsterra/Network Ad (Click Here)</div>;
                           }
                        })()}
                        <div className="absolute top-6 right-6">
                            {adStatus.canSkip ? <button onClick={handleAdClose} className="bg-black/80 text-white px-4 py-2 rounded-full font-bold border border-white/20 hover:bg-red-600 transition flex items-center gap-2">Skip Ad <SkipForward size={16}/></button> : <div className="bg-black/80 text-gray-300 px-4 py-2 rounded-full text-xs font-mono border border-white/10">Reward in {adStatus.skipTimer}s</div>}
                        </div>
                    </div>
                    <div className="absolute bottom-10 text-gray-500 text-xs">Advertisement</div>
                </div>
            )}
            

           {/* ON-SCREEN BRIGHTNESS OVERLAY */}
            {showBrightnessOverlay && (
                <div className="absolute inset-0 flex items-center justify-center pointer-events-none z-[80]">
                    <div className="bg-black/60 backdrop-blur-md px-6 py-4 rounded-2xl flex flex-col items-center gap-2 text-white animate-in zoom-in duration-200">
                        <Sun size={40} className={brightness < 30 ? "text-gray-400" : "text-yellow-400"} />
                        <div className="text-xl font-bold">{Math.round(brightness)}%</div>
                        <div className="w-24 h-1.5 bg-gray-600 rounded-full overflow-hidden mt-1">
                            <div className="h-full bg-yellow-400 transition-all duration-300" style={{ width: `${brightness}%` }} />
                        </div>
                    </div>
                </div>
            )}
           {/* ON-SCREEN VOLUME OVERLAY */}
            {showVolOverlay && (
                <div className="absolute inset-0 flex items-center justify-center pointer-events-none z-[80]">
                    <div className="bg-black/60 backdrop-blur-md px-6 py-4 rounded-2xl flex flex-col items-center gap-2 text-white animate-in zoom-in duration-200">
                        {isMuted || volume == 0 ? <VolumeX size={40} className="text-red-500" /> : <Volume2 size={40} />}
                        <div className="text-xl font-bold">{isMuted ? 0 : Math.round(volume)}%</div>
                        <div className="w-24 h-1.5 bg-gray-600 rounded-full overflow-hidden mt-1">
                            <div className="h-full bg-white transition-all duration-300" style={{ width: `${isMuted ? 0 : volume}%` }} />
                        </div>
                    </div>
                </div>
            )}
            {/* ⏳ LOADING SPINNER */}
            {isDirectFile && isBuffering && !videoError && (
                <div className="absolute inset-0 flex items-center justify-center pointer-events-none z-[20]">
                    <div className="w-14 h-14 border-4 border-gray-600 border-t-red-600 rounded-full animate-spin shadow-[0_0_15px_rgba(220,38,38,0.5)]"></div>
                </div>
            )}

            {/* CUSTOM CONTROLS (Only for MP4/Custom) */}
            {showCustomControls && !adStatus.active && (
              <div className={`absolute inset-0 z-30 pointer-events-none flex flex-col justify-between transition-opacity duration-300 ${showControls ? 'opacity-100' : 'opacity-0'}`}>
                <div className="h-20 pointer-events-none"></div>
                <div 
                    className="flex-1 flex w-full pointer-events-auto absolute inset-0 z-10"
                    onPointerDown={handlePointerDown}
                    onPointerUp={handlePointerUp}
                    onPointerLeave={handlePointerUp}
                    onPointerCancel={handlePointerUp}
                >
                      {/* 2x Speed Indicator */}
                      {isFastForwarding && (
                          <div className="absolute top-10 left-1/2 -translate-x-1/2 bg-black/70 text-white px-4 py-2 rounded-full font-bold flex items-center gap-2 animate-pulse z-50">
                              <span>▶▶ 2x Speed</span>
                          </div>
                      )}

                      {/* বাম পাশে ক্লিক বা ডাবল ট্যাপের জন্য */}
                      <div className="flex-1 flex items-center justify-center" onClick={(e) => { 
                          if (isLongPressRef.current) return; // লং-প্রেস হলে ক্লিক ইগনোর করবে
                          if(e.detail===2) handleZoneClick('rewind'); 
                          else handleZoneClick('center'); 
                      }}>
                          {showRewindAnim && <div className="bg-black/60 p-4 rounded-full animate-ping backdrop-blur-md"><RotateCcw size={30} className="text-white"/></div>}
                      </div>
                      
                      {/* ডান পাশে ক্লিক বা ডাবল ট্যাপের জন্য */}
                      <div className="flex-1 flex items-center justify-center" onClick={(e) => { 
                          if (isLongPressRef.current) return; // লং-প্রেস হলে ক্লিক ইগনোর করবে
                          if(e.detail===2) handleZoneClick('forward'); 
                          else handleZoneClick('center'); 
                      }}>
                          {showForwardAnim && <div className="bg-black/60 p-4 rounded-full animate-ping backdrop-blur-md"><RotateCw size={30} className="text-white"/></div>}
                      </div>
                      
                      {/* CENTER CONTROLS (Movie Box Style) */}
                      {showControls && !isBuffering && (
                          <div className={`absolute inset-0 flex items-center justify-center pointer-events-none z-20 ${!isFullscreen && isMobile ? 'gap-6' : 'gap-12 sm:gap-20'}`}>
                              <button 
                                  className={`rounded-full bg-black/40 hover:bg-red-600 text-white backdrop-blur-md transition-all pointer-events-auto border border-white/10 ${!isFullscreen && isMobile ? 'p-2 shadow-md' : 'p-3 sm:p-4 shadow-lg'}`}
                                  onClick={(e) => { e.stopPropagation(); seekRelative(-10); }}
                              >
                                  <RotateCcw className={!isFullscreen && isMobile ? 'w-6 h-6' : 'w-7 h-7 sm:w-[36px] sm:h-[36px]'} />
                              </button>
                              
                              <button 
                                  className={`rounded-full bg-black/40 hover:bg-red-600 text-white backdrop-blur-md transition-all pointer-events-auto border border-white/10 ${!isFullscreen && isMobile ? 'p-3 shadow-md' : 'p-4 sm:p-6 shadow-[0_0_15px_rgba(0,0,0,0.4)]'}`}
                                  onClick={(e) => { e.stopPropagation(); togglePlay(); }}
                              >
                                  {isPlaying ? <Pause fill="currentColor" className={!isFullscreen && isMobile ? 'w-8 h-8' : 'w-9 h-9 sm:w-[48px] sm:h-[48px]'} /> : <Play fill="currentColor" className={!isFullscreen && isMobile ? 'ml-1 w-8 h-8' : 'ml-1 w-9 h-9 sm:w-[48px] sm:h-[48px]'} />}
                              </button>
                              
                              <button 
                                  className={`rounded-full bg-black/40 hover:bg-red-600 text-white backdrop-blur-md transition-all pointer-events-auto border border-white/10 ${!isFullscreen && isMobile ? 'p-2 shadow-md' : 'p-3 sm:p-4 shadow-lg'}`}
                                  onClick={(e) => { e.stopPropagation(); seekRelative(10); }}
                              >
                                  <RotateCw className={!isFullscreen && isMobile ? 'w-6 h-6' : 'w-7 h-7 sm:w-[36px] sm:h-[36px]'} />
                              </button>
                          </div>
                      )}
                </div>

                <div className="p-4 bg-gradient-to-t from-black/90 via-black/60 to-transparent pointer-events-none z-50">
                    {/* SLIDER (Red Line) */}
                    <div className="w-full mb-4 relative flex items-center group/timeline h-4 pointer-events-auto">
                        <input
                            type="range"
                            min="0"
                            max={duration || 100}
                            value={currentVideoTime}
                            onChange={handleSeek}
                            className="absolute w-full h-1.5 bg-gray-600 rounded-lg appearance-none cursor-pointer accent-red-600 hover:h-2.5 transition-all z-50"
                            style={{
                                background: `linear-gradient(to right, #dc2626 ${(currentVideoTime / (duration || 100)) * 100}%, #4b5563 ${(currentVideoTime / (duration || 100)) * 100}%)`
                            }}
                        />
                    </div>
                    
                    <div className="flex justify-between items-center text-white">
                        <div className="flex items-center gap-4 pointer-events-auto">
                            <button onClick={togglePlay} className="hover:text-red-500 transition">{isPlaying ? <Pause size={28} fill="currentColor"/> : <Play size={28} fill="currentColor"/>}</button>
                            <div className="flex items-center gap-2 group/vol relative">
                                <button onClick={toggleMute} className="hover:text-red-500">{isMuted ? <VolumeX size={22}/> : <Volume2 size={22}/>}</button>
                                
                                {/* মোবাইলে লুকানোর জন্য hidden md:block যোগ করা হয়েছে */}
                                <input type="range" min="0" max="100" value={isMuted ? 0 : volume} onChange={(e) => handleVolume(e.target.value)} className="w-0 hidden md:block group-hover/vol:w-24 transition-all duration-300 h-1 accent-red-600 bg-gray-600 rounded-lg cursor-pointer" />
                                
                                <span className="absolute hidden md:block -top-8 right-0 px-2 py-1 text-[10px] font-bold text-white bg-black/90 rounded z-50 opacity-0 group-hover/vol:opacity-100 transition-opacity pointer-events-none border border-gray-700 shadow-lg">
                                    {isMuted ? 0 : volume}%
                                </span>
                            </div>
                            <span className="text-xs font-mono font-bold opacity-90 tracking-wider">
    {Math.floor(currentVideoTime / 60)}:{String(Math.floor(currentVideoTime % 60)).padStart(2, '0')} / {Math.floor((duration || 0) / 60)}:{String(Math.floor((duration || 0) % 60)).padStart(2, '0')}
</span>
                        </div>
                        <div className="flex items-center gap-5 pointer-events-auto">
                              <div className="relative">
                                  <button onClick={() => setIsSettingsOpen(!isSettingsOpen)} className="hover:text-red-500 text-white transition hover:scale-110"><Settings size={22} /></button>
                                  {isSettingsOpen && (
                                      <div className="absolute bottom-10 right-0 bg-black/95 border border-gray-700 rounded-lg w-48 overflow-hidden z-[60] text-white backdrop-blur-md shadow-xl mb-2">
                                          {/* Quality options removed for MP4 generally, keeping features logic */}
                                          <button onClick={handleSpeed} className="w-full px-4 py-2 text-left hover:bg-white/10 text-xs border-b border-gray-800 flex justify-between"><span>Speed</span><span>{playbackRate}x</span></button>
                                          <button onClick={handleZoom} className="w-full px-4 py-2 text-left hover:bg-white/10 text-xs border-b border-gray-800 flex justify-between"><span>Zoom</span><span>{zoomLevel === 1 ? '1x' : 'Zoomed'}</span></button>
                                          <button onClick={handleFlip} className="w-full px-4 py-2 text-left hover:bg-white/10 text-xs flex justify-between"><span>Flip</span><span>{isFlipped ? 'On' : 'Off'}</span></button>
                                      </div>
                                  )}
                              </div>
                              {!isCapacitor && <button onClick={togglePiP} className="hover:text-red-500 text-white transition hover:scale-110" title={t.pip}><PictureInPicture size={22}/></button>}
                              <button onClick={toggleFullscreen} className="hover:text-red-500 text-white transition hover:scale-110" title={t.fullscreen}>{isFullscreen ? <Minimize2 size={22}/> : <Scan size={22}/>}</button>
                              
                        </div>
                    </div>
                </div>
            </div>
            )}
        </div>
        
       {/* BOTTOM AD */}
        {/* পরিবর্তন: !isPremium && যোগ করা হয়েছে */}
        {!isPremium && bottomAdSettings.active && (
            <div className="w-full bg-black py-2 flex justify-center items-center border-b border-gray-800 relative group">
                 <div className="relative w-full max-w-[728px] h-[60px] md:h-[90px]">
                    <span className="absolute top-0 left-0 bg-gray-600 text-[8px] text-white px-1">AD</span>
                    {(() => {
                       if (bottomAdSettings.provider === 'custom') {
                           return <img src={bottomAdSettings.image} alt="Sponsor" className="w-full h-full object-contain cursor-pointer" onClick={() => window.open(bottomAdSettings.link || '#', '_blank')} />;
                       } else {
                          return <div className="w-full h-full flex items-center justify-center bg-gray-900 text-white text-xs cursor-pointer border border-gray-700" onClick={() => window.open(bottomAdSettings.link || '#', '_blank')}>Adsterra/Network Banner (Click)</div>;
                       }
                    })()}
                    <button onClick={(e) => { e.stopPropagation(); e.target.closest('.group').style.display = 'none'; }} className="absolute -top-2 -right-2 bg-red-600 text-white p-1 rounded-full opacity-0 group-hover:opacity-100 transition-opacity shadow-lg z-10"><X size={14} /></button>
                 </div>
            </div>
        )}

        {/* DETAILS SECTION */}
        <div className={`flex-1 p-6 space-y-4 pb-20 transition-colors ${styles.bg} ${styles.text}`}>
           <div><h1 className="text-2xl font-bold mb-1">{currentMovie.title}</h1>{currentMovie.isSeries && activeEp && <h2 className="text-sm text-red-500 font-medium">Season {activeEp.season} | Episode {activeEp.episode}</h2>}</div>
           <div className={`flex items-center gap-3 text-xs ${styles.subText} mb-4`}><span className={`px-2 py-1 rounded border ${theme === 'dark' ? 'bg-gray-800 border-gray-700' : 'bg-gray-200 border-gray-300'}`}>{currentMovie.category || 'Movie'}</span><span>{currentMovie.year || '2024'}</span>{currentMovie.lang && <span className={`px-2 py-1 rounded border ${theme === 'dark' ? 'bg-gray-800 border-gray-700' : 'bg-gray-200 border-gray-300'}`}>{currentMovie.lang}</span>}{currentMovie.imdbRating && (<span className="flex items-center gap-1 bg-yellow-500/20 text-yellow-500 px-2 py-0.5 rounded font-bold border border-yellow-500/30"><span className="bg-yellow-500 text-black text-[9px] px-1 rounded-sm mr-1">IMDb</span>{currentMovie.imdbRating}</span>)}{Number(avgRating) > 0 && (<span className="flex items-center gap-1 text-blue-400 font-bold"><Star size={12} fill="currentColor" /> {avgRating}/5</span>)}</div>

           {servers.length > 1 && (
             <div className="flex flex-wrap gap-2 mb-4">
                <div className="w-full text-xs font-bold opacity-70 mb-1 flex items-center gap-1"><Settings size={12}/> Video Quality</div>
                 {servers.map((s, idx) => ( <button key={idx} onClick={() => formatAndSetUrl(s)} className={`px-4 py-1.5 rounded text-xs font-bold transition-all border ${activeQuality === s.name ? 'bg-green-600 text-white border-green-600 shadow-md scale-105' : (theme === 'dark' ? 'bg-gray-800 border-gray-700 hover:border-gray-500' : 'bg-gray-100 border-gray-300 hover:border-gray-400')}`}>{s.name}</button> ))}
             </div>
           )}

           {/* --- ACTION BUTTONS (COMPACT MOBILE STYLE) --- */}
           <div className="flex gap-2.5 overflow-x-auto pb-4 mb-2 custom-scrollbar select-none">
             
             {/* 1. Trailer (High Priority) */}
             {currentMovie.trailerUrl && (
                <button 
                    onClick={() => setShowTrailer(true)} 
                    className={`flex-shrink-0 px-3 py-1.5 md:px-4 md:py-2.5 rounded-full font-bold text-xs flex items-center gap-1.5 border transition active:scale-95 ${
                        theme === 'dark' ? 'bg-gray-800 text-white border-gray-600 hover:bg-gray-700' : 'bg-gray-100 text-gray-900 border-gray-300'
                    }`}
                >
                    <Film size={14} className="text-red-500"/> {t.watchTrailer}
                </button>
             )}

             {/* 2. Download (Restricted to App Only) */}
             {downloadLink && (
                 isCapacitor ? (
                    <button 
                        onClick={(e) => { e.preventDefault(); e.stopPropagation(); startOfflineDownload(currentMovie, activeEp || null); }}
                        className={`flex-shrink-0 px-3 py-1.5 md:px-4 md:py-2.5 rounded-full font-bold text-xs flex items-center gap-1.5 border transition active:scale-95 ${
                            theme === 'dark' ? 'bg-gray-800 text-white border-gray-600 hover:bg-gray-700' : 'bg-gray-100 text-gray-900 border-gray-300'
                        }`}
                    >
                        {downloadingItems.find(i => i.url === (activeEp ? (activeEp.downloadUrl || activeEp.videoUrl) : downloadLink)) ? (
                            <><Loader size={14} className="animate-spin text-blue-500"/> Downloading...</>
                        ) : (
                            <><Download size={14} className="text-green-500"/> {t.download}</>
                        )}
                    </button>
                 ) : (
                    <a 
                        href={appLinks.find(l => l.type === 'mobile')?.url || '#'}
                        target="_blank"
                        rel="noopener noreferrer"
                        onClick={(e) => {
                            const mobileLink = appLinks.find(l => l.type === 'mobile');
                            if (!mobileLink) {
                                e.preventDefault();
                                alert("App download link is not available right now. Please add it from the Admin Panel.");
                            } else {
                                alert("Movie downloading is secured. Please install our App to download movies!");
                            }
                        }}
                        className={`flex-shrink-0 px-3 py-1.5 md:px-4 md:py-2.5 rounded-full font-bold text-xs flex items-center gap-1.5 border transition active:scale-95 animate-pulse-slow ${
                            theme === 'dark' ? 'bg-yellow-900/30 text-yellow-500 border-yellow-600 hover:bg-yellow-900/50' : 'bg-yellow-100 text-yellow-700 border-yellow-400 hover:bg-yellow-200'
                        }`}
                    >
                        <Download size={14} className="text-yellow-500"/> App Download
                    </a>
                 )
             )}

             {/* 3. Watchlist */}
             <button 
                onClick={() => toggleWatchlist(currentMovie.id)} 
                className={`flex-shrink-0 px-3 py-1.5 md:px-4 md:py-2.5 rounded-full font-bold text-xs flex items-center gap-1.5 border transition active:scale-95 ${
                    isInWatchlist 
                    ? 'bg-red-600 text-white border-red-600' 
                    : (theme === 'dark' ? 'bg-gray-800 text-white border-gray-600 hover:bg-gray-700' : 'bg-gray-100 text-gray-900 border-gray-300')
                }`}
             >
                {isInWatchlist ? <Check size={14} /> : <Plus size={14} className={isInWatchlist ? "text-white" : "text-blue-500"}/>} 
                {isInWatchlist ? t.removeFromWatchlist : t.addToWatchlist}
             </button>

             <button 
                onClick={async () => {
                    const shareUrl = `${window.location.origin}${window.location.pathname}?movie=${currentMovie?.id}`;
                    const shareData = {
                        title: `ZiniPlay - ${currentMovie?.title}`,
                        text: `Watch this amazing movie on ZiniPlay!\nMovie: ${currentMovie?.title}\n\nLink: `,
                        url: shareUrl
                    };

                    const isMobileDevice = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);

                    if (isMobileDevice && navigator.share) {
                try {
                    await navigator.share(shareData);
                } catch (error) {
                    // ইউজার শেয়ার ক্যানসেল করলে যেন অযথাই শেয়ার মডাল ওপেন না হয়
                    if (error.name !== "AbortError") {
                        console.log("Native share failed, opening backup modal.");
                        setShowShareModal(true);
                    }
                }
            } else {
                setShowShareModal(true);
            }
                }}
                className={`flex-shrink-0 px-3 py-1.5 md:px-4 md:py-2.5 rounded-full font-bold text-xs flex items-center gap-1.5 border transition active:scale-95 ${
                    theme === 'dark' ? 'bg-gray-800 text-white border-gray-600 hover:bg-gray-700' : 'bg-gray-100 text-gray-900 border-gray-300'
                }`}
            >
                <Share2 size={14} className={theme === 'dark' ? 'text-gray-400' : 'text-gray-600'} /> 
                {language === 'bn' ? 'শেয়ার' : 'Share'}
            </button>
        
             {/* 5. Report */}
             <button 
                onClick={() => setShowReportModal(true)} 
                className={`flex-shrink-0 px-3 py-1.5 md:px-4 md:py-2.5 rounded-full font-bold text-xs flex items-center gap-1.5 border transition active:scale-95 ${
                    theme === 'dark' ? 'bg-gray-800 text-red-400 border-gray-600 hover:bg-gray-700' : 'bg-gray-100 text-red-600 border-gray-300'
                }`}
             >
                <Flag size={14} /> {t.reportIssue}
             </button>

           </div>
           <p className={`leading-relaxed text-sm ${styles.subText}`}>{currentMovie.description || t.noDescription}</p>
           {currentMovie.cast && currentMovie.cast.length > 0 && (<div className="mt-6"><h3 className="font-bold mb-3 text-sm uppercase tracking-wider opacity-80 border-b border-gray-700 pb-1">{t.topCast}</h3><div className="flex gap-4 overflow-x-auto pb-2 custom-scrollbar">{currentMovie.cast.map((actor, idx) => (<div key={idx} className="flex flex-col items-center min-w-[80px]"><div className={`w-16 h-16 rounded-full overflow-hidden mb-2 border-2 ${theme === 'dark' ? 'border-gray-700' : 'border-gray-300'}`}><img src={actor.image} alt={actor.name} className="w-full h-full object-cover" onError={(e) => e.target.src='https://placehold.co/100x100?text=Actor'} /></div><span className="text-xs font-medium text-center leading-tight">{actor.name}</span></div>))}</div></div>)}
           {currentMovie.isSeries && (
            <div className="mt-6">
                
                {/* ১. সিজন সেকশন */}
                <div className="mb-6">
                    {/* সিজনের হেডিং এবং অ্যারো বাটন একই লাইনে */}
                    <div className="flex justify-between items-center mb-3 border-b border-gray-700 pb-1">
                        <h3 className="font-bold text-sm uppercase tracking-wider opacity-80">Seasons</h3>
                        <div className="hidden md:flex gap-2">
                            <button onClick={() => scrollSeasons('left')} className="bg-gray-800 hover:bg-red-600 p-1.5 rounded-full text-white transition shadow-lg z-20">
                                <ChevronLeft size={16}/>
                            </button>
                            <button onClick={() => scrollSeasons('right')} className="bg-gray-800 hover:bg-red-600 p-1.5 rounded-full text-white transition shadow-lg z-20">
                                <ChevronRight size={16}/>
                            </button>
                        </div>
                    </div>
                    
                    {/* সিজনের স্লাইডার */}
                    <div ref={seasonsRef} className="flex gap-2 overflow-x-auto custom-scrollbar scroll-smooth">
                        {uniqueSeasons.map(seasonNum => (
                            <button key={seasonNum} onClick={() => setSelectedSeason(seasonNum)} className={`px-4 py-2 rounded font-bold text-sm transition-colors whitespace-nowrap ${selectedSeason === seasonNum ? 'bg-red-600 text-white' : (theme === 'dark' ? 'bg-gray-800 text-gray-400 hover:text-white' : 'bg-gray-200 text-gray-600 hover:text-black')}`}>
                                S{seasonNum.padStart(2, '0')}
                            </button>
                        ))}
                    </div>
                </div>

                {/* ২. এপিসোড সেকশন */}
                <div>
                    {/* এপিসোডের হেডিং এবং অ্যারো বাটন একই লাইনে */}
                    <div className="flex justify-between items-center mb-3 border-b border-gray-700 pb-1">
                        <h3 className="font-bold text-sm uppercase tracking-wider opacity-80">{t.episodes}</h3>
                        <div className="hidden md:flex gap-2">
                            <button onClick={() => scrollEpisodes('left')} className="bg-gray-800 hover:bg-red-600 p-1.5 rounded-full text-white transition shadow-lg z-20">
                                <ChevronLeft size={16}/>
                            </button>
                            <button onClick={() => scrollEpisodes('right')} className="bg-gray-800 hover:bg-red-600 p-1.5 rounded-full text-white transition shadow-lg z-20">
                                <ChevronRight size={16}/>
                            </button>
                        </div>
                    </div>

                    {/* এপিসোডের স্লাইডার */}
                    <div ref={episodesRef} className="flex gap-3 overflow-x-auto pb-4 pt-1 custom-scrollbar scroll-smooth">
                        {currentSeasonEpisodes.map(ep => (
                            <button key={ep.id} onClick={() => setActiveEp(ep)} className={`py-3 px-4 min-w-[90px] flex-shrink-0 rounded-lg flex items-center justify-center font-bold text-sm transition-all border ${activeEp?.id === ep.id ? 'bg-red-600 text-white border-red-600 shadow-lg scale-105' : (theme === 'dark' ? 'bg-gray-800 text-gray-300 border-gray-700 hover:bg-gray-700' : 'bg-gray-100 text-gray-800 border-gray-200 hover:bg-gray-200')}`}>
                                Ep {ep.episode}
                            </button>
                        ))}
                    </div>
                </div>
                
            </div>
           )}
           <ReviewsSection movieId={currentMovie.id} />
           {relatedMovies.length > 0 ? (
            <div className="mt-8 relative group/section">
               <div className="flex justify-between items-center mb-3 border-b border-gray-700 pb-1">
                  <h3 className="font-bold text-sm uppercase tracking-wider opacity-80">
                      {currentMovie.isOfflineMode ? (currentMovie.seriesData ? "Other Episodes" : "Other Downloads") : t.relatedMovies}
                  </h3>
                  {/* PC Scroll Buttons */}
                  <div className="hidden md:flex gap-2">
                      <button onClick={() => scrollRelated('left')} className="bg-gray-800 hover:bg-red-600 p-1.5 rounded-full text-white transition shadow-lg z-20">
                        <ChevronLeft size={16}/>
                      </button>
                      <button onClick={() => scrollRelated('right')} className="bg-gray-800 hover:bg-red-600 p-1.5 rounded-full text-white transition shadow-lg z-20">
                        <ChevronRight size={16}/>
                      </button>
                  </div>
               </div>
               <div ref={relatedRef} className="flex gap-3 overflow-x-auto pb-4 custom-scrollbar scroll-smooth">
                  {relatedMovies.map(m => (
                    <div key={m.id} 
                         onClick={() => {
                             if (m.isOfflineEp) { playOfflineVideo(m.seriesData, m.epData); }
                             else if (m.isOfflineMovie) { playOfflineVideo(m.itemData); }
                             else { handlePlayMovie(m); }
                         }} 
                         className="min-w-[110px] w-28 cursor-pointer relative group flex-shrink-0 transition-transform hover:scale-105 duration-300">
                      <div className={`aspect-[2/3] rounded-lg overflow-hidden relative shadow-lg ${theme === 'dark' ? 'bg-gray-800' : 'bg-gray-200'}`}>
                        <img src={m.poster} className="w-full h-full object-cover" alt={m.title} />
                        <div className="absolute inset-0 bg-black/40 opacity-0 group-hover:opacity-100 transition-opacity flex items-center justify-center z-10">
                            <Play size={24} className="text-white fill-white"/>
                        </div>
                        {m.lang && !m.isOfflineEp && <div className="absolute top-0 right-0 bg-black/80 text-white text-[10px] font-bold px-2 py-1 rounded-bl-md shadow-sm border-b border-l border-white/10">{m.lang}</div>}
                        {m.isOfflineEp && <div className="absolute top-0 right-0 bg-black/80 text-white text-[10px] font-bold px-2 py-1 rounded-bl-md shadow-sm border-b border-l border-white/10 flex items-center gap-1"><Tv size={8}/> EP</div>}
                        {m.isOfflineMovie && <div className="absolute top-0 right-0 bg-green-600/90 text-white text-[10px] font-bold px-2 py-1 rounded-bl-md shadow-sm">Offline</div>}
                      </div>
                      <h4 className={`mt-2 text-xs font-bold truncate ${styles.subText} group-hover:text-red-500 transition-colors`}>{m.title}</h4>
                    </div>
                  ))}
               </div>
            </div>
           ) : (
               isOffline && currentMovie.isOfflineMode && (
                   <div className="mt-8 p-6 rounded-2xl bg-gradient-to-br from-gray-900 to-black border border-gray-800 text-center">
                       <CloudOff size={48} className="mx-auto mb-4 text-gray-600 opacity-50" />
                       <h3 className="text-lg font-black text-white mb-2">You are currently offline</h3>
                       <p className="text-sm text-gray-400 max-w-xs mx-auto">
                           Go to your <strong className="text-green-500 cursor-pointer" onClick={() => setView('downloads')}>My Downloads</strong> to find other offline movies and series.
                       </p>
                   </div>
               )
           )}
        </div>

        {/* MODALS */}
        {showTrailer && currentMovie.trailerUrl && ( <div className="fixed inset-0 z-[120] bg-black/90 flex items-center justify-center p-4 animate-in fade-in"> <div className="relative w-full max-w-4xl aspect-video bg-black rounded-xl overflow-hidden border border-gray-800 shadow-2xl"> <button onClick={() => setShowTrailer(false)} className="absolute top-4 right-4 bg-black/50 text-white p-2 rounded-full hover:bg-red-600 transition z-10"><X size={24}/></button> <iframe src={getEmbedUrl(currentMovie.trailerUrl, true)} className="w-full h-full" frameBorder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowFullScreen title="Trailer"></iframe> </div> </div> )}
        {showShareModal && (
            <div className="fixed inset-0 z-[130] flex items-center justify-center p-4 bg-black/80 backdrop-blur-sm animate-in zoom-in duration-200">
                <div className="bg-gray-900 w-full max-w-sm rounded-2xl p-6 border border-gray-700 shadow-2xl relative text-center">
                    <button onClick={() => setShowShareModal(false)} className="absolute top-3 right-3 bg-gray-800 text-gray-400 p-1.5 rounded-full hover:bg-red-600 hover:text-white transition">
                        <X size={18} />
                    </button>
                    <h3 className="text-lg font-bold text-white mb-5">Share this Movie</h3>
                    
                    <div className="grid grid-cols-3 gap-4 mb-6">
                        {/* WhatsApp */}
                        <button 
                            onClick={() => window.open(`https://api.whatsapp.com/send?text=Watch this amazing movie on ZiniPlay!%0AMovie: ${encodeURIComponent(currentMovie?.title)}%0A%0ALink: ${encodeURIComponent(window.location.origin + window.location.pathname + '?movie=' + currentMovie?.id)}`, '_blank')}
                            className="flex flex-col items-center gap-2 group"
                        >
                            <div className="bg-green-500 group-hover:bg-green-600 p-3 rounded-full text-white shadow-lg transition transform group-hover:scale-110">
                                <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24"><path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51a12.8 12.8 0 0 0-.57-.01c-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 0 1-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 0 1-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 0 1 2.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0 0 12.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 0 0 5.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 0 0-3.48-8.413z"/></svg>
                            </div>
                            <span className="text-[10px] text-gray-400 group-hover:text-white">WhatsApp</span>
                        </button>

                        {/* Facebook */}
                        <button 
                            onClick={() => window.open(`https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(window.location.origin + window.location.pathname + '?movie=' + currentMovie?.id)}`, '_blank')}
                            className="flex flex-col items-center gap-2 group"
                        >
                            <div className="bg-blue-600 group-hover:bg-blue-700 p-3 rounded-full text-white shadow-lg transition transform group-hover:scale-110">
                                <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24"><path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.469h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.469h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z"/></svg>
                            </div>
                            <span className="text-[10px] text-gray-400 group-hover:text-white">Facebook</span>
                        </button>

                        {/* Telegram */}
                        <button 
                            onClick={() => window.open(`https://t.me/share/url?url=${encodeURIComponent(window.location.origin + window.location.pathname + '?movie=' + currentMovie?.id)}&text=Watch this amazing movie on ZiniPlay!`, '_blank')}
                            className="flex flex-col items-center gap-2 group"
                        >
                            <div className="bg-sky-500 group-hover:bg-sky-600 p-3 rounded-full text-white shadow-lg transition transform group-hover:scale-110">
                                <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24"><path d="M12 0C5.373 0 0 5.373 0 12s5.373 12 12 12 12-5.373 12-12S18.627 0 12 0zm5.894 8.221l-1.97 9.28c-.145.658-.537.818-1.084.508l-3-2.21-1.446 1.394c-.14.18-.357.295-.6.295-.002 0-.003 0-.005 0l.213-3.054 5.56-5.022c.24-.213-.054-.334-.373-.121l-6.869 4.326-2.96-.924c-.64-.203-.658-.64.135-.954l11.566-4.458c.538-.196 1.006.128.832.94z"/></svg>
                            </div>
                            <span className="text-[10px] text-gray-400 group-hover:text-white">Telegram</span>
                        </button>

                        {/* Twitter / X */}
                        <button 
                            onClick={() => window.open(`https://twitter.com/intent/tweet?url=${encodeURIComponent(window.location.origin + window.location.pathname + '?movie=' + currentMovie?.id)}&text=Watch this amazing movie on ZiniPlay!`, '_blank')}
                            className="flex flex-col items-center gap-2 group"
                        >
                            <div className="bg-black border border-gray-600 group-hover:bg-gray-800 p-3 rounded-full text-white shadow-lg transition transform group-hover:scale-110">
                                <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24"><path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z"/></svg>
                            </div>
                            <span className="text-[10px] text-gray-400 group-hover:text-white">X (Twitter)</span>
                        </button>

                        {/* Reddit */}
                        <button 
                            onClick={() => window.open(`https://www.reddit.com/submit?url=${encodeURIComponent(window.location.origin + window.location.pathname + '?movie=' + currentMovie?.id)}&title=Watch ${encodeURIComponent(currentMovie?.title)} on ZiniPlay!`, '_blank')}
                            className="flex flex-col items-center gap-2 group"
                        >
                            <div className="bg-[#FF4500] group-hover:bg-[#ff571a] p-3 rounded-full text-white shadow-lg transition transform group-hover:scale-110">
                                <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24"><path d="M12 0A12 12 0 0 0 0 12a12 12 0 0 0 12 12 12 12 0 0 0 12-12A12 12 0 0 0 12 0zm5.01 4.744c.688 0 1.25.561 1.25 1.249a1.25 1.25 0 0 1-2.498.056l-2.597-.547-.8 3.747c1.824.07 3.48.632 4.674 1.488.308-.309.73-.491 1.207-.491.968 0 1.754.786 1.754 1.754 0 .716-.435 1.333-1.01 1.614a3.111 3.111 0 0 1 .042.52c0 2.694-3.13 4.87-7.004 4.87-3.874 0-7.004-2.176-7.004-4.87 0-.183.015-.366.043-.534A1.748 1.748 0 0 1 4.028 12c0-.968.786-1.754 1.754-1.754.463 0 .898.196 1.207.49 1.207-.883 2.878-1.43 4.744-1.487l.885-4.182a.342.342 0 0 1 .14-.197.35.35 0 0 1 .238-.042l2.906.617a1.214 1.214 0 0 1 1.108-.701zM9.25 12C8.561 12 8 12.562 8 13.25c0 .687.561 1.248 1.25 1.248.687 0 1.248-.561 1.248-1.249 0-.688-.561-1.249-1.248-1.249zm5.5 0c-.687 0-1.248.561-1.248 1.25 0 .687.561 1.248 1.249 1.248.688 0 1.249-.561 1.249-1.249 0-.688-.561-1.249-1.25-1.249zm-2.752 4.698c-1.38 0-2.342-.511-2.39-.536a.345.345 0 0 1-.161-.31.35.35 0 0 1 .238-.313.344.344 0 0 1 .325.048c.03.02 .836.425 1.988.425 1.15 0 1.956-.405 1.987-.425a.343.343 0 0 1 .324-.048.349.349 0 0 1 .239.313.343.343 0 0 1-.162.31c-.048.025-1.011.536-2.388.536z"/></svg>
                            </div>
                            <span className="text-[10px] text-gray-400 group-hover:text-white">Reddit</span>
                        </button>

                        {/* Email */}
                        <button 
                            onClick={() => window.open(`mailto:?subject=Watch this amazing movie on ZiniPlay!&body=Movie: ${encodeURIComponent(currentMovie?.title)}%0A%0ALink: ${encodeURIComponent(window.location.origin + window.location.pathname + '?movie=' + currentMovie?.id)}`, '_blank')}
                            className="flex flex-col items-center gap-2 group"
                        >
                            <div className="bg-red-500 group-hover:bg-red-600 p-3 rounded-full text-white shadow-lg transition transform group-hover:scale-110">
                                <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24"><path d="M20 4H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 4l-8 5-8-5V6l8 5 8-5v2z"/></svg>
                            </div>
                            <span className="text-[10px] text-gray-400 group-hover:text-white">Email</span>
                        </button>
                    </div>

                    <div className="bg-black/50 p-2.5 rounded-lg border border-gray-800 flex items-center justify-between">
                        <span className="text-xs text-gray-400 font-mono truncate pl-1 w-[200px] text-left">
                            {window.location.origin}{window.location.pathname}?movie={currentMovie?.id}
                        </span>
                        <button 
                            onClick={() => {
                                const shareUrl = `${window.location.origin}${window.location.pathname}?movie=${currentMovie?.id}`;
                                const copyText = `Watch this amazing movie on ZiniPlay!\nMovie: ${currentMovie?.title}\n\nLink:\n${shareUrl}`;
                                
                                try {
                                    // মোবাইলের জন্য ১০০% কাজ করা কপি সিস্টেম
                                    const textArea = document.createElement("textarea");
                                    textArea.value = copyText;
                                    document.body.appendChild(textArea);
                                    textArea.select();
                                    document.execCommand('copy');
                                    document.body.removeChild(textArea);
                                    
                                    // প্রফেশনাল কাস্টম পপআপ (Toast Notification)
                                    const toast = document.createElement("div");
                                    toast.innerText = language === 'bn' ? "✅ লিংক কপি করা হয়েছে!" : "✅ Link copied!";
                                    toast.style.cssText = "position: fixed; bottom: 30px; left: 50%; transform: translateX(-50%); background-color: #22c55e; color: white; padding: 12px 24px; border-radius: 50px; font-weight: 600; font-size: 14px; z-index: 10000; box-shadow: 0 4px 12px rgba(0,0,0,0.15); opacity: 0; transition: opacity 0.3s ease-in-out, transform 0.3s ease-in-out; font-family: sans-serif;";
                                    document.body.appendChild(toast);
                                    
                                    // একটু অ্যানিমেশন দিয়ে শো করানো
                                    setTimeout(() => { 
                                        toast.style.opacity = '1'; 
                                        toast.style.transform = 'translateX(-50%) translateY(-10px)'; 
                                    }, 10);
                                    
                                    // আড়াই সেকেন্ড পর হাইড করে ডিলিট করা
                                    setTimeout(() => {
                                        toast.style.opacity = '0';
                                        toast.style.transform = 'translateX(-50%) translateY(0)';
                                        setTimeout(() => document.body.removeChild(toast), 300);
                                    }, 2500);
                                } catch (err) {
                                    console.error("Copy failed", err);
                                    alert("Copy failed! Please try again.");
                                }
                                
                                setShowShareModal(false);
                            }}
                            className="bg-red-600 hover:bg-red-700 text-white px-4 py-1.5 rounded-md text-xs font-bold transition flex items-center gap-1"
                        >
                            Copy
                        </button>
                    </div>
                </div>
            </div>
        )}
        {showReportModal && ( <div className="fixed inset-0 z-[110] flex items-center justify-center p-4 bg-black/80 backdrop-blur-sm animate-in fade-in"> <div className="w-full max-w-sm bg-gray-900 rounded-2xl p-6 border border-gray-700 shadow-2xl"> <h3 className="text-lg font-bold mb-4 flex items-center gap-2 text-red-500"><AlertTriangle size={24}/> {t.reportIssue}</h3> <textarea className="w-full bg-black p-3 rounded border border-gray-600 text-sm mb-4 h-24 outline-none focus:border-red-500 transition-colors text-white" placeholder={t.describeIssue} value={reportIssue} onChange={(e) => setReportIssue(e.target.value)} /> <div className="flex gap-3"> <button onClick={handleReportSubmit} className="flex-1 bg-red-600 py-2 rounded font-bold text-white hover:bg-red-700 transition">{t.submit}</button> <button onClick={() => { setShowReportModal(false); setReportIssue(''); }} className="flex-1 bg-gray-700 py-2 rounded font-bold text-gray-300 hover:bg-gray-600 transition">{t.cancel}</button> </div> </div> </div> )}
      </div>
    );
}
  // স্প্ল্যাশ স্ক্রিন চালু থাকলে অন্য কিছু দেখাবে না
  if (showSplash) {
    return <SplashScreen />;
  }
switch(view) {
    case 'player': return <PlayerView />;
    case 'downloads': return <DownloadsView />;
    default: return (
      <>
        <HomeView />
        {/* USING THE NEW EXTRACTED COMPONENT */}
        <AIComponent 
            isOpen={isAiOpen} 
            onClose={() => setIsAiOpen(false)} 
            messages={aiMessages} 
            input={aiInput} 
            setInput={setAiInput} 
            onSubmit={handleAiSubmit} 
            isLoading={isAiLoading} 
            t={t}
            usageCount={aiUsageCount}
            keyCount={geminiKeys.length} 
            dailyLimit={aiDailyLimit} // Pass the dynamic limit
        />
        <PopupModal />
        <SideMenu />
        <SequentialPromoModal />
        <SmartDownloadModal />
        <SettingsModal />
        <PremiumModal 
            isOpen={showPremiumModal} 
            onClose={() => setShowPremiumModal(false)} 
            user={user} 
            coins={coins} 
            t={t}
            handleGoogleLogin={handleGoogleLogin}
            onPaymentSuccess={() => {
                setShowPremiumModal(false); // প্রিমিয়াম মডাল বন্ধ হবে
                setShowPaymentHistory(true); // পেমেন্ট হিস্ট্রি ওপেন হবে
            }} 
        />
        <HistoryModal />
        <PaymentHistoryModal />
        <Notification />
        <LoginErrorModal />
        <UpdateModal />
       {/* --- 1. SMART DOWNLOAD MODAL (ONLY FOR PC) --- */}
          {showDownloadModal && !isMobile && (
            <div className="fixed inset-0 z-[9999] flex items-center justify-center p-4 bg-black/80 backdrop-blur-sm animate-in fade-in duration-500">
               <div className="relative bg-[#1a1a1a] border border-gray-700 w-full max-w-sm rounded-xl shadow-2xl overflow-hidden">
                  <button 
                    onClick={() => setShowDownloadModal(false)} 
                    className="absolute top-2 right-2 z-10 bg-black/50 hover:bg-red-600 text-white p-1 rounded-full transition-colors"
                  >
                    <X size={20} />
                  </button>
                  <div className="p-6 text-center">
                        <div className="mb-4 flex justify-center"><Download size={48} className="text-red-600"/></div>
                        <h3 className="text-xl font-bold text-white mb-2">Download PC App!</h3>
                        <p className="text-gray-400 text-sm mb-6">For the best streaming experience, install our official PC application.</p>
                        <button 
                         onClick={() => {
  setShowDownloadModal(false);
  handleAppDownload('pc');
}}
                          className="w-full py-3 bg-red-600 hover:bg-red-700 text-white font-bold rounded-lg transition-transform active:scale-95 flex items-center justify-center gap-2"
                        >
                          <Download size={20} /> Download Now
                        </button>
                  </div>
              </div>
            </div>
          )}
          {/* --- 3. STICKY DOWNLOAD BANNER (Mobile Browser Only) --- */}
          {/* --- 3. STICKY DOWNLOAD BANNER (Mobile Browser Only) --- */}
          {isMobile && !isCapacitor && showBottomBanner && isBannerAllowed && (
             (() => {
                const hasMobileLinks = appLinks.some(l => l.type === 'mobile');
                if (!hasMobileLinks) return null;
                const isAdActive = adConfig.homeFooter.mobile.active;

                return (
                   <div 
                     className={`fixed left-0 right-0 z-[4000] px-4 flex justify-center transition-all duration-300 ${
                        isAdActive ? 'bottom-[70px]' : 'bottom-4'
                     }`}
                   >
                      <div
                         onClick={() => handleAppDownload('mobile')}
                         // পরিবর্তন ১: p-2 এর বদলে py-1 px-3 দেওয়া হয়েছে (ব্যানার চিকন করার জন্য)
                         className="w-full max-w-sm bg-gradient-to-r from-emerald-500 to-green-600 rounded-full py-1 px-3 pr-4 shadow-[0_4px_20px_rgba(0,0,0,0.5)] flex items-center justify-between cursor-pointer border-2 border-white/20 relative overflow-hidden group animate-in slide-in-from-bottom-10"
                      >
                         <div className="absolute top-0 left-0 w-full h-full bg-white/10 -skew-x-12 transform -translate-x-full group-hover:translate-x-full transition-transform duration-1000"></div>

                         <div className="flex items-center gap-3 pl-1">
                            <div className="bg-white p-1 rounded-full shadow-md">
                               {/* পরিবর্তন ২: w-8 h-8 বদলে w-6 h-6 করা হয়েছে (লোগো ছোট করার জন্য) */}
                               <img 
  src="https://i.imgur.com/6fubsgM.jpeg" 
  className="w-9 h-9 object-cover rounded-xl scale-125 border-0 outline-none" 
  alt="Zini Play Icon"
/>
                            </div>
                            <div className="text-white leading-tight">
                               <h4 className="font-black text-xs uppercase tracking-wide drop-shadow-md">Get the App</h4>
                               <p className="text-[9px] opacity-90 font-medium text-green-100">Watch & Download Free</p>
                            </div>
                         </div>

                         <div className="bg-white text-green-700 px-3 py-1 rounded-full text-[10px] font-black uppercase tracking-wider shadow-sm flex items-center gap-1 group-active:scale-95 transition-transform">
                            Install <Download size={12} />
                         </div>
                      </div>
                   </div>
                );
             })()
          )}

          {/* --- 2. DYNAMIC FOOTER AD (MOBILE & PC) --- */}
          {/* পরিবর্তন: শুরুতে !isPremium && যোগ করা হয়েছে */}
          {!isPremium && ((isMobile && adConfig.homeFooter.mobile.active) || (!isMobile && adConfig.homeFooter.pc.active)) && (
            <div className="fixed bottom-0 left-0 right-0 z-[5000] bg-black/90 border-t border-white/10 p-1 flex justify-center items-center">
               <div className="relative group w-full max-w-[728px] h-[60px] md:h-[90px] bg-gray-800 flex items-center justify-center overflow-hidden">
                  <span className="absolute top-0 right-0 bg-gray-600 text-[8px] text-white px-1">AD</span>
                  
                  {/* Ad Logic */}
                  {(() => {
                    const settings = isMobile ? adConfig.homeFooter.mobile : adConfig.homeFooter.pc;
                    if (settings.provider === 'custom') {
                      return (
                        <img 
                          src={settings.image} 
                          alt="Ad" 
                          className="w-full h-full object-cover cursor-pointer"
                          onClick={() => window.open(settings.link, '_blank')} 
                        />
                      );
                    } else if (settings.provider === 'adsterra') {
                       return (
                         <div className="w-full h-full flex items-center justify-center text-white text-xs cursor-pointer" onClick={() => window.open(settings.link, '_blank')}>
                            Adsterra Banner (Click to Open)
                         </div>
                       );
                    }
                    return null;
                  })()}

                  <button 
                    onClick={(e) => {
                        e.stopPropagation();
                        e.target.closest('.fixed').style.display = 'none';
                    }}
                    className="absolute -top-2 -right-2 bg-red-600 text-white p-1 rounded-full scale-75 opacity-0 group-hover:opacity-100 transition-opacity"
                  >
                    <X size={16} />
                  </button>
               </div>
            </div>
          )}
      </>
    );
  }
}